export const PrintIcon = ({ className }) => {
  return (
    <svg
      className={`button-icon-image ${className}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10.4C7.84177 10.4 7.6871 10.4469 7.55554 10.5348C7.42398 10.6227 7.32145 10.7477 7.2609 10.8939C7.20035 11.04 7.1845 11.2009 7.21537 11.3561C7.24624 11.5113 7.32243 11.6538 7.43431 11.7657C7.5462 11.8776 7.68874 11.9538 7.84393 11.9846C7.99911 12.0155 8.15997 11.9997 8.30615 11.9391C8.45233 11.8786 8.57727 11.776 8.66518 11.6445C8.75308 11.5129 8.8 11.3582 8.8 11.2C8.8 10.9878 8.71571 10.7843 8.56569 10.6343C8.41566 10.4843 8.21217 10.4 8 10.4ZM17.6 7.2H16.8V4.8C16.8 4.58783 16.7157 4.38434 16.5657 4.23431C16.4157 4.08429 16.2122 4 16 4H8C7.78783 4 7.58434 4.08429 7.43431 4.23431C7.28429 4.38434 7.2 4.58783 7.2 4.8V7.2H6.4C5.76348 7.2 5.15303 7.45286 4.70294 7.90294C4.25286 8.35303 4 8.96348 4 9.6V14.4C4 15.0365 4.25286 15.647 4.70294 16.0971C5.15303 16.5471 5.76348 16.8 6.4 16.8H7.2V19.2C7.2 19.4122 7.28429 19.6157 7.43431 19.7657C7.58434 19.9157 7.78783 20 8 20H16C16.2122 20 16.4157 19.9157 16.5657 19.7657C16.7157 19.6157 16.8 19.4122 16.8 19.2V16.8H17.6C18.2365 16.8 18.847 16.5471 19.2971 16.0971C19.7471 15.647 20 15.0365 20 14.4V9.6C20 8.96348 19.7471 8.35303 19.2971 7.90294C18.847 7.45286 18.2365 7.2 17.6 7.2ZM8.8 5.6H15.2V7.2H8.8V5.6ZM15.2 18.4H8.8V15.2H15.2V18.4ZM18.4 14.4C18.4 14.6122 18.3157 14.8157 18.1657 14.9657C18.0157 15.1157 17.8122 15.2 17.6 15.2H16.8V14.4C16.8 14.1878 16.7157 13.9843 16.5657 13.8343C16.4157 13.6843 16.2122 13.6 16 13.6H8C7.78783 13.6 7.58434 13.6843 7.43431 13.8343C7.28429 13.9843 7.2 14.1878 7.2 14.4V15.2H6.4C6.18783 15.2 5.98434 15.1157 5.83431 14.9657C5.68429 14.8157 5.6 14.6122 5.6 14.4V9.6C5.6 9.38783 5.68429 9.18434 5.83431 9.03431C5.98434 8.88429 6.18783 8.8 6.4 8.8H17.6C17.8122 8.8 18.0157 8.88429 18.1657 9.03431C18.3157 9.18434 18.4 9.38783 18.4 9.6V14.4Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ExportPrintIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6845_10453)">
        <path
          d="M19 6V4C19 2.93913 18.5786 1.92172 17.8284 1.17157C17.0783 0.421427 16.0609 0 15 0L9 0C7.93913 0 6.92172 0.421427 6.17157 1.17157C5.42143 1.92172 5 2.93913 5 4V6C3.67441 6.00159 2.40356 6.52888 1.46622 7.46622C0.528882 8.40356 0.00158786 9.67441 0 11L0 16C0.00158786 17.3256 0.528882 18.5964 1.46622 19.5338C2.40356 20.4711 3.67441 20.9984 5 21C5 21.7956 5.31607 22.5587 5.87868 23.1213C6.44129 23.6839 7.20435 24 8 24H16C16.7956 24 17.5587 23.6839 18.1213 23.1213C18.6839 22.5587 19 21.7956 19 21C20.3256 20.9984 21.5964 20.4711 22.5338 19.5338C23.4711 18.5964 23.9984 17.3256 24 16V11C23.9984 9.67441 23.4711 8.40356 22.5338 7.46622C21.5964 6.52888 20.3256 6.00159 19 6ZM7 4C7 3.46957 7.21071 2.96086 7.58579 2.58579C7.96086 2.21071 8.46957 2 9 2H15C15.5304 2 16.0391 2.21071 16.4142 2.58579C16.7893 2.96086 17 3.46957 17 4V6H7V4ZM17 21C17 21.2652 16.8946 21.5196 16.7071 21.7071C16.5196 21.8946 16.2652 22 16 22H8C7.73478 22 7.48043 21.8946 7.29289 21.7071C7.10536 21.5196 7 21.2652 7 21V17C7 16.7348 7.10536 16.4804 7.29289 16.2929C7.48043 16.1054 7.73478 16 8 16H16C16.2652 16 16.5196 16.1054 16.7071 16.2929C16.8946 16.4804 17 16.7348 17 17V21ZM22 16C22 16.7956 21.6839 17.5587 21.1213 18.1213C20.5587 18.6839 19.7956 19 19 19V17C19 16.2044 18.6839 15.4413 18.1213 14.8787C17.5587 14.3161 16.7956 14 16 14H8C7.20435 14 6.44129 14.3161 5.87868 14.8787C5.31607 15.4413 5 16.2044 5 17V19C4.20435 19 3.44129 18.6839 2.87868 18.1213C2.31607 17.5587 2 16.7956 2 16V11C2 10.2044 2.31607 9.44129 2.87868 8.87868C3.44129 8.31607 4.20435 8 5 8H19C19.7956 8 20.5587 8.31607 21.1213 8.87868C21.6839 9.44129 22 10.2044 22 11V16Z"
          fill="currentColor"
        />
        <path
          d="M18 10H16C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11C15 11.2652 15.1054 11.5196 15.2929 11.7071C15.4804 11.8946 15.7348 12 16 12H18C18.2652 12 18.5196 11.8946 18.7071 11.7071C18.8946 11.5196 19 11.2652 19 11C19 10.7348 18.8946 10.4804 18.7071 10.2929C18.5196 10.1054 18.2652 10 18 10Z"
          fill="#374957"
        />
      </g>
      <defs>
        <clipPath id="clip0_6845_10453">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TickIcon = ({ className }) => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.753 0.246919C15.9112 0.405088 16 0.619582 16 0.843233C16 1.06688 15.9112 1.28138 15.753 1.43955L6.27105 10.9224C6.18489 11.0086 6.0826 11.077 5.97 11.1236C5.85741 11.1703 5.73673 11.1943 5.61485 11.1943C5.49298 11.1943 5.3723 11.1703 5.2597 11.1236C5.14711 11.077 5.04481 11.0086 4.95865 10.9224L0.247177 6.21091C0.168812 6.13255 0.10665 6.03951 0.0642391 5.93713C0.0218285 5.83474 8.25705e-10 5.725 0 5.61417C-8.25705e-10 5.50335 0.0218285 5.39361 0.0642391 5.29122C0.10665 5.18883 0.168812 5.0958 0.247177 5.01744C0.325541 4.93907 0.418573 4.87691 0.520961 4.8345C0.62335 4.79209 0.733089 4.77026 0.843913 4.77026C0.954737 4.77026 1.06448 4.79209 1.16686 4.8345C1.26925 4.87691 1.36229 4.93907 1.44065 5.01744L5.6157 9.19248L14.5596 0.246919C14.7177 0.0887972 14.9322 -3.05176e-05 15.1559 -3.05176e-05C15.3795 -3.05176e-05 15.5949 0.0887972 15.753 0.246919Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LockIcon = ({ className }) => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.3899 6.82344V5.67C14.3899 4.16622 13.7926 2.72404 12.7292 1.6607C11.6659 0.597373 10.2237 0 8.71993 0C7.21616 0 5.77397 0.597373 4.71064 1.6607C3.64731 2.72404 3.04993 4.16622 3.04993 5.67V6.82344C2.32852 7.13829 1.71448 7.65654 1.28292 8.31482C0.851355 8.9731 0.62097 9.74287 0.619934 10.53V15.39C0.62122 16.4637 1.04833 17.4931 1.80757 18.2524C2.56682 19.0116 3.5962 19.4387 4.66993 19.44H12.7699C13.8437 19.4387 14.8731 19.0116 15.6323 18.2524C16.3915 17.4931 16.8186 16.4637 16.8199 15.39V10.53C16.8189 9.74287 16.5885 8.9731 16.1569 8.31482C15.7254 7.65654 15.1114 7.13829 14.3899 6.82344V6.82344ZM4.66993 5.67C4.66993 4.59587 5.09663 3.56574 5.85615 2.80622C6.61567 2.0467 7.64581 1.62 8.71993 1.62C9.79406 1.62 10.8242 2.0467 11.5837 2.80622C12.3432 3.56574 12.7699 4.59587 12.7699 5.67V6.48H4.66993V5.67ZM15.1999 15.39C15.1999 16.0345 14.9439 16.6526 14.4882 17.1083C14.0325 17.564 13.4144 17.82 12.7699 17.82H4.66993C4.02546 17.82 3.40738 17.564 2.95166 17.1083C2.49595 16.6526 2.23993 16.0345 2.23993 15.39V10.53C2.23993 9.88552 2.49595 9.26744 2.95166 8.81173C3.40738 8.35602 4.02546 8.1 4.66993 8.1H12.7699C13.4144 8.1 14.0325 8.35602 14.4882 8.81173C14.9439 9.26744 15.1999 9.88552 15.1999 10.53V15.39Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UnLockIcon = ({ className }) => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.9999 6.66797H3.99999V5.83472C3.99974 4.91097 4.29425 4.01334 4.8372 3.28294C5.38016 2.55254 6.14077 2.03079 6.99945 1.79973C7.85814 1.56867 8.76619 1.64141 9.58085 2.00649C10.3955 2.37157 11.0707 3.0083 11.4999 3.81657C11.551 3.91227 11.6196 3.99656 11.7018 4.06463C11.7842 4.13271 11.8785 4.18324 11.9795 4.21335C12.0806 4.24344 12.1863 4.25252 12.2907 4.24006C12.3951 4.22759 12.4961 4.19384 12.588 4.14071C12.6798 4.08758 12.7608 4.01613 12.8261 3.93043C12.8915 3.84474 12.94 3.74646 12.9689 3.64123C12.9978 3.536 13.0065 3.42587 12.9946 3.31714C12.9826 3.2084 12.9501 3.10318 12.8992 3.00749C12.2978 1.8762 11.3526 0.985118 10.212 0.474329C9.07145 -0.0364593 7.80027 -0.137997 6.59828 0.185676C5.3963 0.509349 4.33165 1.23988 3.57169 2.26244C2.81175 3.28499 2.39959 4.5416 2.4 5.83472V7.02126C1.68749 7.34516 1.08103 7.87828 0.654794 8.55547C0.228563 9.23263 0.00102265 10.0245 0 10.8342V15.8337C0.00127023 16.9383 0.423101 17.9973 1.17297 18.7782C1.92284 19.5593 2.93952 19.9987 3.99999 20H11.9999C13.0605 19.9987 14.0772 19.5593 14.827 18.7782C15.5769 17.9973 15.9987 16.9383 16 15.8337V10.8342C15.9987 9.72967 15.5769 8.67074 14.827 7.8897C14.0772 7.10865 13.0605 6.66928 11.9999 6.66797ZM14.3999 15.8337C14.3999 16.4967 14.1471 17.1325 13.697 17.6013C13.2469 18.0702 12.6365 18.3335 11.9999 18.3335H3.99999C3.36347 18.3335 2.75303 18.0702 2.30294 17.6013C1.85285 17.1325 1.6 16.4967 1.6 15.8337V10.8342C1.6 10.1713 1.85285 9.53543 2.30294 9.06663C2.75303 8.59784 3.36347 8.33448 3.99999 8.33448H11.9999C12.6365 8.33448 13.2469 8.59784 13.697 9.06663C14.1471 9.53543 14.3999 10.1713 14.3999 10.8342V15.8337Z"
        fill="#6B6970"
      />
    </svg>
  );
};

export const UnLinkIcon = ({ className }) => {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M29.6378 27.2217C29.8125 26.0093 29.7244 24.7735 29.3794 23.5981C29.0345 22.4226 28.4408 21.3351 27.6387 20.4092C26.8365 19.4833 25.8446 18.7407 24.7303 18.2318C23.616 17.7228 22.4053 17.4595 21.1804 17.4596L13.9318 17.459C11.6923 17.4977 9.55766 18.4146 7.98777 20.012C6.41789 21.6094 5.53832 23.7596 5.53851 25.9995C5.53871 28.2394 6.41865 30.3897 7.98881 31.9874C9.55897 33.5851 11.6937 34.5023 13.9333 34.5414L18.077 34.5538M22.3891 24.8049C22.2144 26.0173 22.3025 27.2532 22.6474 28.4286C22.9924 29.604 23.5861 30.6916 24.3882 31.6175C25.1904 32.5434 26.1823 33.286 27.2966 33.7949C28.4109 34.3038 29.6216 34.5671 30.8465 34.567L38.0951 34.5676C40.3346 34.5289 42.4692 33.6121 44.0391 32.0147C45.609 30.4173 46.4886 28.2671 46.4884 26.0272C46.4882 23.7873 45.6082 21.6369 44.0381 20.0392C42.4679 18.4415 40.3332 17.5244 38.0936 17.4853L33.9619 17.4849"
        stroke="#6B6970"
        strokeWidth="2.16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 2L26 26L50 50"
        stroke="#6B6970"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const LinkIcon = ({ className, width = "49", height = "49" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M28.612 26.196C28.7868 24.9836 28.6988 23.7479 28.3539 22.5725C28.0091 21.3972 27.4156 20.3097 26.6135 19.3839C25.8115 18.4582 24.8197 17.7157 23.7055 17.2069C22.5913 16.6981 21.3807 16.4349 20.1558 16.4351L12.9077 16.4351C10.6682 16.4741 8.53367 17.391 6.96373 18.9885C5.3938 20.5859 4.51409 22.7361 4.51409 24.9759C4.51409 27.2156 5.3938 29.3658 6.96374 30.9633C8.53368 32.5607 10.6682 33.4777 12.9077 33.5166L17.0512 33.5287M21.3638 23.7799C21.1891 24.9923 21.2771 26.228 21.6219 27.4034C21.9667 28.5787 22.5603 29.6662 23.3623 30.592C24.1643 31.5177 25.1561 32.2602 26.2703 32.769C27.3845 33.2778 28.5951 33.541 29.82 33.5408L37.0682 33.5408C39.3076 33.5018 41.4422 32.5849 43.0121 30.9874C44.582 29.39 45.4617 27.2398 45.4617 25C45.4617 22.7603 44.582 20.6101 43.0121 19.0126C41.4422 17.4152 39.3076 16.4982 37.0682 16.4593L32.9367 16.4593"
        stroke="currentColor"
        strokeWidth="2.16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BlueBoxIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.81818 4H5.45455C5.06878 4 4.69881 4.15325 4.42603 4.42603C4.15325 4.69881 4 5.06878 4 5.45455V9.81818C4 10.204 4.15325 10.5739 4.42603 10.8467C4.69881 11.1195 5.06878 11.2727 5.45455 11.2727H9.81818C10.204 11.2727 10.5739 11.1195 10.8467 10.8467C11.1195 10.5739 11.2727 10.204 11.2727 9.81818V5.45455C11.2727 5.06878 11.1195 4.69881 10.8467 4.42603C10.5739 4.15325 10.204 4 9.81818 4ZM9.81818 9.81818H5.45455V5.45455H9.81818V9.81818ZM9.81818 12.7273H5.45455C5.06878 12.7273 4.69881 12.8805 4.42603 13.1533C4.15325 13.4261 4 13.796 4 14.1818V18.5455C4 18.9312 4.15325 19.3012 4.42603 19.574C4.69881 19.8468 5.06878 20 5.45455 20H9.81818C10.204 20 10.5739 19.8468 10.8467 19.574C11.1195 19.3012 11.2727 18.9312 11.2727 18.5455V14.1818C11.2727 13.796 11.1195 13.4261 10.8467 13.1533C10.5739 12.8805 10.204 12.7273 9.81818 12.7273ZM9.81818 18.5455H5.45455V14.1818H9.81818V18.5455ZM18.5455 4H14.1818C13.796 4 13.4261 4.15325 13.1533 4.42603C12.8805 4.69881 12.7273 5.06878 12.7273 5.45455V9.81818C12.7273 10.204 12.8805 10.5739 13.1533 10.8467C13.4261 11.1195 13.796 11.2727 14.1818 11.2727H18.5455C18.9312 11.2727 19.3012 11.1195 19.574 10.8467C19.8468 10.5739 20 10.204 20 9.81818V5.45455C20 5.06878 19.8468 4.69881 19.574 4.42603C19.3012 4.15325 18.9312 4 18.5455 4ZM18.5455 9.81818H14.1818V5.45455H18.5455V9.81818ZM12.7273 16.3636V13.4545C12.7273 13.2617 12.8039 13.0767 12.9403 12.9403C13.0767 12.8039 13.2617 12.7273 13.4545 12.7273C13.6474 12.7273 13.8324 12.8039 13.9688 12.9403C14.1052 13.0767 14.1818 13.2617 14.1818 13.4545V16.3636C14.1818 16.5565 14.1052 16.7415 13.9688 16.8779C13.8324 17.0143 13.6474 17.0909 13.4545 17.0909C13.2617 17.0909 13.0767 17.0143 12.9403 16.8779C12.8039 16.7415 12.7273 16.5565 12.7273 16.3636ZM20 14.9091C20 15.102 19.9234 15.287 19.787 15.4234C19.6506 15.5597 19.4656 15.6364 19.2727 15.6364H17.0909V19.2727C17.0909 19.4656 17.0143 19.6506 16.8779 19.787C16.7415 19.9234 16.5565 20 16.3636 20H13.4545C13.2617 20 13.0767 19.9234 12.9403 19.787C12.8039 19.6506 12.7273 19.4656 12.7273 19.2727C12.7273 19.0798 12.8039 18.8949 12.9403 18.7585C13.0767 18.6221 13.2617 18.5455 13.4545 18.5455H15.6364V13.4545C15.6364 13.2617 15.713 13.0767 15.8494 12.9403C15.9858 12.8039 16.1708 12.7273 16.3636 12.7273C16.5565 12.7273 16.7415 12.8039 16.8779 12.9403C17.0143 13.0767 17.0909 13.2617 17.0909 13.4545V14.1818H19.2727C19.4656 14.1818 19.6506 14.2584 19.787 14.3948C19.9234 14.5312 20 14.7162 20 14.9091ZM20 17.8182V19.2727C20 19.4656 19.9234 19.6506 19.787 19.787C19.6506 19.9234 19.4656 20 19.2727 20C19.0798 20 18.8949 19.9234 18.7585 19.787C18.6221 19.6506 18.5455 19.4656 18.5455 19.2727V17.8182C18.5455 17.6253 18.6221 17.4403 18.7585 17.3039C18.8949 17.1675 19.0798 17.0909 19.2727 17.0909C19.4656 17.0909 19.6506 17.1675 19.787 17.3039C19.9234 17.4403 20 17.6253 20 17.8182Z"
        fill="#6A18ED"
      />
    </svg>
  );
};
export const TransactionIcon = ({ className }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 6.90914C6.5 6.10581 7.15122 5.45459 7.95455 5.45459H17.4091C18.2124 5.45459 18.8636 6.10581 18.8636 6.90914V18.5455C18.8636 19.3488 18.2124 20 17.4091 20H7.95455C7.15122 20 6.5 19.3488 6.5 18.5455V6.90914ZM17.4091 6.90914H7.95455V18.5455H17.4091V6.90914Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4995 4C10.9011 4 11.2267 4.32561 11.2267 4.72727V6.90909C11.2267 7.31075 10.9011 7.63636 10.4995 7.63636C10.0978 7.63636 9.77219 7.31075 9.77219 6.90909V4.72727C9.77219 4.32561 10.0978 4 10.4995 4ZM14.8631 4C15.2648 4 15.5904 4.32561 15.5904 4.72727V6.90909C15.5904 7.31075 15.2648 7.63636 14.8631 7.63636C14.4614 7.63636 14.1358 7.31075 14.1358 6.90909V4.72727C14.1358 4.32561 14.4614 4 14.8631 4ZM9.04492 10.1818C9.04492 9.78016 9.37053 9.45455 9.77219 9.45455H15.5904C15.992 9.45455 16.3176 9.78016 16.3176 10.1818C16.3176 10.5835 15.992 10.9091 15.5904 10.9091H9.77219C9.37053 10.9091 9.04492 10.5835 9.04492 10.1818ZM9.04492 13.0909C9.04492 12.6892 9.37053 12.3636 9.77219 12.3636H14.1358C14.5375 12.3636 14.8631 12.6892 14.8631 13.0909C14.8631 13.4926 14.5375 13.8182 14.1358 13.8182H9.77219C9.37053 13.8182 9.04492 13.4926 9.04492 13.0909ZM9.04492 16C9.04492 15.5983 9.37053 15.2727 9.77219 15.2727H12.6813C13.0829 15.2727 13.4086 15.5983 13.4086 16C13.4086 16.4017 13.0829 16.7273 12.6813 16.7273H9.77219C9.37053 16.7273 9.04492 16.4017 9.04492 16Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const AddIcon = ({ className }) => {
  return (
    <svg
      className={`button-icon-image ${className}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1111 19.1111C11.1111 19.3469 11.2048 19.573 11.3715 19.7397C11.5382 19.9064 11.7643 20 12 20C12.2357 20 12.4618 19.9064 12.6285 19.7397C12.7952 19.573 12.8889 19.3469 12.8889 19.1111V12.8889H19.1111C19.3469 12.8889 19.573 12.7952 19.7397 12.6285C19.9064 12.4618 20 12.2357 20 12C20 11.7643 19.9064 11.5382 19.7397 11.3715C19.573 11.2048 19.3469 11.1111 19.1111 11.1111H12.8889V4.88889C12.8889 4.65314 12.7952 4.42705 12.6285 4.26035C12.4618 4.09365 12.2357 4 12 4C11.7643 4 11.5382 4.09365 11.3715 4.26035C11.2048 4.42705 11.1111 4.65314 11.1111 4.88889V11.1111H4.88889C4.65314 11.1111 4.42705 11.2048 4.26035 11.3715C4.09365 11.5382 4 11.7643 4 12C4 12.2357 4.09365 12.4618 4.26035 12.6285C4.42705 12.7952 4.65314 12.8889 4.88889 12.8889H11.1111V19.1111Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const TickIconLong = ({ className }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.753 6.74692C19.9112 6.90509 20 7.11958 20 7.34323C20 7.56688 19.9112 7.78138 19.753 7.93955L10.2711 17.4224C10.1849 17.5086 10.0826 17.577 9.97 17.6236C9.85741 17.6703 9.73673 17.6943 9.61485 17.6943C9.49298 17.6943 9.3723 17.6703 9.2597 17.6236C9.14711 17.577 9.04481 17.5086 8.95865 17.4224L4.24718 12.7109C4.16881 12.6325 4.10665 12.5395 4.06424 12.4371C4.02183 12.3347 4 12.225 4 12.1142C4 12.0033 4.02183 11.8936 4.06424 11.7912C4.10665 11.6888 4.16881 11.5958 4.24718 11.5174C4.32554 11.4391 4.41857 11.3769 4.52096 11.3345C4.62335 11.2921 4.73309 11.2703 4.84391 11.2703C4.95474 11.2703 5.06448 11.2921 5.16686 11.3345C5.26925 11.3769 5.36229 11.4391 5.44065 11.5174L9.6157 15.6925L18.5596 6.74692C18.7177 6.5888 18.9322 6.49997 19.1559 6.49997C19.3795 6.49997 19.5949 6.5888 19.753 6.74692Z"
        fill="#6A18ED"
      />
    </svg>
  );
};
export const CancelIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="25"
      className={className}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7346 7.04544C18.8187 6.96147 18.8854 6.86178 18.9309 6.75204C18.9765 6.6423 18.9999 6.52466 19 6.40585C19.0001 6.28704 18.9767 6.16938 18.9313 6.05958C18.8859 5.94978 18.8194 5.85001 18.7354 5.76594C18.6514 5.68188 18.5518 5.61517 18.442 5.56964C18.3323 5.5241 18.2146 5.50063 18.0958 5.50056C17.977 5.50048 17.8594 5.52381 17.7496 5.56921C17.6398 5.61461 17.54 5.68119 17.4559 5.76515L11.9999 11.2213L6.54541 5.76515C6.37564 5.59538 6.14538 5.5 5.90528 5.5C5.66519 5.5 5.43492 5.59538 5.26515 5.76515C5.09538 5.93493 5 6.1652 5 6.4053C5 6.64539 5.09538 6.87566 5.26515 7.04544L10.7212 12.5L5.26515 17.9546C5.18109 18.0386 5.1144 18.1384 5.06891 18.2483C5.02342 18.3581 5 18.4758 5 18.5947C5 18.7136 5.02342 18.8313 5.06891 18.9411C5.1144 19.051 5.18109 19.1508 5.26515 19.2348C5.43492 19.4046 5.66519 19.5 5.90528 19.5C6.02416 19.5 6.14188 19.4766 6.25172 19.4311C6.36155 19.3856 6.46135 19.3189 6.54541 19.2348L11.9999 13.7787L17.4559 19.2348C17.6257 19.4044 17.8559 19.4996 18.0958 19.4994C18.3358 19.4993 18.5658 19.4038 18.7354 19.2341C18.905 19.0643 19.0001 18.8341 19 18.5941C18.9999 18.3542 18.9044 18.1241 18.7346 17.9546L13.2786 12.5L18.7346 7.04544Z"
        fill="#918E95"
      />
    </svg>
  );
};
export const AsendingSortingIcon = ({ className }) => {
  return (
    <svg
      width="14"
      height="14"
      className={className}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4396 13.1298C16.2831 13.2855 16.0711 13.3727 15.8503 13.3722C15.6295 13.3716 15.4179 13.2834 15.2622 13.1269L10.0348 7.87383L4.78175 13.1012C4.70475 13.1805 4.61269 13.2437 4.51099 13.2871C4.40928 13.3305 4.30003 13.3532 4.18942 13.3539C4.07882 13.3546 3.96927 13.3333 3.86708 13.2911C3.76478 13.249 3.67193 13.187 3.59402 13.1086C3.51602 13.0302 3.45434 12.9371 3.4128 12.8347C3.37115 12.7322 3.35032 12.6225 3.35159 12.512C3.35286 12.4014 3.37603 12.2922 3.41998 12.1907C3.46383 12.0892 3.52755 11.9975 3.60724 11.9209L9.45042 6.10629C9.60701 5.95047 9.81892 5.86339 10.0398 5.86394C10.2606 5.86448 10.4721 5.9526 10.6279 6.10918L16.4425 11.9524C16.5982 12.1089 16.6854 12.3209 16.6849 12.5417C16.6843 12.7625 16.5961 12.974 16.4396 13.1298Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DesendingSortingIcon = ({ className }) => {
  return (
    <svg
      width="14"
      height="14"
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5773 6.91047C3.73346 6.75436 3.94522 6.66666 4.16602 6.66666C4.38683 6.66666 4.59859 6.75436 4.75475 6.91047L9.99496 12.1507L15.2352 6.91047C15.312 6.83093 15.4039 6.7675 15.5055 6.72385C15.6071 6.68021 15.7163 6.65724 15.8269 6.65628C15.9375 6.65532 16.0471 6.67639 16.1494 6.71826C16.2518 6.76013 16.3448 6.82196 16.4229 6.90014C16.5011 6.97833 16.563 7.0713 16.6048 7.17364C16.6467 7.27597 16.6678 7.38562 16.6668 7.49619C16.6658 7.60676 16.6429 7.71602 16.5992 7.81762C16.5556 7.91921 16.4921 8.0111 16.4126 8.08791L10.5837 13.9168C10.4275 14.073 10.2158 14.1606 9.99496 14.1606C9.77415 14.1606 9.56239 14.073 9.40624 13.9168L3.5773 8.08791C3.42119 7.93175 3.3335 7.71999 3.3335 7.49919C3.3335 7.27838 3.42119 7.06662 3.5773 6.91047Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DefaultSortingIcon = ({ className }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 21 21"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.062 8.47297C14.9228 8.61141 14.7344 8.6889 14.5381 8.68842C14.3418 8.68794 14.1537 8.60952 14.0153 8.4704L9.36837 3.80063L4.69859 8.44754C4.63014 8.51808 4.54831 8.57427 4.45789 8.61285C4.36748 8.65142 4.27036 8.6716 4.17204 8.67221C4.07371 8.67282 3.97633 8.65385 3.88548 8.61641C3.79454 8.57897 3.71201 8.5238 3.64275 8.45413C3.5734 8.38445 3.51858 8.30167 3.48164 8.2106C3.44462 8.11955 3.4261 8.02203 3.42723 7.92374C3.42836 7.82545 3.44896 7.72837 3.48803 7.63815C3.52701 7.54793 3.58366 7.46638 3.6545 7.39828L8.84886 2.22936C8.98805 2.09084 9.17644 2.01343 9.37275 2.01391C9.56904 2.01439 9.7571 2.09273 9.89557 2.23192L15.0645 7.42628C15.203 7.56544 15.2805 7.75387 15.28 7.95016C15.2795 8.14645 15.2011 8.3345 15.062 8.47297Z"
        fill="currentColor"
      />
      <path
        d="M15.0609 11.5588C14.9224 11.4198 14.7343 11.3414 14.538 11.3409C14.3417 11.3404 14.1533 11.4179 14.0142 11.5562L9.3444 16.2004L4.69748 11.5334C4.62938 11.4625 4.54782 11.406 4.4576 11.367C4.36738 11.328 4.27035 11.3073 4.17204 11.3062C4.07372 11.3051 3.97624 11.3236 3.88521 11.3606C3.79409 11.3976 3.71128 11.4523 3.64169 11.5216C3.572 11.5909 3.51677 11.6733 3.47939 11.7642C3.44192 11.855 3.42292 11.9524 3.42357 12.0506C3.42422 12.1489 3.44434 12.246 3.48296 12.3363C3.5215 12.4267 3.57775 12.5085 3.64825 12.5769L8.81719 17.7682C8.9557 17.9073 9.1437 17.9856 9.34002 17.9861C9.53631 17.9866 9.72475 17.9092 9.8639 17.7708L15.0583 12.6049C15.1974 12.4665 15.2758 12.2785 15.2763 12.0824C15.2768 11.8862 15.1993 11.6979 15.0609 11.5588Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const BendArrowIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 7.57142V12.1428C20 12.2943 19.9398 12.4396 19.8326 12.5468C19.7255 12.654 19.5801 12.7142 19.4286 12.7142C19.277 12.7142 19.1317 12.654 19.0245 12.5468C18.9174 12.4396 18.8572 12.2943 18.8572 12.1428V8.95068L12.9759 14.8327C12.9228 14.8858 12.8598 14.928 12.7904 14.9567C12.721 14.9855 12.6467 15.0003 12.5716 15.0003C12.4965 15.0003 12.4221 14.9855 12.3528 14.9567C12.2834 14.928 12.2204 14.8858 12.1673 14.8327L9.71449 12.3792L4.97601 17.1184C4.86879 17.2256 4.72337 17.2858 4.57173 17.2858C4.4201 17.2858 4.27468 17.2256 4.16746 17.1184C4.06024 17.0111 4 16.8657 4 16.7141C4 16.5625 4.06024 16.417 4.16746 16.3098L9.31021 11.1671C9.36328 11.1139 9.4263 11.0718 9.49567 11.043C9.56504 11.0143 9.6394 10.9995 9.71449 10.9995C9.78958 10.9995 9.86394 11.0143 9.93331 11.043C10.0027 11.0718 10.0657 11.1139 10.1188 11.1671L12.5716 13.6206L18.0493 8.14283H14.8572C14.7057 8.14283 14.5604 8.08263 14.4532 7.97547C14.346 7.86831 14.2858 7.72297 14.2858 7.57142C14.2858 7.41987 14.346 7.27453 14.4532 7.16736C14.5604 7.0602 14.7057 7 14.8572 7H19.4286C19.5801 7 19.7255 7.0602 19.8326 7.16736C19.9398 7.27453 20 7.41987 20 7.57142Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const RightArrowIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.91047 3.5773C6.75436 3.73346 6.66666 3.94522 6.66666 4.16602C6.66666 4.38683 6.75436 4.59859 6.91047 4.75475L12.1507 9.99496L6.91047 15.2352C6.83093 15.312 6.7675 15.4039 6.72385 15.5055C6.68021 15.6071 6.65724 15.7163 6.65628 15.8269C6.65532 15.9375 6.67639 16.0471 6.71826 16.1494C6.76013 16.2518 6.82196 16.3448 6.90014 16.4229C6.97833 16.5011 7.0713 16.563 7.17364 16.6048C7.27597 16.6467 7.38562 16.6678 7.49619 16.6668C7.60676 16.6658 7.71602 16.6429 7.81762 16.5992C7.91921 16.5556 8.0111 16.4921 8.08791 16.4126L13.9168 10.5837C14.073 10.4275 14.1606 10.2158 14.1606 9.99496C14.1606 9.77415 14.073 9.56239 13.9168 9.40624L8.08791 3.5773C7.93175 3.42119 7.71999 3.3335 7.49919 3.3335C7.27838 3.3335 7.06662 3.42119 6.91047 3.5773Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LeftArrowIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2567 3.57661C12.3343 3.65402 12.3959 3.74598 12.4379 3.84722C12.4799 3.94846 12.5015 4.057 12.5015 4.16661C12.5015 4.27622 12.4799 4.38476 12.4379 4.486C12.3959 4.58724 12.3343 4.6792 12.2567 4.75661L7.01169 9.99994L12.2567 15.2433C12.3342 15.3208 12.3956 15.4127 12.4376 15.514C12.4795 15.6152 12.5011 15.7237 12.5011 15.8333C12.5011 15.9429 12.4795 16.0514 12.4376 16.1526C12.3956 16.2538 12.3342 16.3458 12.2567 16.4233C12.1792 16.5008 12.0872 16.5622 11.986 16.6041C11.8848 16.6461 11.7763 16.6677 11.6667 16.6677C11.5571 16.6677 11.4486 16.6461 11.3474 16.6041C11.2462 16.5622 11.1542 16.5008 11.0767 16.4233L5.24336 10.5899C5.16575 10.5125 5.10418 10.4206 5.06217 10.3193C5.02016 10.2181 4.99854 10.1096 4.99854 9.99994C4.99854 9.89033 5.02016 9.7818 5.06217 9.68055C5.10418 9.57931 5.16575 9.48735 5.24336 9.40994L11.0767 3.57661C11.1541 3.499 11.2461 3.43743 11.3473 3.39542C11.4485 3.35341 11.5571 3.33179 11.6667 3.33179C11.7763 3.33179 11.8848 3.35341 11.9861 3.39542C12.0873 3.43743 12.1793 3.499 12.2567 3.57661Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ActionDotsIcons = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8 11.6C16.8 11.1757 16.9686 10.7687 17.2686 10.4686C17.5687 10.1686 17.9757 10 18.4 10C18.8243 10 19.2313 10.1686 19.5314 10.4686C19.8314 10.7687 20 11.1757 20 11.6C20 12.0243 19.8314 12.4313 19.5314 12.7314C19.2313 13.0314 18.8243 13.2 18.4 13.2C17.9757 13.2 17.5687 13.0314 17.2686 12.7314C16.9686 12.4313 16.8 12.0243 16.8 11.6ZM10.4 11.6C10.4 11.1757 10.5686 10.7687 10.8686 10.4686C11.1687 10.1686 11.5757 10 12 10C12.4243 10 12.8313 10.1686 13.1314 10.4686C13.4314 10.7687 13.6 11.1757 13.6 11.6C13.6 12.0243 13.4314 12.4313 13.1314 12.7314C12.8313 13.0314 12.4243 13.2 12 13.2C11.5757 13.2 11.1687 13.0314 10.8686 12.7314C10.5686 12.4313 10.4 12.0243 10.4 11.6ZM4 11.6C4 11.1757 4.16857 10.7687 4.46863 10.4686C4.76869 10.1686 5.17565 10 5.6 10C6.02435 10 6.43131 10.1686 6.73137 10.4686C7.03143 10.7687 7.2 11.1757 7.2 11.6C7.2 12.0243 7.03143 12.4313 6.73137 12.7314C6.43131 13.0314 6.02435 13.2 5.6 13.2C5.17565 13.2 4.76869 13.0314 4.46863 12.7314C4.16857 12.4313 4 12.0243 4 11.6Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EditIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.73994 8.10847C5.21371 7.63469 5.85628 7.36853 6.5263 7.36853H7.3684C7.83348 7.36853 8.2105 7.74555 8.2105 8.21063C8.2105 8.67571 7.83348 9.05273 7.3684 9.05273H6.5263C6.30296 9.05273 6.08877 9.14145 5.93085 9.29938C5.77292 9.4573 5.6842 9.67149 5.6842 9.89483V17.4737C5.6842 17.6971 5.77292 17.9113 5.93085 18.0692C6.08877 18.2271 6.30296 18.3158 6.5263 18.3158H14.1052C14.3285 18.3158 14.5427 18.2271 14.7007 18.0692C14.8586 17.9113 14.9473 17.6971 14.9473 17.4737V16.6316C14.9473 16.1666 15.3243 15.7895 15.7894 15.7895C16.2545 15.7895 16.6315 16.1666 16.6315 16.6316V17.4737C16.6315 18.1438 16.3653 18.7863 15.8916 19.2601C15.4178 19.7339 14.7752 20 14.1052 20H6.5263C5.85628 20 5.21371 19.7339 4.73994 19.2601C4.26616 18.7863 4 18.1438 4 17.4737V9.89483C4 9.22482 4.26616 8.58224 4.73994 8.10847Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5445 4.76397C16.034 4.2748 16.6978 4 17.3898 4C18.0822 4 18.7462 4.27504 19.2358 4.76463C19.7254 5.25421 20.0004 5.91823 20.0004 6.6106C20.0004 7.30265 19.7256 7.96637 19.2365 8.45589C19.2363 8.45612 19.236 8.45635 19.2358 8.45658L18.1719 9.52432C18.1423 9.56798 18.1082 9.60948 18.0695 9.64815C18.0316 9.68608 17.9909 9.71964 17.9482 9.74882L12.1759 15.5418C12.0178 15.7004 11.8032 15.7895 11.5793 15.7895H9.05304C8.58796 15.7895 8.21094 15.4125 8.21094 14.9474V12.4211C8.21094 12.1972 8.30007 11.9826 8.45865 11.8246L14.2516 6.05226C14.2808 6.00952 14.3144 5.96887 14.3523 5.93094C14.391 5.89226 14.4325 5.85814 14.4761 5.82856L15.5439 4.76463C15.5441 4.76441 15.5443 4.76419 15.5445 4.76397ZM14.9572 7.72677L9.89514 12.7708V14.1053H11.2296L16.2737 9.04323L14.9572 7.72677ZM17.4625 7.85019L16.1502 6.53798L16.7348 5.95554C16.9085 5.7818 17.1441 5.6842 17.3898 5.6842C17.6355 5.6842 17.8712 5.7818 18.0449 5.95554C18.2186 6.12927 18.3162 6.3649 18.3162 6.6106C18.3162 6.8563 18.2186 7.09193 18.0449 7.26567L17.4625 7.85019Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DeleteIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 5.6C8 5.17565 8.16857 4.76869 8.46863 4.46863C8.76869 4.16857 9.17565 4 9.6 4H14.4C14.8243 4 15.2313 4.16857 15.5314 4.46863C15.8314 4.76869 16 5.17565 16 5.6V7.2H19.2C19.4122 7.2 19.6157 7.28429 19.7657 7.43431C19.9157 7.58434 20 7.78783 20 8C20 8.21217 19.9157 8.41566 19.7657 8.56569C19.6157 8.71571 19.4122 8.8 19.2 8.8H18.3448L17.6512 18.5136C17.6225 18.9173 17.4418 19.2951 17.1457 19.5709C16.8495 19.8467 16.4599 20 16.0552 20H7.944C7.53931 20 7.14965 19.8467 6.85351 19.5709C6.55736 19.2951 6.37673 18.9173 6.348 18.5136L5.656 8.8H4.8C4.58783 8.8 4.38434 8.71571 4.23431 8.56569C4.08429 8.41566 4 8.21217 4 8C4 7.78783 4.08429 7.58434 4.23431 7.43431C4.38434 7.28429 4.58783 7.2 4.8 7.2H8V5.6ZM9.6 7.2H14.4V5.6H9.6V7.2ZM7.2592 8.8L7.9448 18.4H16.056L16.7416 8.8H7.2592ZM10.4 10.4C10.6122 10.4 10.8157 10.4843 10.9657 10.6343C11.1157 10.7843 11.2 10.9878 11.2 11.2V16C11.2 16.2122 11.1157 16.4157 10.9657 16.5657C10.8157 16.7157 10.6122 16.8 10.4 16.8C10.1878 16.8 9.98434 16.7157 9.83431 16.5657C9.68429 16.4157 9.6 16.2122 9.6 16V11.2C9.6 10.9878 9.68429 10.7843 9.83431 10.6343C9.98434 10.4843 10.1878 10.4 10.4 10.4ZM13.6 10.4C13.8122 10.4 14.0157 10.4843 14.1657 10.6343C14.3157 10.7843 14.4 10.9878 14.4 11.2V16C14.4 16.2122 14.3157 16.4157 14.1657 16.5657C14.0157 16.7157 13.8122 16.8 13.6 16.8C13.3878 16.8 13.1843 16.7157 13.0343 16.5657C12.8843 16.4157 12.8 16.2122 12.8 16V11.2C12.8 10.9878 12.8843 10.7843 13.0343 10.6343C13.1843 10.4843 13.3878 10.4 13.6 10.4Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FulfillIcon = ({ className }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_26_2)">
        <path
          d="M7.16358 4.04466C7.32629 3.88191 7.32629 3.6181 7.16358 3.45538C7.00087 3.29266 6.73704 3.29266 6.57433 3.45538L4.51191 5.51778L3.62804 4.63391C3.46532 4.47116 3.20151 4.47116 3.03879 4.63391C2.87607 4.79662 2.87607 5.06045 3.03879 5.22316L4.18783 6.3722C4.36683 6.5512 4.65704 6.5512 4.83604 6.3722L7.16358 4.04466Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.00004 0.833344C2.69885 0.833344 0.833374 2.69882 0.833374 5.00001C0.833374 7.30118 2.69885 9.16668 5.00004 9.16668C7.30121 9.16668 9.16671 7.30118 9.16671 5.00001C9.16671 2.69882 7.30121 0.833344 5.00004 0.833344ZM1.66671 5.00001C1.66671 3.15906 3.15909 1.66668 5.00004 1.66668C6.841 1.66668 8.33337 3.15906 8.33337 5.00001C8.33337 6.84097 6.841 8.33334 5.00004 8.33334C3.15909 8.33334 1.66671 6.84097 1.66671 5.00001Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_26_2">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EmailIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4634 16.1901L3.25379 16.1901C2.40683 16.1901 1.71724 15.4363 1.71724 14.5093L1.71724 5.78368C1.71724 4.85719 2.40683 4.10285 3.25379 4.10285L17.4634 4.10285C18.3107 4.10285 19 4.85694 19 5.78368L19 14.5093C19 15.4361 18.3107 16.1901 17.4634 16.1901ZM3.25379 5.5943C3.07824 5.5943 2.97034 5.71675 2.97034 5.78343L2.97034 14.5091C2.97034 14.5758 3.07824 14.6982 3.25379 14.6982L17.4634 14.6982C17.639 14.6982 17.7469 14.5758 17.7469 14.5091L17.7469 5.78368C17.7469 5.717 17.639 5.59455 17.4634 5.59455L3.25379 5.5943Z"
        fill="currentColor"
      />
      <path
        d="M18.0553 5.28927L10.3522 9.78254L2.79892 5.29145L1.95609 6.4124L10.3343 11.394L18.8882 6.41677L18.0553 5.28927Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HideIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.4353 11.1962C23.4025 11.1222 22.6084 9.36062 20.8431 7.59531C18.4909 5.24312 15.52 4 12.25 4C8.97999 4 6.00905 5.24312 3.65687 7.59531C1.89155 9.36062 1.09374 11.125 1.06468 11.1962C1.02204 11.2922 1 11.396 1 11.5009C1 11.6059 1.02204 11.7097 1.06468 11.8056C1.09749 11.8797 1.89155 13.6403 3.65687 15.4056C6.00905 17.7569 8.97999 19 12.25 19C15.52 19 18.4909 17.7569 20.8431 15.4056C22.6084 13.6403 23.4025 11.8797 23.4353 11.8056C23.4779 11.7097 23.5 11.6059 23.5 11.5009C23.5 11.396 23.4779 11.2922 23.4353 11.1962ZM12.25 17.5C9.36437 17.5 6.84343 16.4509 4.75655 14.3828C3.90028 13.5313 3.17179 12.5603 2.59374 11.5C3.17164 10.4396 3.90014 9.4686 4.75655 8.61719C6.84343 6.54906 9.36437 5.5 12.25 5.5C15.1356 5.5 17.6566 6.54906 19.7434 8.61719C20.6014 9.4684 21.3315 10.4394 21.9109 11.5C21.235 12.7619 18.2903 17.5 12.25 17.5ZM12.25 7C11.36 7 10.4899 7.26392 9.74993 7.75839C9.0099 8.25285 8.43313 8.95566 8.09253 9.7779C7.75194 10.6002 7.66282 11.505 7.83646 12.3779C8.01009 13.2508 8.43867 14.0526 9.06801 14.682C9.69735 15.3113 10.4992 15.7399 11.3721 15.9135C12.245 16.0872 13.1498 15.9981 13.9721 15.6575C14.7943 15.3169 15.4971 14.7401 15.9916 14.0001C16.4861 13.26 16.75 12.39 16.75 11.5C16.7488 10.3069 16.2742 9.16303 15.4306 8.31939C14.587 7.47575 13.4431 7.00124 12.25 7ZM12.25 14.5C11.6566 14.5 11.0766 14.3241 10.5833 13.9944C10.0899 13.6648 9.70542 13.1962 9.47835 12.6481C9.25129 12.0999 9.19188 11.4967 9.30764 10.9147C9.42339 10.3328 9.70911 9.7982 10.1287 9.37868C10.5482 8.95912 11.0828 8.6734 11.6647 8.55764C12.2467 8.44189 12.8499 8.5013 13.398 8.72836C13.9462 8.95542 14.4148 9.33994 14.7444 9.8333C15.074 10.3266 15.25 10.9067 15.25 11.5C15.25 12.2956 14.9339 13.0587 14.3713 13.6213C13.8087 14.1839 13.0456 14.5 12.25 14.5Z"
        fill="currentColor"
      />
      <path
        d="M22 2L3 21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ShowIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.1853 11.6962C23.1525 11.6222 22.3584 9.86062 20.5931 8.09531C18.2409 5.74312 15.27 4.5 12 4.5C8.72999 4.5 5.75905 5.74312 3.40687 8.09531C1.64155 9.86062 0.843741 11.625 0.814679 11.6962C0.772035 11.7922 0.75 11.896 0.75 12.0009C0.75 12.1059 0.772035 12.2097 0.814679 12.3056C0.847491 12.3797 1.64155 14.1403 3.40687 15.9056C5.75905 18.2569 8.72999 19.5 12 19.5C15.27 19.5 18.2409 18.2569 20.5931 15.9056C22.3584 14.1403 23.1525 12.3797 23.1853 12.3056C23.2279 12.2097 23.25 12.1059 23.25 12.0009C23.25 11.896 23.2279 11.7922 23.1853 11.6962ZM12 18C9.11437 18 6.59343 16.9509 4.50655 14.8828C3.65028 14.0313 2.92179 13.0603 2.34374 12C2.92164 10.9396 3.65014 9.9686 4.50655 9.11719C6.59343 7.04906 9.11437 6 12 6C14.8856 6 17.4066 7.04906 19.4934 9.11719C20.3514 9.9684 21.0815 10.9394 21.6609 12C20.985 13.2619 18.0403 18 12 18ZM12 7.5C11.11 7.5 10.2399 7.76392 9.49993 8.25839C8.7599 8.75285 8.18313 9.45566 7.84253 10.2779C7.50194 11.1002 7.41282 12.005 7.58646 12.8779C7.76009 13.7508 8.18867 14.5526 8.81801 15.182C9.44735 15.8113 10.2492 16.2399 11.1221 16.4135C11.995 16.5872 12.8998 16.4981 13.7221 16.1575C14.5443 15.8169 15.2471 15.2401 15.7416 14.5001C16.2361 13.76 16.5 12.89 16.5 12C16.4988 10.8069 16.0242 9.66303 15.1806 8.81939C14.337 7.97575 13.1931 7.50124 12 7.5ZM12 15C11.4066 15 10.8266 14.8241 10.3333 14.4944C9.83993 14.1648 9.45542 13.6962 9.22835 13.1481C9.00129 12.5999 8.94188 11.9967 9.05764 11.4147C9.17339 10.8328 9.45911 10.2982 9.87867 9.87868C10.2982 9.45912 10.8328 9.1734 11.4147 9.05764C11.9967 8.94189 12.5999 9.0013 13.148 9.22836C13.6962 9.45542 14.1648 9.83994 14.4944 10.3333C14.824 10.8266 15 11.4067 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PasswordIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.0696 10.5002C8.06947 9.11964 6.93455 8.00036 5.53468 8.00023C4.13482 8.0001 3.00012 9.11918 3.00025 10.4998C3.00038 11.8804 4.1353 12.9996 5.53517 12.9998C6.93503 12.9999 8.06973 11.8808 8.0696 10.5002Z"
        stroke="currentColor"
        strokeWidth="0.925816"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0928 10.4997L8.07199 10.4992"
        stroke="currentColor"
        strokeWidth="0.925816"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5531 12.5892L12.5536 10.5013"
        stroke="currentColor"
        strokeWidth="0.925816"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9895 12.2275L13.99 10.499"
        stroke="currentColor"
        strokeWidth="0.925816"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4259 12.5875L15.4264 10.4996"
        stroke="currentColor"
        strokeWidth="0.925816"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.44474 4.54807C9.31829 4.18624 10.2546 4 11.2001 4C12.1456 4 13.0819 4.18624 13.9554 4.54807C14.829 4.90991 15.6227 5.44027 16.2913 6.10886C16.9599 6.77745 17.4903 7.57118 17.8521 8.44474C18.2139 9.31829 18.4002 10.2546 18.4002 11.2001C18.4002 12.1456 18.2139 13.0819 17.8521 13.9554C17.5928 14.5816 17.2468 15.1667 16.8255 15.6941L19.7657 18.6343C20.0781 18.9467 20.0781 19.4533 19.7657 19.7657C19.4533 20.0781 18.9467 20.0781 18.6343 19.7657L15.6941 16.8255C14.4243 17.84 12.8411 18.4002 11.2001 18.4002C9.29051 18.4002 7.45914 17.6416 6.10886 16.2913C4.75858 14.941 4 13.1097 4 11.2001C4 9.29051 4.75858 7.45914 6.10886 6.10886C6.77745 5.44027 7.57118 4.90991 8.44474 4.54807ZM11.2001 5.59998C10.4647 5.59998 9.73646 5.74483 9.05702 6.02627C8.37759 6.3077 7.76024 6.7202 7.24022 7.24022C6.18999 8.29044 5.59998 9.71485 5.59998 11.2001C5.59998 12.6853 6.18999 14.1097 7.24022 15.16C8.29044 16.2102 9.71485 16.8002 11.2001 16.8002C12.6853 16.8002 14.1097 16.2102 15.16 15.16C15.68 14.6399 16.0925 14.0226 16.3739 13.3432C16.6553 12.6637 16.8002 11.9355 16.8002 11.2001C16.8002 10.4647 16.6553 9.73646 16.3739 9.05702C16.0925 8.37759 15.68 7.76024 15.16 7.24022C14.6399 6.7202 14.0226 6.3077 13.3432 6.02627C12.6637 5.74483 11.9355 5.59998 11.2001 5.59998Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const CopyIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.40098 4.60309C7.33255 4.60309 7.26691 4.63027 7.21851 4.67866C7.17017 4.72698 7.14297 4.79252 7.14289 4.86087V6.32754C7.14289 6.67819 6.85862 6.96246 6.50797 6.96246C6.15731 6.96246 5.87305 6.67819 5.87305 6.32754V4.86087C5.87319 4.45573 6.03423 4.06701 6.32076 3.78058C6.60729 3.49416 6.99584 3.33325 7.40098 3.33325H15.1388C15.544 3.33325 15.9326 3.49423 16.2192 3.78077C16.5057 4.06732 16.6667 4.45595 16.6667 4.86119V12.5993C16.6666 13.0044 16.5055 13.3931 16.219 13.6796C15.9325 13.966 15.5439 14.1269 15.1388 14.1269H13.6562C13.3056 14.1269 13.0213 13.8426 13.0213 13.492C13.0213 13.1413 13.3056 12.8571 13.6562 12.8571H15.1388C15.2072 12.8571 15.2728 12.8299 15.3212 12.7815C15.3696 12.7331 15.3968 12.6675 15.3969 12.5991V4.86119C15.3969 4.79274 15.3697 4.72709 15.3213 4.67869C15.2729 4.63029 15.2072 4.60309 15.1388 4.60309H7.40098Z"
        fill="#6A18ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.86022 5.87305L12.5994 5.87305C12.8003 5.87305 12.9987 5.91267 13.1839 5.98941C13.3693 6.06623 13.5378 6.17882 13.6797 6.32076C13.8216 6.4627 13.9341 6.6312 14.0109 6.81664C14.0876 7.00201 14.1271 7.20068 14.127 7.4013C14.127 7.40123 14.127 7.40138 14.127 7.4013V15.1388C14.127 15.5439 13.9661 15.9325 13.6797 16.219C13.3933 16.5055 13.0048 16.6666 12.5996 16.6667H4.86131C4.45608 16.6667 4.06744 16.5057 3.7809 16.2192C3.49435 15.9326 3.33337 15.544 3.33337 15.1388V7.40098C3.33337 6.99594 3.4942 6.60747 3.78051 6.32095C4.06682 6.03444 4.45518 5.87334 4.86022 5.87305ZM4.86098 7.14289C4.79261 7.14298 4.72707 7.17019 4.67874 7.21855C4.63038 7.26694 4.60322 7.33256 4.60322 7.40098V15.1388C4.60322 15.2072 4.63041 15.2729 4.67881 15.3213C4.72721 15.3697 4.79286 15.3969 4.86131 15.3969H12.5992C12.6676 15.3968 12.7332 15.3696 12.7816 15.3212C12.83 15.2728 12.8572 15.2072 12.8572 15.1388V7.4013C12.8572 7.3674 12.8505 7.3336 12.8376 7.30228C12.8246 7.27095 12.8056 7.24249 12.7816 7.21852C12.7577 7.19454 12.7292 7.17552 12.6979 7.16254C12.6663 7.14948 12.6331 7.14289 12.5994 7.14289H4.86098Z"
        fill="#6A18ED"
      />
    </svg>
  );
};

export const SidebarToggleIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#984DF7" />
      <path
        d="M9.52759 6.86204C9.4027 6.98696 9.33255 7.15637 9.33255 7.33301C9.33255 7.50966 9.4027 7.67907 9.52759 7.80399L13.7198 11.9962L9.52759 16.1883C9.46397 16.2498 9.41322 16.3233 9.3783 16.4046C9.34339 16.4858 9.32501 16.5733 9.32424 16.6617C9.32348 16.7502 9.34033 16.8379 9.37383 16.9197C9.40732 17.0016 9.45679 17.076 9.51933 17.1385C9.58188 17.2011 9.65626 17.2506 9.73813 17.2841C9.82 17.3175 9.90772 17.3344 9.99617 17.3336C10.0846 17.3329 10.172 17.3145 10.2533 17.2796C10.3346 17.2447 10.4081 17.1939 10.4695 17.1303L15.1327 12.4671C15.2576 12.3422 15.3277 12.1728 15.3277 11.9962C15.3277 11.8195 15.2576 11.6501 15.1327 11.5252L10.4695 6.86204C10.3446 6.73715 10.1752 6.66699 9.99857 6.66699C9.82193 6.66699 9.65252 6.73715 9.52759 6.86204Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LogoImageReplaceIcon = ({ className }) => {
  return (
    <svg
      width="18"
      height="18"
      className={className}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.56339 3.56364C3.77593 3.35109 4.0642 3.23169 4.36478 3.23169H6.63145C6.93202 3.23169 7.22029 3.35109 7.43283 3.56364C7.64537 3.77618 7.76478 4.06444 7.76478 4.36502V6.63169C7.76478 6.93227 7.64537 7.22054 7.43283 7.43308C7.22029 7.64562 6.93202 7.76502 6.63145 7.76502H4.36478C4.0642 7.76502 3.77593 7.64562 3.56339 7.43308C3.35085 7.22054 3.23145 6.93227 3.23145 6.63169V4.36502C3.23145 4.06444 3.35085 3.77618 3.56339 3.56364ZM6.63145 4.36502H4.36478V6.63169H6.63145V4.36502ZM10.7641 3.39766C10.9854 3.17637 11.3442 3.17637 11.5655 3.39766C11.7868 3.61896 11.7868 3.97775 11.5655 4.19905L10.8328 4.93169H12.8648C13.3156 4.93169 13.748 5.1108 14.0669 5.42961C14.3857 5.74842 14.5648 6.18082 14.5648 6.63169V8.33169C14.5648 8.64465 14.3111 8.89836 13.9981 8.89836C13.6852 8.89836 13.4314 8.64465 13.4314 8.33169V6.63169C13.4314 6.4814 13.3717 6.33727 13.2655 6.231C13.1592 6.12473 13.0151 6.06502 12.8648 6.06502H10.8328L11.5655 6.79766C11.7868 7.01896 11.7868 7.37775 11.5655 7.59905C11.3442 7.82035 10.9854 7.82035 10.7641 7.59905L9.06409 5.89905C8.84279 5.67775 8.84279 5.31896 9.06409 5.09766L10.7641 3.39766ZM3.79811 8.89836C4.11107 8.89836 4.36478 9.15206 4.36478 9.46502V11.165C4.36478 11.3153 4.42448 11.4594 4.53075 11.5657C4.63702 11.672 4.78116 11.7317 4.93145 11.7317H6.96339L6.23075 10.9991C6.00945 10.7778 6.00945 10.419 6.23075 10.1977C6.45205 9.97637 6.81084 9.97637 7.03214 10.1977L8.73214 11.8977C8.95344 12.119 8.95344 12.4778 8.73214 12.6991L7.03214 14.3991C6.81084 14.6203 6.45205 14.6203 6.23075 14.3991C6.00945 14.1778 6.00945 13.819 6.23075 13.5977L6.96339 12.865H4.93145C4.48058 12.865 4.04818 12.6859 3.72936 12.3671C3.41055 12.0483 3.23145 11.6159 3.23145 11.165V9.46502C3.23145 9.15206 3.48515 8.89836 3.79811 8.89836ZM10.3634 10.3636C10.5759 10.1511 10.8642 10.0317 11.1648 10.0317H13.4314C13.732 10.0317 14.0203 10.1511 14.2328 10.3636C14.4454 10.5762 14.5648 10.8644 14.5648 11.165V13.4317C14.5648 13.7323 14.4454 14.0205 14.2328 14.2331C14.0203 14.4456 13.732 14.565 13.4314 14.565H11.1648C10.8642 14.565 10.5759 14.4456 10.3634 14.2331C10.1509 14.0205 10.0314 13.7323 10.0314 13.4317V11.165C10.0314 10.8644 10.1509 10.5762 10.3634 10.3636ZM13.4314 11.165H11.1648V13.4317H13.4314V11.165Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const NotificationIcon = ({ className }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.5011 5.83318C12.6405 5.48855 12.8797 5.1934 13.188 4.98559C13.4962 4.77777 13.8595 4.66675 14.2313 4.66675C14.6031 4.66675 14.9664 4.77777 15.2746 4.98559C15.5829 5.1934 15.8221 5.48855 15.9615 5.83318C17.3415 6.21271 18.5588 7.03477 19.4264 8.17311C20.294 9.31145 20.7639 10.7031 20.7639 12.1344V16.5178L22.4736 19.0823C22.5674 19.2229 22.6213 19.3862 22.6294 19.555C22.6376 19.7237 22.5999 19.8916 22.5202 20.0405C22.4405 20.1895 22.3218 20.314 22.1769 20.4009C22.0319 20.4877 21.8661 20.5335 21.6972 20.5335H17.4649C17.3526 21.311 16.9639 22.022 16.37 22.5362C15.7761 23.0504 15.0168 23.3334 14.2313 23.3334C13.4457 23.3334 12.6865 23.0504 12.0926 22.5362C11.4987 22.022 11.11 21.311 10.9976 20.5335H6.76541C6.59645 20.5335 6.43066 20.4877 6.28571 20.4009C6.14077 20.314 6.02212 20.1895 5.94241 20.0405C5.8627 19.8916 5.82493 19.7237 5.83313 19.555C5.84133 19.3862 5.89518 19.2229 5.98895 19.0823L7.69864 16.5178V12.1344C7.69864 9.12563 9.73309 6.59096 12.5011 5.83318ZM12.9117 20.5335C13.0081 20.8066 13.1868 21.0431 13.4232 21.2104C13.6596 21.3777 13.9421 21.4675 14.2318 21.4675C14.5214 21.4675 14.8039 21.3777 15.0403 21.2104C15.2767 21.0431 15.4554 20.8066 15.5518 20.5335H12.9108H12.9117ZM14.2313 7.46821C12.9937 7.46821 11.8069 7.95982 10.9318 8.8349C10.0567 9.70998 9.56511 10.8968 9.56511 12.1344V16.8006C9.56515 16.9849 9.5106 17.1651 9.40833 17.3185L8.50962 18.667H19.952L19.0533 17.3185C18.9514 17.165 18.8971 16.9848 18.8975 16.8006V12.1344C18.8975 10.8968 18.4059 9.70998 17.5308 8.8349C16.6557 7.95982 15.4688 7.46821 14.2313 7.46821Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const BackArrowIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.7078 4.29208C14.801 4.38497 14.8748 4.49532 14.9253 4.61681C14.9757 4.7383 15.0016 4.86854 15.0016 5.00008C15.0016 5.13161 14.9757 5.26186 14.9253 5.38335C14.8748 5.50484 14.801 5.61519 14.7078 5.70808L8.41383 12.0001L14.7078 18.2921C14.8008 18.3851 14.8746 18.4954 14.9249 18.6169C14.9752 18.7384 15.0011 18.8686 15.0011 19.0001C15.0011 19.1316 14.9752 19.2618 14.9249 19.3832C14.8746 19.5047 14.8008 19.6151 14.7078 19.7081C14.6149 19.8011 14.5045 19.8748 14.383 19.9251C14.2615 19.9754 14.1313 20.0013 13.9998 20.0013C13.8683 20.0013 13.7381 19.9754 13.6167 19.9251C13.4952 19.8748 13.3848 19.8011 13.2918 19.7081L6.29183 12.7081C6.19871 12.6152 6.12482 12.5048 6.07441 12.3833C6.024 12.2619 5.99805 12.1316 5.99805 12.0001C5.99805 11.8685 6.024 11.7383 6.07441 11.6168C6.12482 11.4953 6.19871 11.385 6.29183 11.2921L13.2918 4.29208C13.3847 4.19895 13.4951 4.12507 13.6166 4.07465C13.7381 4.02424 13.8683 3.99829 13.9998 3.99829C14.1314 3.99829 14.2616 4.02424 14.3831 4.07465C14.5046 4.12507 14.6149 4.19895 14.7078 4.29208Z"
        fill="#6B6970"
      />
    </svg>
  );
};

export const TopbarBillingIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.50001 10.5H12C12.2652 10.5 12.5196 10.3947 12.7071 10.2071C12.8947 10.0196 13 9.76522 13 9.50001C13 9.23479 12.8947 8.98044 12.7071 8.7929C12.5196 8.60536 12.2652 8.50001 12 8.50001H11V8.00001C11 7.73479 10.8947 7.48044 10.7071 7.2929C10.5196 7.10536 10.2652 7.00001 10 7.00001C9.73479 7.00001 9.48044 7.10536 9.2929 7.2929C9.10537 7.48044 9.00001 7.73479 9.00001 8.00001V8.55001C8.39243 8.67338 7.85237 9.01811 7.48466 9.51727C7.11696 10.0164 6.94785 10.6344 7.01015 11.2513C7.07246 11.8681 7.36174 12.4398 7.82184 12.8553C8.28194 13.2709 8.88003 13.5006 9.50001 13.5H10.5C10.6326 13.5 10.7598 13.5527 10.8536 13.6465C10.9473 13.7402 11 13.8674 11 14C11 14.1326 10.9473 14.2598 10.8536 14.3536C10.7598 14.4473 10.6326 14.5 10.5 14.5H8.00001C7.73479 14.5 7.48044 14.6054 7.2929 14.7929C7.10537 14.9804 7.00001 15.2348 7.00001 15.5C7.00001 15.7652 7.10537 16.0196 7.2929 16.2071C7.48044 16.3947 7.73479 16.5 8.00001 16.5H9.00001V17C9.00001 17.2652 9.10537 17.5196 9.2929 17.7071C9.48044 17.8947 9.73479 18 10 18C10.2652 18 10.5196 17.8947 10.7071 17.7071C10.8947 17.5196 11 17.2652 11 17V16.45C11.6076 16.3266 12.1476 15.9819 12.5154 15.4827C12.8831 14.9836 13.0522 14.3656 12.9899 13.7488C12.9276 13.1319 12.6383 12.5602 12.1782 12.1447C11.7181 11.7291 11.12 11.4994 10.5 11.5H9.50001C9.3674 11.5 9.24022 11.4473 9.14645 11.3536C9.05269 11.2598 9.00001 11.1326 9.00001 11C9.00001 10.8674 9.05269 10.7402 9.14645 10.6465C9.24022 10.5527 9.3674 10.5 9.50001 10.5ZM21 12H18V3.00001C18.0007 2.8238 17.9548 2.65053 17.867 2.49775C17.7792 2.34498 17.6526 2.21811 17.5 2.13001C17.348 2.04224 17.1755 1.99603 17 1.99603C16.8245 1.99603 16.652 2.04224 16.5 2.13001L13.5 3.85001L10.5 2.13001C10.348 2.04224 10.1755 1.99603 10 1.99603C9.82447 1.99603 9.65203 2.04224 9.50001 2.13001L6.50001 3.85001L3.50001 2.13001C3.34799 2.04224 3.17554 1.99603 3.00001 1.99603C2.82447 1.99603 2.65203 2.04224 2.50001 2.13001C2.3474 2.21811 2.22079 2.34498 2.13299 2.49775C2.04518 2.65053 1.99931 2.8238 2.00001 3.00001V19C2.00001 19.7957 2.31608 20.5587 2.87869 21.1213C3.4413 21.6839 4.20436 22 5.00001 22H19C19.7957 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7957 22 19V13C22 12.7348 21.8947 12.4804 21.7071 12.2929C21.5196 12.1054 21.2652 12 21 12ZM5.00001 20C4.73479 20 4.48044 19.8947 4.2929 19.7071C4.10536 19.5196 4.00001 19.2652 4.00001 19V4.73001L6.00001 5.87001C6.15435 5.95062 6.32589 5.99272 6.50001 5.99272C6.67413 5.99272 6.84567 5.95062 7.00001 5.87001L10 4.15001L13 5.87001C13.1543 5.95062 13.3259 5.99272 13.5 5.99272C13.6741 5.99272 13.8457 5.95062 14 5.87001L16 4.73001V19C16.0027 19.3412 16.0636 19.6793 16.18 20H5.00001ZM20 19C20 19.2652 19.8947 19.5196 19.7071 19.7071C19.5196 19.8947 19.2652 20 19 20C18.7348 20 18.4804 19.8947 18.2929 19.7071C18.1054 19.5196 18 19.2652 18 19V14H20V19Z"
        fill="#918E95"
      />
    </svg>
  );
};

export const TopbarLogoutIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5.69185C4 4.75747 4.75747 4 5.69185 4H11.6133C12.0805 4 12.4592 4.37873 12.4592 4.84592C12.4592 5.31312 12.0805 5.69185 11.6133 5.69185H5.69185V17.5348H11.6133C12.0805 17.5348 12.4592 17.9135 12.4592 18.3807C12.4592 18.8479 12.0805 19.2266 11.6133 19.2266H5.69185C4.75748 19.2266 4 18.4692 4 17.5348V5.69185Z"
        fill="#D61717"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.23047 11.6133C8.23047 11.1461 8.6092 10.7674 9.07639 10.7674H18.8045C19.2717 10.7674 19.6505 11.1461 19.6505 11.6133C19.6505 12.0805 19.2717 12.4592 18.8045 12.4592H9.07639C8.6092 12.4592 8.23047 12.0805 8.23047 11.6133Z"
        fill="#D61717"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2439 8.05441C15.5742 7.72405 16.1098 7.72405 16.4402 8.05441L19.9991 11.6133L16.4402 15.1722C16.1098 15.5026 15.5742 15.5026 15.2439 15.1722C14.9135 14.8418 14.9135 14.3062 15.2439 13.9759L17.6064 11.6133L15.2439 9.25072C14.9135 8.92037 14.9135 8.38476 15.2439 8.05441Z"
        fill="#D61717"
      />
    </svg>
  );
};

export const TopbarPayoutsIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3 6.5V6.5C3 5.11929 4.11929 4 5.5 4L19.2857 4C19.4852 4 19.585 4 19.6651 4.02806C19.8088 4.07831 19.9217 4.19124 19.9719 4.33486C20 4.41505 20 4.51479 20 4.71429V4.71429C20 5.91124 20 6.50972 19.8317 6.99084C19.5301 7.85258 18.8526 8.53011 17.9908 8.83165C17.5097 9 16.9112 9 15.7143 9L15 9M3 6.5V6.5C3 7.88071 4.11929 9 5.5 9L19 9C19.9428 9 20.4142 9 20.7071 9.29289C21 9.58579 21 10.0572 21 11L21 13M3 6.5L3 17C3 18.8856 3 19.8284 3.58579 20.4142C4.17157 21 5.11438 21 7 21L19 21C19.9428 21 20.4142 21 20.7071 20.7071C21 20.4142 21 19.9428 21 19L21 17M21 17H17C16.0572 17 15.5858 17 15.2929 16.7071C15 16.4142 15 15.9428 15 15V15C15 14.0572 15 13.5858 15.2929 13.2929C15.5858 13 16.0572 13 17 13H21M21 17L21 13"
        stroke="#918E95"
        strokeWidth="2"
      />
    </svg>
  );
};

export const TopbarPrinterIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.25 7.3C5.04233 7.3 4.83932 7.34985 4.66665 7.44325C4.49398 7.53665 4.3594 7.6694 4.27993 7.82472C4.20045 7.98004 4.17966 8.15094 4.22018 8.31583C4.26069 8.48071 4.36069 8.63217 4.50754 8.75104C4.65438 8.86992 4.84148 8.95087 5.04516 8.98367C5.24884 9.01647 5.45995 8.99963 5.65182 8.9353C5.84368 8.87096 6.00767 8.76202 6.12304 8.62224C6.23842 8.48245 6.3 8.31811 6.3 8.15C6.3 7.92457 6.18937 7.70837 5.99246 7.54896C5.79555 7.38955 5.52848 7.3 5.25 7.3ZM17.85 3.9H16.8V1.35C16.8 1.12457 16.6894 0.908365 16.4925 0.748959C16.2955 0.589553 16.0285 0.5 15.75 0.5H5.25C4.97152 0.5 4.70445 0.589553 4.50754 0.748959C4.31062 0.908365 4.2 1.12457 4.2 1.35V3.9H3.15C2.31457 3.9 1.51335 4.16866 0.922614 4.64688C0.331874 5.1251 0 5.7737 0 6.45V11.55C0 12.2263 0.331874 12.8749 0.922614 13.3531C1.51335 13.8313 2.31457 14.1 3.15 14.1H4.2V16.65C4.2 16.8754 4.31062 17.0916 4.50754 17.251C4.70445 17.4104 4.97152 17.5 5.25 17.5H15.75C16.0285 17.5 16.2955 17.4104 16.4925 17.251C16.6894 17.0916 16.8 16.8754 16.8 16.65V14.1H17.85C18.6854 14.1 19.4866 13.8313 20.0774 13.3531C20.6681 12.8749 21 12.2263 21 11.55V6.45C21 5.7737 20.6681 5.1251 20.0774 4.64688C19.4866 4.16866 18.6854 3.9 17.85 3.9ZM6.3 2.2H14.7V3.9H6.3V2.2ZM14.7 15.8H6.3V12.4H14.7V15.8ZM18.9 11.55C18.9 11.7754 18.7894 11.9916 18.5925 12.151C18.3955 12.3104 18.1285 12.4 17.85 12.4H16.8V11.55C16.8 11.3246 16.6894 11.1084 16.4925 10.949C16.2955 10.7896 16.0285 10.7 15.75 10.7H5.25C4.97152 10.7 4.70445 10.7896 4.50754 10.949C4.31062 11.1084 4.2 11.3246 4.2 11.55V12.4H3.15C2.87152 12.4 2.60445 12.3104 2.40754 12.151C2.21062 11.9916 2.1 11.7754 2.1 11.55V6.45C2.1 6.22457 2.21062 6.00837 2.40754 5.84896C2.60445 5.68955 2.87152 5.6 3.15 5.6H17.85C18.1285 5.6 18.3955 5.68955 18.5925 5.84896C18.7894 6.00837 18.9 6.22457 18.9 6.45V11.55Z"
        fill="#918E95"
      />
    </svg>
  );
};
export const PrinterIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10.4C7.84177 10.4 7.6871 10.4469 7.55554 10.5348C7.42398 10.6227 7.32145 10.7477 7.2609 10.8939C7.20035 11.04 7.1845 11.2009 7.21537 11.3561C7.24624 11.5113 7.32243 11.6538 7.43431 11.7657C7.5462 11.8776 7.68874 11.9538 7.84393 11.9846C7.99911 12.0155 8.15997 11.9997 8.30615 11.9391C8.45233 11.8786 8.57727 11.776 8.66518 11.6445C8.75308 11.5129 8.8 11.3582 8.8 11.2C8.8 10.9878 8.71571 10.7843 8.56569 10.6343C8.41566 10.4843 8.21217 10.4 8 10.4ZM17.6 7.2H16.8V4.8C16.8 4.58783 16.7157 4.38434 16.5657 4.23431C16.4157 4.08429 16.2122 4 16 4H8C7.78783 4 7.58434 4.08429 7.43431 4.23431C7.28429 4.38434 7.2 4.58783 7.2 4.8V7.2H6.4C5.76348 7.2 5.15303 7.45286 4.70294 7.90294C4.25286 8.35303 4 8.96348 4 9.6V14.4C4 15.0365 4.25286 15.647 4.70294 16.0971C5.15303 16.5471 5.76348 16.8 6.4 16.8H7.2V19.2C7.2 19.4122 7.28429 19.6157 7.43431 19.7657C7.58434 19.9157 7.78783 20 8 20H16C16.2122 20 16.4157 19.9157 16.5657 19.7657C16.7157 19.6157 16.8 19.4122 16.8 19.2V16.8H17.6C18.2365 16.8 18.847 16.5471 19.2971 16.0971C19.7471 15.647 20 15.0365 20 14.4V9.6C20 8.96348 19.7471 8.35303 19.2971 7.90294C18.847 7.45286 18.2365 7.2 17.6 7.2ZM8.8 5.6H15.2V7.2H8.8V5.6ZM15.2 18.4H8.8V15.2H15.2V18.4ZM18.4 14.4C18.4 14.6122 18.3157 14.8157 18.1657 14.9657C18.0157 15.1157 17.8122 15.2 17.6 15.2H16.8V14.4C16.8 14.1878 16.7157 13.9843 16.5657 13.8343C16.4157 13.6843 16.2122 13.6 16 13.6H8C7.78783 13.6 7.58434 13.6843 7.43431 13.8343C7.28429 13.9843 7.2 14.1878 7.2 14.4V15.2H6.4C6.18783 15.2 5.98434 15.1157 5.83431 14.9657C5.68429 14.8157 5.6 14.6122 5.6 14.4V9.6C5.6 9.38783 5.68429 9.18434 5.83431 9.03431C5.98434 8.88429 6.18783 8.8 6.4 8.8H17.6C17.8122 8.8 18.0157 8.88429 18.1657 9.03431C18.3157 9.18434 18.4 9.38783 18.4 9.6V14.4Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TopbarUserInfoIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9 11C10.1046 11 11 10.1046 11 9C11 7.89543 10.1046 7 9 7C7.89543 7 7 7.89543 7 9C7 10.1046 7.89543 11 9 11Z"
        stroke="#918E95"
        strokeWidth="1.5"
      />
      <path
        d="M13 15C13 16.105 13 17 9 17C5 17 5 16.105 5 15C5 13.895 6.79 13 9 13C11.21 13 13 13.895 13 15Z"
        stroke="#918E95"
        strokeWidth="1.5"
      />
      <path
        d="M22 12C22 15.771 22 17.657 20.828 18.828C19.657 20 17.771 20 14 20H10C6.229 20 4.343 20 3.172 18.828C2 17.657 2 15.771 2 12C2 8.229 2 6.343 3.172 5.172C4.343 4 6.229 4 10 4H14C17.771 4 19.657 4 20.828 5.172C21.298 5.642 21.579 6.226 21.748 7M19 12H15M19 9H14M19 15H16"
        stroke="#918E95"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const CheckStatusIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5763 21L11.9943 17.4173L13.0065 16.405L15.5763 18.974L21.0101 13.5394L22.0238 14.5531L15.5763 21Z"
        fill="currentColor"
      />
      <path
        d="M9.12868 11.8129L7.27321 9.95744L6.26309 10.9676L9.12868 13.8331L14.1435 8.81836L13.1333 7.80824L9.12868 11.8129Z"
        fill="currentColor"
      />
      <path
        d="M8.99923 19.1289C7.32922 18.8189 5.78858 18.0208 4.572 16.8355C3.35542 15.6502 2.5175 14.1308 2.16414 12.4695C1.81077 10.8081 1.95781 9.07925 2.58668 7.50142C3.21554 5.92359 4.29801 4.56757 5.6973 3.60474C7.09658 2.64191 8.74987 2.11547 10.4482 2.09195C12.1466 2.06843 13.8139 2.54888 15.2393 3.4726C16.6647 4.39631 17.7843 5.72183 18.4566 7.28165C19.1289 8.84146 19.3238 10.5656 19.0165 12.2361L17.6998 12.0714C17.9574 10.678 17.7961 9.23954 17.2362 7.93787C16.6763 6.63619 15.7431 5.52976 14.5544 4.75847C13.3657 3.98719 11.975 3.58569 10.5582 3.60474C9.14134 3.62379 7.76195 4.06254 6.59445 4.86551C5.42695 5.66848 4.52376 6.79961 3.99908 8.11586C3.47441 9.43212 3.35181 10.8744 3.6468 12.2603C3.94179 13.6463 4.64111 14.9136 5.65633 15.9021C6.67156 16.8906 7.9571 17.5559 9.35041 17.8138L8.99923 19.1289Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const BoxIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.6 7.2H7.2V8C7.2 8.88 7.92 9.6 8.8 9.6H13.6C14.48 9.6 15.2 8.88 15.2 8V7.2H16.8V11.2H18.4V7.2C18.4 6.32 17.68 5.6 16.8 5.6H13.456C13.12 4.672 12.24 4 11.2 4C10.16 4 9.28 4.672 8.944 5.6H5.6C4.72 5.6 4 6.32 4 7.2V18.4C4 19.28 4.72 20 5.6 20H10.4V18.4H5.6V7.2ZM11.2 5.6C11.64 5.6 12 5.96 12 6.4C12 6.84 11.64 7.2 11.2 7.2C10.76 7.2 10.4 6.84 10.4 6.4C10.4 5.96 10.76 5.6 11.2 5.6Z"
        fill="currentColor"
      />
      <path
        d="M18.9999 12.9999C18.6719 12.6719 18.1279 12.6719 17.7999 12.9999L14.0079 16.7999L12.1999 14.9999C11.8719 14.6719 11.3359 14.6719 10.9999 14.9999C10.6719 15.3279 10.6719 15.8719 10.9999 16.1999L13.4399 18.6319C13.7519 18.9439 14.2559 18.9439 14.5679 18.6319L18.9919 14.1999C19.3279 13.8719 19.3279 13.3279 18.9999 12.9999Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ImportCSVIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 9.7826V18.1304C20 18.5917 19.8168 19.034 19.4906 19.3602C19.1645 19.6863 18.7221 19.8696 18.2609 19.8696H5.73913C5.27788 19.8696 4.83553 19.6863 4.50938 19.3602C4.18323 19.034 4 18.5917 4 18.1304V9.7826C4 9.32136 4.18323 8.879 4.50938 8.55285C4.83553 8.2267 5.27788 8.04347 5.73913 8.04347H7.82609C8.10283 8.04347 8.36825 8.15341 8.56394 8.3491C8.75963 8.54479 8.86957 8.8102 8.86957 9.08695C8.86957 9.3637 8.75963 9.62911 8.56394 9.8248C8.36825 10.0205 8.10283 10.1304 7.82609 10.1304H6.08696V17.7826H17.913V10.1304H16.1739C15.8972 10.1304 15.6318 10.0205 15.4361 9.8248C15.2404 9.62911 15.1304 9.3637 15.1304 9.08695C15.1304 8.8102 15.2404 8.54479 15.4361 8.3491C15.6318 8.15341 15.8972 8.04347 16.1739 8.04347H18.2609C18.7221 8.04347 19.1645 8.2267 19.4906 8.55285C19.8168 8.879 20 9.32136 20 9.7826Z"
        fill="currentColor"
      />
      <path
        d="M12.9235 13.3818L14.4236 11.6622L14.4221 11.6595C14.5954 11.4606 14.8306 11.3489 15.0757 11.3489C15.3208 11.3489 15.5559 11.4606 15.7293 11.6595C15.9026 11.8584 16 12.1282 16 12.4095C16 12.5488 15.9761 12.6867 15.9296 12.8154C15.8832 12.944 15.8151 13.0609 15.7293 13.1594L12.6536 16.6886C12.5679 16.7873 12.466 16.8656 12.3538 16.9191C12.2417 16.9725 12.1214 17 12 17C11.8786 17 11.7583 16.9725 11.6462 16.9191C11.534 16.8656 11.4321 16.7873 11.3464 16.6886L8.27072 13.1594C8.18489 13.0609 8.11681 12.944 8.07036 12.8154C8.02391 12.6867 8 12.5488 8 12.4095C8 12.2702 8.02391 12.1323 8.07036 12.0036C8.11681 11.8749 8.18489 11.758 8.27072 11.6595C8.35655 11.5611 8.45845 11.4829 8.57059 11.4296C8.68273 11.3763 8.80293 11.3489 8.92431 11.3489C9.04569 11.3489 9.16588 11.3763 9.27803 11.4296C9.39017 11.4829 9.49206 11.5611 9.57789 11.6595L11.0781 13.3818L11.0781 6.05875C11.0781 5.77795 11.1753 5.50866 11.3483 5.3101C11.5214 5.11155 11.7561 5 12.0008 5C12.2455 5 12.4802 5.11155 12.6532 5.3101C12.8263 5.50866 12.9235 5.77795 12.9235 6.05875L12.9235 13.3818Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ExportCSVIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6294 11.4077V18.5185C18.6294 18.9114 18.4734 19.2882 18.1955 19.5661C17.9177 19.8439 17.5409 19.9999 17.148 19.9999H6.48181C6.0889 19.9999 5.7121 19.8439 5.43428 19.5661C5.15647 19.2882 5.00038 18.9114 5.00038 18.5185V11.4077C5.00038 11.0148 5.15647 10.638 5.43428 10.3602C5.7121 10.0824 6.0889 9.92632 6.48181 9.92632H8.2595C8.49524 9.92632 8.72132 10.02 8.88801 10.1867C9.0547 10.3534 9.14835 10.5794 9.14835 10.8152C9.14835 11.0509 9.0547 11.277 8.88801 11.4437C8.72132 11.6104 8.49524 11.704 8.2595 11.704H6.77809V18.2222H16.8517V11.704H15.3703C15.1345 11.704 14.9084 11.6104 14.7418 11.4437C14.5751 11.277 14.4815 11.0509 14.4815 10.8152C14.4815 10.5794 14.5751 10.3534 14.7418 10.1867C14.9084 10.02 15.1345 9.92632 15.3703 9.92632H17.148C17.5409 9.92632 17.9177 10.0824 18.1955 10.3602C18.4734 10.638 18.6294 11.0148 18.6294 11.4077ZM9.48093 8.4812L10.9261 7.03756V13.1855C10.9261 13.4212 11.0197 13.6472 11.1864 13.8139C11.3531 13.9806 11.5792 14.0743 11.8149 14.0743C12.0506 14.0743 12.2767 13.9806 12.4434 13.8139C12.6101 13.6472 12.7038 13.4212 12.7038 13.1855V7.03756L14.1488 8.48342C14.2315 8.5661 14.3297 8.63169 14.4378 8.67643C14.5458 8.72117 14.6616 8.74421 14.7785 8.74421C14.8954 8.74421 15.0112 8.72117 15.1192 8.67643C15.2273 8.63169 15.3254 8.5661 15.4081 8.48342C15.4908 8.40074 15.5563 8.30258 15.6011 8.19455C15.6458 8.08653 15.6689 7.97074 15.6689 7.85381C15.6689 7.73689 15.6458 7.62111 15.6011 7.51307C15.5563 7.40505 15.4908 7.30689 15.4081 7.22421L12.4452 4.26139C12.3626 4.17851 12.2646 4.11277 12.1565 4.06791C12.0485 4.02304 11.9326 3.99995 11.8156 3.99995C11.6987 3.99995 11.5828 4.02304 11.4748 4.06791C11.3667 4.11277 11.2686 4.17851 11.186 4.26139L8.22321 7.22421C8.14053 7.30689 8.07494 7.40505 8.03019 7.51307C7.98544 7.62111 7.96241 7.73689 7.96241 7.85381C7.96241 8.08996 8.05623 8.31644 8.22321 8.48342C8.39019 8.6504 8.61667 8.74421 8.85281 8.74421C9.08895 8.74421 9.31543 8.6504 9.48241 8.48342L9.48093 8.4812Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CategoryIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5783 6.10381L13.5218 9.27551H9.62963L11.5783 6.10381ZM7.73068 9.50085L10.8633 4.40221C10.9378 4.27947 11.0428 4.17796 11.1682 4.10749C11.2936 4.03703 11.4351 4 11.5791 4C11.7231 4 11.8646 4.03703 11.99 4.10749C12.1154 4.17796 12.2204 4.27947 12.2949 4.40221L15.4191 9.50085C15.7644 10.0543 15.3602 10.7755 14.7033 10.7755H8.44647C7.78963 10.7755 7.38542 10.0543 7.73068 9.50085Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2104 18.5C17.4807 18.5 18.4998 17.4761 18.4998 16.2263C18.4998 14.9765 17.4807 13.9526 16.2104 13.9526C14.94 13.9526 13.9209 14.9765 13.9209 16.2263C13.9209 17.4761 14.94 18.5 16.2104 18.5ZM19.9998 16.2263C19.9998 18.3104 18.3032 20 16.2104 20C14.1175 20 12.4209 18.3104 12.4209 16.2263C12.4209 14.1422 14.1175 12.4526 16.2104 12.4526C18.3032 12.4526 19.9998 14.1422 19.9998 16.2263Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.23684 18.0808H5.5V14.3721H9.23684V18.0808ZM9.89474 19.5808H4.84211C4.37895 19.5808 4 19.2034 4 18.7422V13.7107C4 13.2494 4.37895 12.8721 4.84211 12.8721H9.89474C10.3579 12.8721 10.7368 13.2494 10.7368 13.7107V18.7422C10.7368 19.2034 10.3579 19.5808 9.89474 19.5808Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const DateIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.25 4C9.44891 4 9.63968 4.07902 9.78033 4.21967C9.92098 4.36032 10 4.55109 10 4.75V6H15V4.75C15 4.55109 15.079 4.36032 15.2197 4.21967C15.3603 4.07902 15.5511 4 15.75 4C15.9489 4 16.1397 4.07902 16.2803 4.21967C16.421 4.36032 16.5 4.55109 16.5 4.75V6H17.75C18.716 6 19.5 6.784 19.5 7.75V18.25C19.5 18.7141 19.3156 19.1592 18.9874 19.4874C18.6592 19.8156 18.2141 20 17.75 20H7.25C6.78587 20 6.34075 19.8156 6.01256 19.4874C5.68437 19.1592 5.5 18.7141 5.5 18.25V7.75C5.5 6.784 6.284 6 7.25 6H8.5V4.75C8.5 4.55109 8.57902 4.36032 8.71967 4.21967C8.86032 4.07902 9.05109 4 9.25 4ZM7 11.5V18.25C7 18.388 7.112 18.5 7.25 18.5H17.75C17.8163 18.5 17.8799 18.4737 17.9268 18.4268C17.9737 18.3799 18 18.3163 18 18.25V11.5H7ZM17.75 7.5H7.25C7.1837 7.5 7.12011 7.52634 7.07322 7.57322C7.02634 7.62011 7 7.6837 7 7.75V10H18V7.75C18 7.6837 17.9737 7.62011 17.9268 7.57322C17.8799 7.52634 17.8163 7.5 17.75 7.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const PercentageIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="red"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fill="currentColor"
          d="M17.5 21a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-11-9a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm12.571-4.485l1.414 1.414L4.93 20.485l-1.414-1.414L19.07 3.515z"
        />
      </g>
    </svg>
  );
};

export const ClockIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 12C3 7.02931 7.02931 3 12 3C16.9707 3 21 7.02931 21 12C21 16.9707 16.9707 21 12 21C7.02931 21 3 16.9707 3 12ZM12 4.63636C7.93305 4.63636 4.63636 7.93305 4.63636 12C4.63636 16.0669 7.93305 19.3636 12 19.3636C16.0669 19.3636 19.3636 16.0669 19.3636 12C19.3636 7.93305 16.0669 4.63636 12 4.63636Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0037 6.27271C12.4556 6.27271 12.8219 6.63902 12.8219 7.09089V11.6652L16.051 14.8947C16.3705 15.2142 16.3705 15.7322 16.0509 16.0517C15.7314 16.3712 15.2133 16.3712 14.8938 16.0517L11.4252 12.5826C11.2717 12.4291 11.1855 12.221 11.1855 12.0041V7.09089C11.1855 6.63902 11.5519 6.27271 12.0037 6.27271Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const InventoryConditionTypeIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.77778 6.6H7.55555V7.5C7.55555 8.49 8.35555 9.3 9.33333 9.3H14.6667C15.6444 9.3 16.4444 8.49 16.4444 7.5V6.6H18.2222V11.1H20V6.6C20 5.61 19.2 4.8 18.2222 4.8H14.5067C14.1333 3.756 13.1556 3 12 3C10.8444 3 9.86666 3.756 9.49333 4.8H5.77778C4.8 4.8 4 5.61 4 6.6V19.2C4 20.19 4.8 21 5.77778 21H11.1111V19.2H5.77778V6.6ZM12 4.8C12.4889 4.8 12.8889 5.205 12.8889 5.7C12.8889 6.195 12.4889 6.6 12 6.6C11.5111 6.6 11.1111 6.195 11.1111 5.7C11.1111 5.205 11.5111 4.8 12 4.8Z"
        fill="currentColor"
      />
      <path
        d="M20.7114 13.2817C20.3252 12.9061 19.6845 12.9061 19.2982 13.2817L14.8323 17.6338L12.703 15.5723C12.3167 15.1967 11.6854 15.1967 11.2897 15.5723C10.9034 15.948 10.9034 16.571 11.2897 16.9467L14.1633 19.732C14.5308 20.0893 15.1244 20.0893 15.4918 19.732L20.702 14.6561C21.0977 14.2804 21.0977 13.6574 20.7114 13.2817Z"
        fill="currentColor"
      />{" "}
    </svg>
  );
};
export const StepUpNumberIcon = ({ className }) => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.861359 6.47581C0.986476 6.60089 1.15615 6.67115 1.33306 6.67115C1.50998 6.67115 1.67965 6.60089 1.80476 6.47581L6.00338 2.2772L10.202 6.47581C10.3278 6.59734 10.4964 6.66459 10.6713 6.66307C10.8462 6.66155 11.0136 6.59139 11.1373 6.46768C11.261 6.34398 11.3311 6.17664 11.3327 6.00171C11.3342 5.82677 11.2669 5.65824 11.1454 5.53241L6.47508 0.862092C6.34996 0.737013 6.18029 0.666748 6.00338 0.666748C5.82646 0.666748 5.65679 0.737013 5.53167 0.862092L0.861359 5.53241C0.736281 5.65752 0.666016 5.8272 0.666016 6.00411C0.666016 6.18102 0.736281 6.3507 0.861359 6.47581Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const StepDownNumberIcon = ({ className }) => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.861059 0.528567C0.985984 0.403681 1.15539 0.333524 1.33204 0.333524C1.50868 0.333524 1.67809 0.403681 1.80301 0.528567L5.99518 4.72074L10.1874 0.528567C10.2488 0.464942 10.3223 0.414192 10.4036 0.379279C10.4849 0.344366 10.5723 0.325989 10.6607 0.32522C10.7492 0.324452 10.8369 0.341307 10.9188 0.374802C11.0006 0.408298 11.075 0.457762 11.1376 0.52031C11.2001 0.582858 11.2496 0.657237 11.2831 0.739106C11.3166 0.820975 11.3334 0.908695 11.3327 0.997148C11.3319 1.0856 11.3135 1.17301 11.2786 1.25429C11.2437 1.33556 11.1929 1.40907 11.1293 1.47052L6.46616 6.13367C6.34124 6.25856 6.17183 6.32871 5.99518 6.32871C5.81854 6.32871 5.64913 6.25856 5.52421 6.13367L0.861059 1.47052C0.736173 1.3456 0.666016 1.17619 0.666016 0.999545C0.666016 0.822902 0.736173 0.653492 0.861059 0.528567Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DollarIcon = ({ className }) => {
  return (
    <svg
      width="16"
      height="26"
      viewBox="0 0 16 26"
      fill="none"
      className={`dollar-icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.11821 25.5469V0.0780018H8.74981V25.5469H7.11821ZM12.6099 7.71867C12.4906 6.71053 12.0064 5.92789 11.1574 5.37076C10.3085 4.81362 9.26714 4.53506 8.0335 4.53506C7.13147 4.53506 6.3422 4.68097 5.66568 4.9728C4.9958 5.26463 4.47183 5.6659 4.09378 6.17661C3.72236 6.68731 3.53665 7.26766 3.53665 7.91764C3.53665 8.46151 3.66598 8.9291 3.92465 9.32042C4.18995 9.70511 4.52821 10.0268 4.93942 10.2855C5.35064 10.5375 5.78175 10.7464 6.23277 10.9122C6.68378 11.0714 7.09831 11.2007 7.47636 11.3002L9.54571 11.8574C10.0763 11.9966 10.6666 12.189 11.3166 12.4344C11.9732 12.6798 12.6 13.0147 13.1969 13.4392C13.8005 13.8571 14.2979 14.3943 14.6892 15.0509C15.0806 15.7075 15.2762 16.5134 15.2762 17.4685C15.2762 18.5695 14.9877 19.5644 14.4107 20.4531C13.8403 21.3419 13.0046 22.0482 11.9036 22.5722C10.8092 23.0962 9.47939 23.3582 7.91411 23.3582C6.45496 23.3582 5.19146 23.1227 4.12362 22.6518C3.06242 22.1809 2.22672 21.5243 1.61653 20.6819C1.01297 19.8396 0.671396 18.8613 0.591805 17.747H3.13869C3.20502 18.5164 3.46369 19.1531 3.9147 19.6572C4.37234 20.1546 4.94937 20.5261 5.64579 20.7715C6.34883 21.0102 7.10494 21.1296 7.91411 21.1296C8.85593 21.1296 9.70157 20.9771 10.4511 20.672C11.2005 20.3603 11.7941 19.9291 12.2319 19.3786C12.6696 18.8215 12.8885 18.1715 12.8885 17.4287C12.8885 16.7522 12.6995 16.2017 12.3214 15.7772C11.9434 15.3527 11.4459 15.0078 10.8291 14.7425C10.2123 14.4772 9.54571 14.2451 8.8294 14.0461L6.32231 13.3298C4.7305 12.8721 3.47032 12.2188 2.54177 11.3699C1.61321 10.5209 1.14894 9.40996 1.14894 8.03703C1.14894 6.89624 1.45735 5.90136 2.07417 5.05239C2.69763 4.1968 3.53333 3.53355 4.58127 3.06264C5.63584 2.5851 6.81311 2.34633 8.11309 2.34633C9.42632 2.34633 10.5936 2.58178 11.6151 3.05269C12.6365 3.51696 13.4456 4.15369 14.0426 4.96285C14.6461 5.77202 14.9645 6.69063 14.9976 7.71867H12.6099Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const CloseIcon = ({ className }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6906 4.36371C12.7466 4.30774 12.7911 4.24127 12.8215 4.16811C12.8518 4.09495 12.8675 4.01653 12.8675 3.93732C12.8676 3.85811 12.852 3.77967 12.8217 3.70647C12.7915 3.63328 12.7471 3.56676 12.6911 3.51071C12.6351 3.45467 12.5687 3.4102 12.4955 3.37985C12.4224 3.34949 12.3439 3.33384 12.2647 3.33379C12.1855 3.33374 12.1071 3.34929 12.0339 3.37956C11.9607 3.40983 11.8942 3.45422 11.8381 3.51019L8.20077 7.14761L4.56445 3.51019C4.45127 3.39701 4.29776 3.33342 4.1377 3.33342C3.97764 3.33342 3.82413 3.39701 3.71095 3.51019C3.59776 3.62337 3.53418 3.77688 3.53418 3.93695C3.53418 4.09702 3.59776 4.25053 3.71095 4.36371L7.34831 8.00009L3.71095 11.6365C3.6549 11.6925 3.61045 11.759 3.58012 11.8323C3.54979 11.9055 3.53418 11.984 3.53418 12.0632C3.53418 12.1425 3.54979 12.221 3.58012 12.2942C3.61045 12.3674 3.6549 12.4339 3.71095 12.49C3.82413 12.6032 3.97764 12.6668 4.1377 12.6668C4.21696 12.6668 4.29543 12.6511 4.36866 12.6208C4.44188 12.5905 4.50841 12.546 4.56445 12.49L8.20077 8.85256L11.8381 12.49C11.9513 12.603 12.1048 12.6665 12.2647 12.6664C12.4247 12.6663 12.5781 12.6026 12.6911 12.4895C12.8042 12.3763 12.8676 12.2228 12.8675 12.0629C12.8674 11.9029 12.8038 11.7495 12.6906 11.6365L9.05323 8.00009L12.6906 4.36371Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const WalletIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6.5V6.5C3 5.11929 4.11929 4 5.5 4L19.2857 4C19.4852 4 19.585 4 19.6651 4.02806C19.8088 4.07831 19.9217 4.19124 19.9719 4.33486C20 4.41505 20 4.51479 20 4.71429V4.71429C20 5.91124 20 6.50972 19.8317 6.99084C19.5301 7.85258 18.8526 8.53011 17.9908 8.83165C17.5097 9 16.9112 9 15.7143 9L15 9M3 6.5V6.5C3 7.88071 4.11929 9 5.5 9L19 9C19.9428 9 20.4142 9 20.7071 9.29289C21 9.58579 21 10.0572 21 11L21 13M3 6.5L3 17C3 18.8856 3 19.8284 3.58579 20.4142C4.17157 21 5.11438 21 7 21L19 21C19.9428 21 20.4142 21 20.7071 20.7071C21 20.4142 21 19.9428 21 19L21 17M21 17H17C16.0572 17 15.5858 17 15.2929 16.7071C15 16.4142 15 15.9428 15 15V15C15 14.0572 15 13.5858 15.2929 13.2929C15.5858 13 16.0572 13 17 13H21M21 17L21 13"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export const TrendIcon = ({ className }) => {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.3346 9.33334V14.6666C23.3346 14.8434 23.2644 15.0129 23.1394 15.138C23.0144 15.263 22.8448 15.3332 22.668 15.3332C22.4912 15.3332 22.3216 15.263 22.1966 15.138C22.0716 15.0129 22.0013 14.8434 22.0013 14.6666V10.9425L15.1398 17.8048C15.0779 17.8668 15.0044 17.916 14.9234 17.9495C14.8425 17.9831 14.7557 18.0004 14.6681 18.0004C14.5805 18.0004 14.4938 17.9831 14.4129 17.9495C14.3319 17.916 14.2584 17.8668 14.1965 17.8048L11.3349 14.9424L5.80665 20.4715C5.68156 20.5965 5.5119 20.6668 5.33499 20.6668C5.15809 20.6668 4.98843 20.5965 4.86334 20.4715C4.73824 20.3464 4.66797 20.1767 4.66797 19.9998C4.66797 19.8229 4.73824 19.6532 4.86334 19.5281L10.8632 13.5283C10.9251 13.4663 10.9987 13.4171 11.0796 13.3836C11.1605 13.35 11.2473 13.3327 11.3349 13.3327C11.4225 13.3327 11.5092 13.35 11.5902 13.3836C11.6711 13.4171 11.7446 13.4663 11.8065 13.5283L14.6681 16.3907L21.0588 9.99999H17.3348C17.1579 9.99999 16.9884 9.92976 16.8634 9.80474C16.7383 9.67971 16.6681 9.51015 16.6681 9.33334C16.6681 9.15653 16.7383 8.98697 16.8634 8.86195C16.9884 8.73692 17.1579 8.66669 17.3348 8.66669H22.668C22.8448 8.66669 23.0144 8.73692 23.1394 8.86195C23.2644 8.98697 23.3346 9.15653 23.3346 9.33334Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DashboardDollarIcon = ({ className }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_31_5312)">
        <path
          d="M16.9591 8.70833C17.3238 8.70833 17.6735 8.56347 17.9314 8.30561C18.1892 8.04774 18.3341 7.69801 18.3341 7.33333V6.70358C18.3324 5.41243 17.8187 4.17465 16.9058 3.26167C15.9928 2.34869 14.755 1.83503 13.4638 1.83333H12.3758V1.375C12.3758 1.01033 12.2309 0.660591 11.973 0.402728C11.7152 0.144866 11.3654 0 11.0008 0C10.6361 0 10.2864 0.144866 10.0285 0.402728C9.77063 0.660591 9.62576 1.01033 9.62576 1.375V1.83333H8.53768C7.36845 1.83159 6.23762 2.25055 5.35176 3.01367C4.4659 3.77678 3.88414 4.83313 3.71277 5.98973C3.54139 7.14633 3.79183 8.32599 4.41834 9.3132C5.04484 10.3004 6.0056 11.0293 7.12509 11.3667L9.62576 12.0505V17.4167H8.53768C7.97557 17.4159 7.4367 17.1923 7.03924 16.7949C6.64177 16.3974 6.41815 15.8585 6.41743 15.2964V14.6667C6.41743 14.302 6.27256 13.9523 6.0147 13.6944C5.75684 13.4365 5.4071 13.2917 5.04243 13.2917C4.67775 13.2917 4.32802 13.4365 4.07015 13.6944C3.81229 13.9523 3.66743 14.302 3.66743 14.6667V15.2964C3.66912 16.5876 4.18278 17.8253 5.09576 18.7383C6.00875 19.6513 7.24653 20.165 8.53768 20.1667H9.62576V20.625C9.62576 20.9897 9.77063 21.3394 10.0285 21.5973C10.2864 21.8551 10.6361 22 11.0008 22C11.3654 22 11.7152 21.8551 11.973 21.5973C12.2309 21.3394 12.3758 20.9897 12.3758 20.625V20.1667H13.4638C14.6331 20.1684 15.7639 19.7495 16.6498 18.9863C17.5356 18.2232 18.1174 17.1669 18.2888 16.0103C18.4601 14.8537 18.2097 13.674 17.5832 12.6868C16.9567 11.6996 15.9959 10.9707 14.8764 10.6333L12.3758 9.95133V4.58333H13.4638C14.0259 4.58406 14.5648 4.80768 14.9623 5.20514C15.3597 5.60261 15.5834 6.14148 15.5841 6.70358V7.33333C15.5841 7.69801 15.729 8.04774 15.9868 8.30561C16.2447 8.56347 16.5944 8.70833 16.9591 8.70833ZM14.1009 13.2724C14.5845 13.4248 14.9975 13.7454 15.2651 14.1761C15.5327 14.6067 15.6371 15.119 15.5596 15.6201C15.482 16.1211 15.2275 16.5778 14.8422 16.9074C14.4569 17.237 13.9663 17.4177 13.4593 17.4167H12.3758V12.8013L14.1009 13.2724ZM9.62576 9.19875L7.90059 8.72758C7.41739 8.5753 7.00464 8.2551 6.73704 7.82491C6.46943 7.39472 6.36463 6.88296 6.44161 6.38221C6.51859 5.88145 6.77226 5.42479 7.15672 5.09484C7.54118 4.76489 8.03104 4.58345 8.53768 4.58333H9.62576V9.19875Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const TradeIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.4097 9.49999H21.4997V12C21.4997 12.8954 20.9949 14.0932 19.7447 14.4159L19.4711 14.4865L19.3905 14.7574C19.1767 15.4756 18.662 16.1723 17.7414 16.4167L17.4706 16.4886L17.3905 16.7572C17.2574 17.2039 17.0107 17.6383 16.6327 17.9585C16.2617 18.2728 15.7379 18.5 14.9997 18.5H11.4097H11.202L11.0555 18.6471L8.35613 21.3564C8.35605 21.3565 8.35596 21.3566 8.35588 21.3567C8.04177 21.6707 7.51366 21.95 6.95968 21.95C6.54448 21.95 6.09103 21.8042 5.64324 21.3564L2.64726 18.3605C2.36918 18.0686 2.11863 17.6273 2.06254 17.1481C2.009 16.6907 2.12688 16.165 2.64277 15.644L3.35072 14.946L3.49968 14.7992V14.59V10.7971L7.79324 6.50354L7.85252 6.44426L7.88922 6.36889C8.37808 5.36499 9.31815 4.49999 10.9997 4.49999H13.5897H13.7977L13.9443 4.3525L15.6397 2.6471C15.9316 2.36921 16.3726 2.11891 16.8516 2.06285C17.3094 2.00927 17.8355 2.12737 18.3569 2.64426C18.3571 2.64449 18.3573 2.64472 18.3575 2.64495L21.3521 5.63953C21.6296 5.93076 21.8806 6.3744 21.9368 6.8555C21.9904 7.31448 21.8723 7.83879 21.359 8.35358L21.0622 8.6405L20.173 9.49999H21.4097ZM4.49968 15.204L3.35613 16.3564C3.35592 16.3566 3.35571 16.3569 3.3555 16.3571C3.35352 16.359 3.35129 16.3612 3.34884 16.3637C3.29402 16.4179 3.12635 16.5836 3.07488 16.8345C3.01104 17.1458 3.14359 17.4261 3.35455 17.6516L3.36053 17.658L3.36672 17.6641L6.35613 20.6435C6.35625 20.6437 6.35638 20.6438 6.3565 20.6439C6.35854 20.646 6.36083 20.6483 6.36336 20.6508C6.41756 20.7057 6.58332 20.8733 6.83421 20.9248C7.14547 20.9886 7.42575 20.8561 7.65126 20.6451L7.65735 20.6394L7.66324 20.6335L10.7968 17.5H14.9997C15.5296 17.5 15.9395 17.3126 16.2 16.9732C16.4421 16.658 16.4997 16.2824 16.4997 16V15.5H16.9997C17.5296 15.5 17.9395 15.3126 18.2 14.9732C18.4421 14.658 18.4997 14.2824 18.4997 14V13.5H18.9997C19.5296 13.5 19.9395 13.3126 20.2 12.9732C20.4421 12.658 20.4997 12.2824 20.4997 12V11V10.5H19.9997H12.9997H12.4997V11C12.4997 11.5084 12.3284 12.1446 11.933 12.643C11.5518 13.1234 10.9455 13.5 9.99969 13.5C9.05387 13.5 8.44753 13.1234 8.06639 12.643C7.67101 12.1446 7.49968 11.5084 7.49968 11V9.40999V8.20288L6.64613 9.05644L4.64613 11.0564L4.49968 11.2029V11.41V15.204ZM18.5897 9.49999H18.7977L18.9443 9.35251L20.6432 7.64354C20.6435 7.64333 20.6437 7.64311 20.6439 7.64289C20.6459 7.64092 20.6481 7.63873 20.6505 7.63631C20.7053 7.58212 20.873 7.41636 20.9245 7.16546C20.9883 6.8542 20.8558 6.57392 20.6448 6.34841L20.6388 6.34202L20.6326 6.33584L17.6432 3.35644C17.6432 3.35637 17.6431 3.35631 17.643 3.35624C17.641 3.35415 17.6386 3.35178 17.636 3.34914C17.5818 3.29432 17.4161 3.12665 17.1652 3.07519C16.8539 3.01134 16.5736 3.14389 16.3481 3.35485L16.342 3.36055L16.3361 3.36644L14.2026 5.49999H10.9997C9.91387 5.49999 9.25092 5.97275 8.88715 6.56618C8.54687 7.1213 8.49968 7.72801 8.49968 7.99999V11C8.49968 11.2824 8.5573 11.658 8.79934 11.9732C9.05986 12.3126 9.46979 12.5 9.99969 12.5C10.5296 12.5 10.9395 12.3126 11.2 11.9732C11.4421 11.658 11.4997 11.2824 11.4997 11V9.49999H18.5897Z"
        fill="#984DF7"
        stroke="#984DF7"
      />
    </svg>
  );
};

export const ReturnArrowIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 4L3 7L6.5 10.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 7H14.497C17.9385 7 20.861 9.81 20.995 13.25C21.137 16.885 18.1335 20 14.497 20H5.999"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChartIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.84 16.16L11.04 10.4L14.24 13.6L18.72 5.92M4 4V20H20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RoundIcon = ({ className }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5" cy="5" r="5" fill="currentColor" />
    </svg>
  );
};

export const CrossIcon = ({ className }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7346 6.54544C18.8187 6.46147 18.8854 6.36178 18.9309 6.25204C18.9765 6.1423 18.9999 6.02466 19 5.90585C19.0001 5.78704 18.9767 5.66938 18.9313 5.55958C18.8859 5.44978 18.8194 5.35001 18.7354 5.26594C18.6514 5.18188 18.5518 5.11517 18.442 5.06964C18.3323 5.0241 18.2146 5.00063 18.0958 5.00056C17.977 5.00048 17.8594 5.02381 17.7496 5.06921C17.6398 5.11461 17.54 5.18119 17.4559 5.26515L11.9999 10.7213L6.54541 5.26515C6.37564 5.09538 6.14538 5 5.90528 5C5.66519 5 5.43492 5.09538 5.26515 5.26515C5.09538 5.43493 5 5.6652 5 5.9053C5 6.14539 5.09538 6.37566 5.26515 6.54544L10.7212 12L5.26515 17.4546C5.18109 17.5386 5.1144 17.6384 5.06891 17.7483C5.02342 17.8581 5 17.9758 5 18.0947C5 18.2136 5.02342 18.3313 5.06891 18.4411C5.1144 18.551 5.18109 18.6508 5.26515 18.7348C5.43492 18.9046 5.66519 19 5.90528 19C6.02416 19 6.14188 18.9766 6.25172 18.9311C6.36155 18.8856 6.46135 18.8189 6.54541 18.7348L11.9999 13.2787L17.4559 18.7348C17.6257 18.9044 17.8559 18.9996 18.0958 18.9994C18.3358 18.9993 18.5658 18.9038 18.7354 18.7341C18.905 18.5643 19.0001 18.3341 19 18.0941C18.9999 17.8542 18.9044 17.6241 18.7346 17.4546L13.2786 12L18.7346 6.54544Z"
        fill="#918E95"
      />
    </svg>
  );
};

export const ParkSaleIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.74142 1.69797C7.11184 1.81194 7.31973 2.20463 7.20576 2.57505L6.94928 3.40859C7.21746 3.32528 7.49226 3.25271 7.76551 3.19059C8.60279 3.00026 9.48408 2.89499 10.2192 2.89499C14.4825 2.89499 17.9384 6.35089 17.9384 10.6142C17.9384 14.8775 14.4825 18.3334 10.2192 18.3334C5.9559 18.3334 2.5 14.8775 2.5 10.6142C2.5 10.2266 2.81418 9.91246 3.20175 9.91246C3.58931 9.91246 3.90349 10.2266 3.90349 10.6142C3.90349 14.1024 6.73103 16.9299 10.2192 16.9299C13.7074 16.9299 16.5349 14.1024 16.5349 10.6142C16.5349 7.12602 13.7074 4.29848 10.2192 4.29848C9.60305 4.29848 8.82677 4.38864 8.07662 4.55917C7.85599 4.60933 7.6425 4.66534 7.43979 4.72628L8.09913 5.08592C8.43937 5.2715 8.56475 5.69777 8.37916 6.03801C8.19357 6.37825 7.76731 6.50362 7.42707 6.31804L5.49726 5.26542C5.2044 5.10567 5.06448 4.76183 5.16258 4.44298L5.86433 2.16231C5.97831 1.79188 6.37099 1.58399 6.74142 1.69797Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2213 5.7019C10.6088 5.7019 10.923 6.01609 10.923 6.40365V10.327L13.6926 13.0969C13.9666 13.3709 13.9666 13.8153 13.6925 14.0893C13.4184 14.3633 12.9741 14.3633 12.7001 14.0892L9.72504 11.1138C9.59345 10.9822 9.51953 10.8037 9.51953 10.6176V6.40365C9.51953 6.01609 9.83371 5.7019 10.2213 5.7019Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UploadCsvIcon = ({ className }) => {
  return (
    <svg
      width="48"
      height="48"
      className={className}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 31H8C7.20435 31 6.44129 30.6839 5.87868 30.1213C5.31607 29.5587 5 28.7956 5 28V22C5 21.2044 5.31607 20.4413 5.87868 19.8787C6.44129 19.3161 7.20435 19 8 19H21C21.7956 19 22.5587 19.3161 23.1213 19.8787C23.6839 20.4413 24 21.2044 24 22V28C24 28.7956 23.6839 29.5587 23.1213 30.1213C22.5587 30.6839 21.7956 31 21 31ZM8 21C7.73478 21 7.48043 21.1054 7.29289 21.2929C7.10536 21.4804 7 21.7348 7 22V28C7 28.2652 7.10536 28.5196 7.29289 28.7071C7.48043 28.8946 7.73478 29 8 29H21C21.2652 29 21.5196 28.8946 21.7071 28.7071C21.8946 28.5196 22 28.2652 22 28V22C22 21.7348 21.8946 21.4804 21.7071 21.2929C21.5196 21.1054 21.2652 21 21 21H8Z"
        fill="currentColor"
      />
      <path
        d="M25 16H15C14.8026 15.999 14.6099 15.9396 14.4461 15.8293C14.2824 15.7189 14.155 15.5626 14.08 15.38C14.0034 15.1979 13.9825 14.9972 14.0199 14.8032C14.0572 14.6092 14.1512 14.4306 14.29 14.29L24.29 4.29C24.4306 4.15124 24.6092 4.05725 24.8032 4.01987C24.9972 3.9825 25.1979 4.00342 25.38 4.08C25.5626 4.15502 25.7189 4.28242 25.8293 4.44614C25.9396 4.60986 25.999 4.80258 26 5V15C26 15.2652 25.8946 15.5196 25.7071 15.7071C25.5196 15.8946 25.2652 16 25 16ZM17.41 14H24V7.41L17.41 14Z"
        fill="currentColor"
      />
      <path
        d="M10.78 27.29C10.4429 27.2982 10.1076 27.2379 9.79451 27.1127C9.48141 26.9874 9.19701 26.7999 8.95856 26.5614C8.72011 26.323 8.53258 26.0386 8.40735 25.7255C8.28211 25.4124 8.22177 25.0771 8.23 24.74C8.22033 24.4025 8.27968 24.0666 8.40441 23.7528C8.52913 23.4391 8.71661 23.1541 8.95536 22.9154C9.1941 22.6766 9.47908 22.4891 9.79283 22.3644C10.1066 22.2397 10.4425 22.1803 10.78 22.19C11.2059 22.1923 11.6247 22.2987 12 22.5C12.3641 22.6995 12.668 22.993 12.88 23.35L12.04 23.83C11.9238 23.6136 11.7464 23.4362 11.53 23.32C11.2978 23.1909 11.0356 23.1254 10.77 23.13C10.5575 23.1204 10.3453 23.1554 10.1472 23.233C9.94914 23.3105 9.76952 23.4287 9.62 23.58C9.3367 23.9 9.1803 24.3126 9.1803 24.74C9.1803 25.1674 9.3367 25.58 9.62 25.9C9.77002 26.05 9.94997 26.1667 10.1481 26.2425C10.3463 26.3184 10.5582 26.3516 10.77 26.34C11.0343 26.3433 11.2953 26.2815 11.53 26.16C11.7483 26.0463 11.9263 25.8683 12.04 25.65L12.88 26.13C12.6708 26.4943 12.3667 26.795 12 27C11.6255 27.2013 11.205 27.3013 10.78 27.29Z"
        fill="currentColor"
      />
      <path
        d="M15.15 27.29C14.7236 27.3161 14.299 27.2152 13.93 27C13.6031 26.7952 13.356 26.4846 13.23 26.12L14.05 25.64C14.1322 25.8695 14.2869 26.066 14.4909 26.1995C14.6948 26.3331 14.9368 26.3964 15.18 26.38C15.3897 26.3976 15.5997 26.3487 15.78 26.24C15.8379 26.197 15.8852 26.1413 15.9182 26.0772C15.9511 26.013 15.9688 25.9421 15.97 25.87C15.9722 25.7861 15.9509 25.7032 15.9085 25.6307C15.8661 25.5583 15.8043 25.4991 15.73 25.46C15.4706 25.323 15.1951 25.2189 14.91 25.15C14.7198 25.0974 14.5329 25.034 14.35 24.96C14.1915 24.8849 14.0408 24.7945 13.9 24.69C13.7503 24.5854 13.6298 24.4443 13.55 24.28C13.4671 24.0946 13.4261 23.8931 13.43 23.69C13.4225 23.4892 13.4609 23.2893 13.5424 23.1056C13.6238 22.9219 13.7461 22.7593 13.9 22.63C14.2209 22.3663 14.6247 22.2246 15.04 22.23C15.4107 22.2233 15.7753 22.324 16.09 22.52C16.3926 22.7214 16.6346 23.0014 16.79 23.33L15.98 23.8C15.9053 23.6123 15.7755 23.4517 15.6077 23.3393C15.4399 23.2268 15.242 23.1678 15.04 23.17C14.8719 23.1611 14.7058 23.2105 14.57 23.31C14.5167 23.3514 14.4737 23.4045 14.4442 23.4652C14.4147 23.5259 14.3996 23.5925 14.4 23.66C14.3979 23.7341 14.4142 23.8075 14.4473 23.8738C14.4805 23.9401 14.5295 23.9972 14.59 24.04C14.8203 24.1787 15.0696 24.2831 15.33 24.35L15.67 24.46L15.98 24.57C16.0885 24.6127 16.1924 24.6663 16.29 24.73C16.3792 24.7813 16.463 24.8416 16.54 24.91C16.6242 24.9803 16.6953 25.0649 16.75 25.16C16.8047 25.2547 16.8484 25.3553 16.88 25.46C16.9126 25.5874 16.9294 25.7184 16.93 25.85C16.939 26.0559 16.8994 26.261 16.8142 26.4486C16.7291 26.6363 16.6009 26.8012 16.44 26.93C16.0641 27.1947 15.6086 27.3218 15.15 27.29Z"
        fill="currentColor"
      />
      <path
        d="M18.63 27.19L17 22.29H18L19.2 26.06L20.39 22.29H21.44L19.79 27.19H18.63Z"
        fill="currentColor"
      />
      <path
        d="M37.931 43H30C29.7348 43 29.4804 42.8946 29.2929 42.7071C29.1054 42.5196 29 42.2652 29 42C29 41.7348 29.1054 41.4804 29.2929 41.2929C29.4804 41.1054 29.7348 41 30 41H37.931C38.1962 41 38.4506 40.8946 38.6381 40.7071C38.8257 40.5196 38.931 40.2652 38.931 40V7C38.931 6.73478 38.8257 6.48043 38.6381 6.29289C38.4506 6.10536 38.1962 6 37.931 6H23.341L13.931 15.41V20C13.931 20.2652 13.8257 20.5196 13.6381 20.7071C13.4506 20.8946 13.1962 21 12.931 21C12.6658 21 12.4114 20.8946 12.2239 20.7071C12.0364 20.5196 11.931 20.2652 11.931 20V15C11.9303 14.8684 11.9555 14.7379 12.0052 14.6161C12.055 14.4943 12.1283 14.3834 12.221 14.29L22.221 4.29C22.3145 4.19732 22.4253 4.12399 22.5471 4.07423C22.6689 4.02447 22.7994 3.99924 22.931 4H37.931C38.7267 4 39.4897 4.31607 40.0523 4.87868C40.6149 5.44129 40.931 6.20435 40.931 7V40C40.931 40.7956 40.6149 41.5587 40.0523 42.1213C39.4897 42.6839 38.7267 43 37.931 43Z"
        fill="currentColor"
      />
      <path
        d="M30.57 43H17C16.2044 43 15.4413 42.6839 14.8787 42.1213C14.3161 41.5587 14 40.7956 14 40V30C14 29.7348 14.1054 29.4804 14.2929 29.2929C14.4804 29.1054 14.7348 29 15 29C15.2652 29 15.5196 29.1054 15.7071 29.2929C15.8946 29.4804 16 29.7348 16 30V40C16 40.2652 16.1054 40.5196 16.2929 40.7071C16.4804 40.8946 16.7348 41 17 41H30.57C30.8352 41 31.0896 41.1054 31.2771 41.2929C31.4646 41.4804 31.57 41.7348 31.57 42C31.57 42.2652 31.4646 42.5196 31.2771 42.7071C31.0896 42.8946 30.8352 43 30.57 43Z"
        fill="currentColor"
      />
      <path
        d="M31.9954 25C32.154 25.0007 32.3102 25.0392 32.4511 25.1122C32.5919 25.1853 32.7134 25.2908 32.8054 25.42L37.8054 32.42C37.9117 32.5692 37.9749 32.7448 37.9882 32.9276C38.0014 33.1103 37.9642 33.2932 37.8807 33.4562C37.7971 33.6193 37.6703 33.7562 37.5142 33.8521C37.3581 33.948 37.1786 33.9992 36.9954 34H35.9954V39C35.9954 39.2652 35.89 39.5196 35.7025 39.7071C35.515 39.8946 35.2606 40 34.9954 40H28.9954C28.7302 40 28.4758 39.8946 28.2883 39.7071C28.1007 39.5196 27.9954 39.2652 27.9954 39V34H26.9954C26.8122 33.9992 26.6327 33.948 26.4766 33.8521C26.3205 33.7562 26.1937 33.6193 26.1101 33.4562C26.0265 33.2932 25.9894 33.1103 26.0026 32.9276C26.0159 32.7448 26.0791 32.5692 26.1854 32.42L31.1854 25.42C31.2774 25.2908 31.3989 25.1853 31.5397 25.1122C31.6805 25.0392 31.8367 25.0007 31.9954 25ZM35.0554 32L31.9954 27.72L28.9354 32H28.9954C29.2606 32 29.515 32.1054 29.7025 32.2929C29.89 32.4804 29.9954 32.7348 29.9954 33L29.9954 38H33.9954V33C33.9954 32.7348 34.1007 32.4804 34.2883 32.2929C34.4758 32.1054 34.7302 32 34.9954 32H35.0554Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RetriveSaleIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3544 3.38046C10.5697 3.2883 10.8193 3.33344 10.9887 3.49518L17.4268 9.64066C17.5425 9.7511 17.608 9.90408 17.608 10.064C17.608 10.224 17.5425 10.377 17.4268 10.4874L10.9887 16.6329C10.8193 16.7946 10.5697 16.8398 10.3544 16.7476C10.139 16.6555 9.99932 16.4438 9.99932 16.2095V13.2916C8.2488 13.3439 7.05366 13.6366 6.11913 14.1198C5.084 14.6549 4.309 15.4535 3.43718 16.5698C3.28341 16.7667 3.02162 16.8442 2.78541 16.7629C2.54919 16.6816 2.39062 16.4593 2.39062 16.2095C2.39062 13.9829 2.75658 11.6465 3.98722 9.85317C5.16835 8.13197 7.08899 6.99196 9.99932 6.85819V3.91855C9.99932 3.6843 10.139 3.47261 10.3544 3.38046ZM11.1699 5.28635V7.43025C11.1699 7.7535 10.9078 8.01554 10.5846 8.01554C7.66397 8.01554 5.95785 9.05028 4.95239 10.5155C4.19236 11.623 3.79777 13.0266 3.64219 14.541C4.21292 13.9606 4.83391 13.4665 5.58155 13.08C6.84169 12.4285 8.40201 12.1125 10.5846 12.1125C10.9078 12.1125 11.1699 12.3746 11.1699 12.6978V14.8417L16.1751 10.064L11.1699 5.28635Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DropdownIcon = ({ className }) => {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.292566 1.29277C0.479952 1.10544 0.734068 1.00021 0.999032 1.00021C1.264 1.00021 1.51811 1.10544 1.7055 1.29277L7.99375 7.58103L14.282 1.29277C14.3742 1.19733 14.4844 1.12121 14.6064 1.06884C14.7283 1.01647 14.8594 0.988904 14.9921 0.987751C15.1248 0.986598 15.2563 1.01188 15.3791 1.06212C15.5019 1.11237 15.6135 1.18656 15.7073 1.28039C15.8011 1.37421 15.8753 1.48577 15.9256 1.60858C15.9758 1.73138 16.0011 1.86296 16 1.99564C15.9988 2.12832 15.9712 2.25944 15.9189 2.38135C15.8665 2.50327 15.7904 2.61353 15.6949 2.7057L8.70022 9.70043C8.51283 9.88776 8.25872 9.99299 7.99375 9.99299C7.72879 9.99299 7.47467 9.88776 7.28729 9.70043L0.292566 2.7057C0.105236 2.51832 0 2.2642 0 1.99924C0 1.73427 0.105236 1.48016 0.292566 1.29277Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LoadingIndicator = () => {
  return (
    <div
      className="spinner-border spinner-border-sm text-purple ms-auto"
      role="status"
    >
      <span className="sr-only"></span>
    </div>
  );
};

export const LoadingIndicatorCentered = () => {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <div
        className="spinner-border spinner-border-sm text-purple ms-auto"
        role="status"
      >
        <span className="sr-only"></span>
      </div>
    </div>
  );
};

export const CashIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.85742 13.5714V6.42857C2.85742 6.04969 3.00793 5.68633 3.27584 5.41842C3.54375 5.15051 3.90711 5 4.28599 5H15.7146C16.0934 5 16.4568 5.15051 16.7247 5.41842C16.9926 5.68633 17.1431 6.04969 17.1431 6.42857V13.5714C17.1431 13.9503 16.9926 14.3137 16.7247 14.5816C16.4568 14.8495 16.0934 15 15.7146 15H4.28599C3.90711 15 3.54375 14.8495 3.27584 14.5816C3.00793 14.3137 2.85742 13.9503 2.85742 13.5714Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6431 10.0072L14.6503 9.99932M5.35742 10.0072L5.36456 9.99932M10.0003 12.1429C9.43196 12.1429 8.88691 11.9171 8.48505 11.5153C8.08319 11.1134 7.85742 10.5684 7.85742 10C7.85742 9.43171 8.08319 8.88667 8.48505 8.48481C8.88691 8.08294 9.43196 7.85718 10.0003 7.85718C10.5686 7.85718 11.1136 8.08294 11.5155 8.48481C11.9174 8.88667 12.1431 9.43171 12.1431 10C12.1431 10.5684 11.9174 11.1134 11.5155 11.5153C11.1136 11.9171 10.5686 12.1429 10.0003 12.1429Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CreditcardIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.334 4.375H4.66732C4.28122 4.37719 3.91156 4.53154 3.63854 4.80455C3.36552 5.07757 3.21117 5.44723 3.20898 5.83333V14.1667C3.21117 14.5528 3.36552 14.9224 3.63854 15.1954C3.91156 15.4685 4.28122 15.6228 4.66732 15.625H16.334C16.7201 15.6228 17.0897 15.4685 17.3628 15.1954C17.6358 14.9224 17.7901 14.5528 17.7923 14.1667V5.83333C17.7901 5.44723 17.6358 5.07757 17.3628 4.80455C17.0897 4.53154 16.7201 4.37719 16.334 4.375ZM4.66732 5.625H16.334C16.3892 5.625 16.4422 5.64695 16.4813 5.68602C16.5204 5.72509 16.5423 5.77808 16.5423 5.83333V7.70833H4.45898V5.83333C4.45898 5.77808 4.48093 5.72509 4.52 5.68602C4.55907 5.64695 4.61206 5.625 4.66732 5.625ZM16.334 14.375H4.66732C4.61206 14.375 4.55907 14.3531 4.52 14.314C4.48093 14.2749 4.45898 14.2219 4.45898 14.1667V8.95833H16.5423V14.1667C16.5423 14.2219 16.5204 14.2749 16.4813 14.314C16.4422 14.3531 16.3892 14.375 16.334 14.375Z"
        fill="currentColor"
      />
      <path
        d="M8 10.8333H6.33333C6.11232 10.8333 5.90036 10.921 5.74408 11.0773C5.5878 11.2336 5.5 11.4456 5.5 11.6666C5.5 11.8876 5.5878 12.0996 5.74408 12.2558C5.90036 12.4121 6.11232 12.4999 6.33333 12.4999H8C8.22101 12.4999 8.43297 12.4121 8.58926 12.2558C8.74554 12.0996 8.83333 11.8876 8.83333 11.6666C8.83333 11.4456 8.74554 11.2336 8.58926 11.0773C8.43297 10.921 8.22101 10.8333 8 10.8333Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GiftCardIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25043 4.16675C4.58003 4.16675 3.93708 4.43307 3.46303 4.90712C2.98897 5.38117 2.72266 6.02412 2.72266 6.69453V13.3056C2.72266 13.976 2.98897 14.619 3.46303 15.093C3.93708 15.5671 4.58003 15.8334 5.25043 15.8334H15.7504C16.0824 15.8334 16.4111 15.768 16.7178 15.641C17.0245 15.514 17.3031 15.3278 17.5378 15.093C17.7726 14.8583 17.9588 14.5797 18.0858 14.273C18.2128 13.9663 18.2782 13.6376 18.2782 13.3056V6.69453C18.2782 6.36257 18.2128 6.03387 18.0858 5.72719C17.9588 5.4205 17.7726 5.14184 17.5378 4.90712C17.3031 4.67239 17.0245 4.4862 16.7178 4.35916C16.4111 4.23213 16.0824 4.16675 15.7504 4.16675H5.25043ZM3.88932 6.69453C3.88932 5.94319 4.4991 5.33341 5.25043 5.33341H7.38932V6.27297C7.03106 6.11638 6.63391 6.07143 6.24971 6.14399C5.86551 6.21655 5.5121 6.40325 5.23563 6.67972C4.95916 6.9562 4.77246 7.3096 4.69989 7.6938C4.62733 8.078 4.67228 8.47515 4.82888 8.83341H3.88932V6.69453ZM8.55599 8.05564C8.55599 7.90181 8.6016 7.75143 8.68707 7.62353C8.77253 7.49562 8.894 7.39593 9.03612 7.33706C9.17824 7.2782 9.33463 7.26279 9.4855 7.2928C9.63638 7.32281 9.77496 7.39689 9.88374 7.50566C9.99251 7.61444 10.0666 7.75303 10.0966 7.9039C10.1266 8.05477 10.1112 8.21116 10.0523 8.35328C9.99347 8.4954 9.89378 8.61687 9.76588 8.70234C9.63797 8.7878 9.4876 8.83341 9.33377 8.83341H8.55599V8.05564ZM7.38932 8.83341H6.61154C6.45772 8.83341 6.30734 8.7878 6.17943 8.70234C6.05153 8.61687 5.95184 8.4954 5.89297 8.35328C5.8341 8.21116 5.8187 8.05477 5.84871 7.9039C5.87872 7.75303 5.9528 7.61444 6.06157 7.50566C6.17035 7.39689 6.30893 7.32281 6.45981 7.2928C6.61068 7.26279 6.76707 7.2782 6.90919 7.33706C7.05131 7.39593 7.17278 7.49562 7.25824 7.62353C7.34371 7.75143 7.38932 7.90181 7.38932 8.05564V8.83341ZM7.38932 10.8245V14.6667H5.25043C4.88944 14.6667 4.54324 14.5233 4.28798 14.2681C4.03273 14.0128 3.88932 13.6666 3.88932 13.3056V10.0001H6.56488L5.2271 11.3379C5.16979 11.3913 5.12382 11.4557 5.09194 11.5272C5.06005 11.5988 5.04291 11.676 5.04153 11.7543C5.04015 11.8327 5.05456 11.9105 5.08389 11.9831C5.11323 12.0557 5.1569 12.1217 5.21229 12.1771C5.26769 12.2325 5.33367 12.2762 5.4063 12.3055C5.47894 12.3348 5.55674 12.3493 5.63506 12.3479C5.71339 12.3465 5.79063 12.3293 5.86219 12.2975C5.93374 12.2656 5.99814 12.2196 6.05155 12.1623L7.38932 10.8245ZM8.55599 14.6667V10.8245L9.89377 12.1623C9.94717 12.2196 10.0116 12.2656 10.0831 12.2975C10.1547 12.3293 10.2319 12.3465 10.3102 12.3479C10.3886 12.3493 10.4664 12.3348 10.539 12.3055C10.6116 12.2762 10.6776 12.2325 10.733 12.1771C10.7884 12.1217 10.8321 12.0557 10.8614 11.9831C10.8908 11.9105 10.9052 11.8327 10.9038 11.7543C10.9024 11.676 10.8853 11.5988 10.8534 11.5272C10.8215 11.4557 10.7755 11.3913 10.7182 11.3379L9.38043 10.0001H17.1115V13.3056C17.1115 13.4844 17.0763 13.6614 17.0079 13.8265C16.9395 13.9916 16.8393 14.1417 16.7129 14.2681C16.5865 14.3945 16.4364 14.4947 16.2713 14.5631C16.1062 14.6315 15.9292 14.6667 15.7504 14.6667H8.55599ZM8.55599 6.27297V5.33341H15.7504C16.5018 5.33341 17.1115 5.94319 17.1115 6.69453V8.83341H11.1164C11.273 8.47515 11.318 8.078 11.2454 7.6938C11.1729 7.3096 10.9862 6.9562 10.7097 6.67972C10.4332 6.40325 10.0798 6.21655 9.69561 6.14399C9.3114 6.07143 8.91425 6.11638 8.55599 6.27297Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const StoreCreditIcon = ({ className }) => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6673 2.3335C13.6673 1.23083 12.77 0.333496 11.6673 0.333496H2.33398C1.23132 0.333496 0.333984 1.23083 0.333984 2.3335V4.22083C0.333984 4.92283 0.588651 5.56083 1.00065 6.0515V11.6668C1.00065 12.4022 1.59865 13.0002 2.33398 13.0002H11.6673C12.4026 13.0002 13.0007 12.4022 13.0007 11.6668V6.05083C13.4127 5.56083 13.6673 4.92283 13.6673 4.22016V2.3335ZM12.334 2.3335V4.22083C12.334 4.98083 11.768 5.62883 11.0733 5.6655L11.0007 5.66683C10.2653 5.66683 9.66732 5.06883 9.66732 4.3335V1.66683H11.6673C12.0353 1.66683 12.334 1.96616 12.334 2.3335ZM5.66732 1.66683H8.33398V4.3335C8.33398 5.06883 7.73598 5.66683 7.00065 5.66683C6.26532 5.66683 5.66732 5.06883 5.66732 4.3335V1.66683ZM1.66732 2.3335C1.66732 1.96616 1.96598 1.66683 2.33398 1.66683H4.33398V4.3335C4.33398 5.06883 3.73598 5.66683 3.00065 5.66683L2.92798 5.66483C2.23332 5.62883 1.66732 4.98083 1.66732 4.22083V2.3335ZM5.66732 11.6668V9.66683H8.33398V11.6668H5.66732ZM9.66732 11.6668V9.66683C9.66732 8.9315 9.06932 8.3335 8.33398 8.3335H5.66732C4.93198 8.3335 4.33398 8.9315 4.33398 9.66683V11.6668H2.33398V6.91283C2.50332 6.9575 2.67865 6.98683 2.85865 6.99616C3.26058 7.01798 3.66221 6.94825 4.03326 6.79223C4.4043 6.63621 4.73509 6.39798 5.00065 6.0955C5.48932 6.65016 6.20532 7.00016 7.00065 7.00016C7.79598 7.00016 8.51198 6.65016 9.00065 6.0955C9.26622 6.39798 9.597 6.63621 9.96805 6.79223C10.3391 6.94825 10.7407 7.01798 11.1426 6.99616C11.3233 6.98683 11.498 6.9575 11.6673 6.91283V11.6668H9.66732Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PosDeviceIcon = ({ className }) => {
  return (
    <svg
      version="1.1"
      width="24"
      height="24"
      id="Layer_1"
      x="0px"
      y="0px"
      className={className}
      viewBox="0 0 352.3 352.1"
    >
      <g>
        <path
          d="M352.3,312.3c-30.7,0-61,0-91.7,0c0,13.3,0,26.4,0,39.7c-87,0-173.7,0-260.7,0C0,234.8,0,117.6,0,0c86.6,0,173.3,0,260.5,0
		c0,28.4,0,56.7,0,85.5c30.9,0,61.2,0,91.9,0C352.3,161.2,352.3,236.5,352.3,312.3z M15.4,15.2c0,107.5,0,214.6,0,321.6
		c76.7,0,153.1,0,229.5,0c0-107.3,0-214.4,0-321.6C168.3,15.2,91.9,15.2,15.4,15.2z M260.9,101.2c0,65.4,0,130.4,0,195.4
		c12.8,0,25.2,0,37.7,0c0-65.3,0-130.3,0-195.4C286,101.2,273.5,101.2,260.9,101.2z M314.4,101.2c0,65.4,0,130.3,0,195.4
		c7.7,0,15.1,0,22.6,0c0-65.3,0-130.3,0-195.4C329.4,101.2,322,101.2,314.4,101.2z"
          fill="currentColor"
        />
        <path
          d="M229.7,30.3c0,28.3,0,56.1,0,84.1c-66.4,0-132.6,0-199.4,0c0-1.3,0-2.6,0-3.9c0-25.3,0.1-50.6-0.1-75.9
		c0-3.5,1.1-4.3,4.4-4.3c63.5,0.1,127,0.1,190.5,0.1C226.6,30.3,228,30.3,229.7,30.3z M45.9,99.2c56.3,0,112.3,0,168.3,0
		c0-17.9,0-35.5,0-53.2C158,46,102,46,45.9,46C45.9,63.7,45.9,81.3,45.9,99.2z"
          fill="currentColor"
        />
        <path
          d="M38.5,275.8c15.3,0,30.2,0,45.4,0c0,15.2,0,30.3,0,45.6c-15,0-30,0-45.4,0C38.5,306.3,38.5,291.2,38.5,275.8z M53.6,306.1
		c5.2,0,10,0,14.9,0c0-5,0-9.9,0-14.8c-5.1,0-9.9,0-14.9,0C53.6,296.3,53.6,301.1,53.6,306.1z"
          fill="currentColor"
        />
        <path
          d="M152.8,321.5c-15.3,0-30.3,0-45.5,0c0-15.3,0-30.3,0-45.6c15.2,0,30.2,0,45.5,0C152.8,291,152.8,306,152.8,321.5z
		 M137.7,291.3c-5.1,0-10,0-15,0c0,5,0,9.8,0,14.7c5.1,0,10,0,15,0C137.7,301.1,137.7,296.3,137.7,291.3z"
          fill="currentColor"
        />
        <path
          d="M176.3,321.5c0-15.4,0-30.4,0-45.6c15.2,0,30.2,0,45.5,0c0,15.2,0,30.3,0,45.6C206.7,321.5,191.7,321.5,176.3,321.5z
		 M191.7,291.2c0,5.1,0,9.9,0,14.9c5.1,0,10,0,14.9,0c0-5.1,0-10,0-14.9C201.6,291.2,196.9,291.2,191.7,291.2z"
          fill="currentColor"
        />
        <path
          d="M38.4,183.4c0-15.2,0-30.2,0-45.4c15.2,0,30.2,0,45.5,0c0,15.1,0,30.1,0,45.4C68.8,183.4,53.8,183.4,38.4,183.4z
		 M53.6,168.2c5.2,0,10,0,15,0c0-5.1,0-10,0-14.9c-5.2,0-10,0-15,0C53.6,158.3,53.6,163.1,53.6,168.2z"
          fill="currentColor"
        />
        <path
          d="M176.3,183.4c0-15.3,0-30.2,0-45.4c15.2,0,30.4,0,45.7,0c0,15.2,0,30.2,0,45.4C206.7,183.4,191.7,183.4,176.3,183.4z
		 M191.8,153.2c0,5,0,9.9,0,15c5.1,0,10,0,14.9,0c0-5.1,0-9.9,0-15C201.6,153.2,196.8,153.2,191.8,153.2z"
          fill="currentColor"
        />
        <path
          d="M83.8,252.4c-15.2,0-30.2,0-45.4,0c0-15.2,0-30.2,0-45.5c15.1,0,30.1,0,45.4,0C83.8,222,83.8,237.1,83.8,252.4z
		 M68.7,222.3c-5.3,0-10.2,0-15.1,0c0,5.1,0,10,0,14.7c5.2,0,10.1,0,15.1,0C68.7,232.1,68.7,227.3,68.7,222.3z"
          fill="currentColor"
        />
        <path
          d="M107.4,206.8c15.3,0,30.2,0,45.4,0c0,15.2,0,30.3,0,45.6c-15.2,0-30.2,0-45.4,0C107.4,237.2,107.4,222.2,107.4,206.8z
		 M137.6,237.2c0-5.1,0-10,0-14.8c-5.2,0-10.1,0-14.9,0c0,5.2,0,10,0,14.8C127.8,237.2,132.6,237.2,137.6,237.2z"
          fill="currentColor"
        />
        <path
          d="M221.8,252.4c-15.2,0-30.3,0-45.5,0c0-15.2,0-30.2,0-45.5c15.1,0,30.1,0,45.5,0C221.8,222,221.8,237,221.8,252.4z
		 M206.6,237.2c0-5.2,0-10.1,0-14.9c-5.1,0-10,0-14.9,0c0,5.2,0,10,0,14.9C196.8,237.2,201.6,237.2,206.6,237.2z"
          fill="currentColor"
        />
        <path
          d="M152.9,138c0,15.2,0,30.1,0,45.3c-15.1,0-30.3,0-45.6,0c0-15.1,0-30.1,0-45.3C122.5,138,137.5,138,152.9,138z M122.7,153.2
		c0,5.1,0,10,0,14.9c5.1,0,10,0,14.9,0c0-5.2,0-10.1,0-14.9C132.4,153.2,127.6,153.2,122.7,153.2z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const NFCIcon = ({ className }) => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path
        d="M12 26.505C12 24.0966 13.9523 22.1443 16.3607 22.1443H27.2624C29.6707 22.1443 31.623 24.0966 31.623 26.505V48.3083C31.623 50.7167 29.6707 52.669 27.2624 52.669H16.3607C13.9523 52.669 12 50.7167 12 48.3083V26.505ZM27.2624 26.505H16.3607V48.3083H27.2624V26.505Z"
        fill="#918E95"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.1474 18.2896C53.1923 17.691 54.5245 18.0528 55.1231 19.0976C58.3155 24.6701 59.997 30.9797 60.001 37.4018C60.0051 43.8239 58.3316 50.1357 55.1463 55.7122C54.549 56.7578 53.2172 57.1213 52.1716 56.524C51.126 55.9268 50.7625 54.595 51.3598 53.5494C54.1684 48.6324 55.6439 43.0671 55.6403 37.4046C55.6368 31.7421 54.1542 26.1786 51.3394 21.2653C50.7408 20.2204 51.1025 18.8881 52.1474 18.2896ZM44.6356 22.8842C45.6837 22.2913 47.014 22.6604 47.6068 23.7085C49.9703 27.8868 51.2125 32.6056 51.2125 37.4061C51.2125 42.2066 49.9703 46.9254 47.6068 51.1038C47.014 52.1519 45.6837 52.5209 44.6356 51.928C43.5875 51.3352 43.2184 50.0049 43.8113 48.9568C45.8043 45.4334 46.8518 41.4542 46.8518 37.4061C46.8518 33.3581 45.8043 29.3789 43.8113 25.8554C43.2184 24.8073 43.5875 23.4771 44.6356 22.8842ZM37.0852 27.4883C38.1313 26.8919 39.4628 27.2565 40.0592 28.3026C41.6405 31.076 42.472 34.2136 42.472 37.4061C42.472 40.5987 41.6405 43.7362 40.0592 46.5097C39.4628 47.5558 38.1313 47.9203 37.0852 47.3239C36.0391 46.7275 35.6746 45.396 36.271 44.3499C37.4771 42.2344 38.1113 39.8412 38.1113 37.4061C38.1113 34.971 37.4771 32.5778 36.271 30.4624C35.6746 29.4163 36.0391 28.0848 37.0852 27.4883Z"
        fill="#918E95"
      />
    </svg>
  );
};
export const PaymentIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 5.25H5C4.53668 5.25263 4.09309 5.43784 3.76546 5.76546C3.43784 6.09309 3.25263 6.53668 3.25 7V17C3.25263 17.4633 3.43784 17.9069 3.76546 18.2345C4.09309 18.5622 4.53668 18.7474 5 18.75H19C19.4633 18.7474 19.9069 18.5622 20.2345 18.2345C20.5622 17.9069 20.7474 17.4633 20.75 17V7C20.7474 6.53668 20.5622 6.09309 20.2345 5.76546C19.9069 5.43784 19.4633 5.25263 19 5.25ZM5 6.75H19C19.0663 6.75 19.1299 6.77634 19.1768 6.82322C19.2237 6.87011 19.25 6.9337 19.25 7V9.25H4.75V7C4.75 6.9337 4.77634 6.87011 4.82322 6.82322C4.87011 6.77634 4.9337 6.75 5 6.75ZM19 17.25H5C4.9337 17.25 4.87011 17.2237 4.82322 17.1768C4.77634 17.1299 4.75 17.0663 4.75 17V10.75H19.25V17C19.25 17.0663 19.2237 17.1299 19.1768 17.1768C19.1299 17.2237 19.0663 17.25 19 17.25Z"
        fill="currentColor"
      />
      <path
        d="M9 13H7C6.73478 13 6.48043 13.1054 6.29289 13.2929C6.10536 13.4804 6 13.7348 6 14C6 14.2652 6.10536 14.5196 6.29289 14.7071C6.48043 14.8946 6.73478 15 7 15H9C9.26522 15 9.51957 14.8946 9.70711 14.7071C9.89464 14.5196 10 14.2652 10 14C10 13.7348 9.89464 13.4804 9.70711 13.2929C9.51957 13.1054 9.26522 13 9 13Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GraphDatePickerIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17 15L12 20L7 15" stroke="currentColor" strokeWidth="2" />
      <path d="M17 9L12 4L7 9" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
};

export const UserIcon = ({ setIsShown, isShown }) => {
  return (
    <svg
      width="34"
      height="24"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transitionDuration: "0.3s" }}
      data-tooltip-id="user-dropdown"
      // the delay in ms should match the transition-delay in topbar's scss file
      data-tooltip-delay-hide={250}
      id="user-drowndown-icon"
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5114 5.11628C10.1757 5.11628 9.09284 6.19913 9.09284 7.53489C9.09284 8.87065 10.1757 9.95349 11.5114 9.95349C12.8472 9.95349 13.9301 8.87065 13.9301 7.53489C13.9301 6.19913 12.8472 5.11628 11.5114 5.11628ZM7.97656 7.53489C7.97656 5.58262 9.55919 4 11.5114 4C13.4637 4 15.0463 5.58262 15.0463 7.53489C15.0463 9.48715 13.4637 11.0698 11.5114 11.0698C9.55919 11.0698 7.97656 9.48715 7.97656 7.53489Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.57569 14.2116C6.57882 14.7723 6.11638 15.4596 6.11638 16.093C6.11638 17.0661 6.14638 17.614 6.65487 18.0281C6.93062 18.2527 7.39158 18.4719 8.18061 18.6316C8.96717 18.7908 10.0425 18.8837 11.5117 18.8837C12.9809 18.8837 14.0563 18.7908 14.8429 18.6316C15.6319 18.4719 16.0928 18.2527 16.3686 18.0281C16.8771 17.614 16.9071 17.0661 16.9071 16.093C16.9071 15.4596 16.4446 14.7723 15.4478 14.2116C14.4684 13.6607 13.0779 13.3023 11.5117 13.3023C9.94555 13.3023 8.55505 13.6607 7.57569 14.2116ZM7.02842 13.2386C8.20385 12.5775 9.7901 12.186 11.5117 12.186C13.2334 12.186 14.8196 12.5775 15.995 13.2386C17.153 13.89 18.0234 14.8771 18.0234 16.093C18.0234 16.1181 18.0234 16.1434 18.0234 16.1689C18.0243 17.0334 18.0253 18.1186 17.0735 18.8937C16.605 19.2752 15.9497 19.5465 15.0643 19.7257C14.1765 19.9054 13.0193 20 11.5117 20C10.0042 20 8.84699 19.9054 7.95913 19.7257C7.07374 19.5465 6.41842 19.2752 5.94998 18.8937C4.99816 18.1186 4.99921 17.0334 5.00005 16.1689C5.00008 16.1434 5.0001 16.1181 5.0001 16.093C5.0001 14.8771 5.8705 13.89 7.02842 13.2386Z"
        fill="currentColor"
      />
      <path
        d="M24.1465 13.8569C24.2403 13.9507 24.3676 14.0034 24.5003 14.0034C24.633 14.0034 24.7602 13.9507 24.8541 13.8569L28.003 10.708L31.152 13.8569C31.2464 13.9481 31.3728 13.9985 31.504 13.9974C31.6352 13.9962 31.7607 13.9436 31.8534 13.8508C31.9462 13.758 31.9988 13.6325 32 13.5013C32.0011 13.3701 31.9507 13.2437 31.8595 13.1494L28.3568 9.64663C28.263 9.55282 28.1357 9.50012 28.003 9.50012C27.8703 9.50012 27.7431 9.55282 27.6492 9.64663L24.1465 13.1494C24.0527 13.2432 24 13.3705 24 13.5031C24 13.6358 24.0527 13.7631 24.1465 13.8569Z"
        fill="currentColor"
        id="user-drowndown-icon-path"
        className={isShown ? "rotate-arrow" : undefined}
      />
    </svg>
  );
};

export const InfoIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2823 10.0611C20.2823 4.50482 15.7775 0 10.2208 0C4.66419 0 0.15937 4.50482 0.15937 10.0611C0.15937 15.6178 4.66419 20.1226 10.2208 20.1226C15.7775 20.1226 20.2823 15.6178 20.2823 10.0611ZM10.2855 10.2898C9.60101 11.1095 9.5292 11.8518 9.55792 12.8617H10.8093C10.8207 12.2597 10.8377 11.6156 11.2092 11.1114C11.4912 10.7282 11.8445 10.417 12.1942 10.109C12.9325 9.45857 13.6546 8.82252 13.6546 7.55339C13.6546 5.65002 11.9912 4.63861 10.2356 4.63861C8.23962 4.63861 7.02791 5.75131 6.78715 7.72233L8.12775 7.88636C8.3171 6.67389 8.91918 5.71124 10.2583 5.71124C11.3369 5.71124 12.314 6.5314 12.314 7.64031C12.314 8.44056 11.6631 9.01245 11.0367 9.56287C10.7628 9.80351 10.4936 10.04 10.2855 10.2898ZM9.31943 13.9941V15.4836H10.8093V13.9941H9.31943ZM1.7309 10.0611C1.7309 5.37222 5.53197 1.57115 10.2208 1.57115C14.9097 1.57115 18.7108 5.37222 18.7108 10.0611C18.7108 14.75 14.9097 18.5511 10.2208 18.5511C5.53197 18.5511 1.7309 14.75 1.7309 10.0611Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ExpandTabIcon = ({ className }) => {
  return (
    <svg
      width="22"
      height="13"
      viewBox="0 0 22 13"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.722119 1.05713C0.971967 0.807362 1.31079 0.667047 1.66407 0.667047C2.01736 0.667047 2.35618 0.807362 2.60603 1.05713L10.9904 9.44147L19.3747 1.05713C19.4976 0.929884 19.6446 0.828383 19.8072 0.758557C19.9697 0.688732 20.1446 0.651978 20.3215 0.650441C20.4984 0.648904 20.6738 0.682614 20.8375 0.749605C21.0013 0.816595 21.15 0.915525 21.2751 1.04062C21.4002 1.16572 21.4992 1.31447 21.5662 1.47821C21.6331 1.64195 21.6669 1.81739 21.6653 1.9943C21.6638 2.1712 21.627 2.34603 21.5572 2.50858C21.4874 2.67113 21.3859 2.81814 21.2586 2.94105L11.9323 12.2673C11.6825 12.5171 11.3437 12.6574 10.9904 12.6574C10.6371 12.6574 10.2983 12.5171 10.0484 12.2673L0.722119 2.94105C0.472346 2.6912 0.332031 2.35238 0.332031 1.99909C0.332031 1.6458 0.472346 1.30698 0.722119 1.05713Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FilterIcon = ({ className }) => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.91834 15.2998C7.78672 15.2998 7.65865 15.2571 7.55335 15.1781L5.12009 13.3532C5.04453 13.2965 4.98321 13.2231 4.94098 13.1386C4.89875 13.0541 4.87676 12.961 4.87676 12.8665V9.44779L0.608806 4.64635C0.305694 4.3044 0.107783 3.88219 0.0388613 3.43046C-0.0300606 2.97874 0.0329389 2.51672 0.220288 2.09994C0.407637 1.68316 0.711363 1.32935 1.09496 1.08104C1.47856 0.832731 1.92571 0.700484 2.38266 0.700195H11.0208C11.4777 0.700731 11.9247 0.833197 12.3082 1.08168C12.6916 1.33015 12.9951 1.68407 13.1823 2.1009C13.3694 2.51772 13.4322 2.97973 13.3631 3.43139C13.294 3.88304 13.096 4.30514 12.7928 4.64696L8.52666 9.44779V14.6915C8.52666 14.8528 8.46257 15.0076 8.34849 15.1216C8.23441 15.2357 8.07968 15.2998 7.91834 15.2998V15.2998ZM6.09339 12.5624L7.31003 13.4749V9.21663C7.31015 9.06769 7.36491 8.92397 7.46393 8.81271L11.8852 3.8385C12.0326 3.67187 12.1288 3.46624 12.1622 3.24628C12.1957 3.02632 12.1649 2.80139 12.0736 2.59848C11.9823 2.39558 11.8345 2.22333 11.6477 2.10242C11.4609 1.98151 11.2432 1.91706 11.0208 1.91683H2.38266C2.16029 1.91717 1.94274 1.98164 1.75609 2.10253C1.56945 2.22341 1.42164 2.39557 1.3304 2.59836C1.23915 2.80114 1.20834 3.02595 1.24165 3.24581C1.27497 3.46567 1.37101 3.67125 1.51824 3.83789L5.9401 8.81271C6.0389 8.92406 6.09344 9.06777 6.09339 9.21663V12.5624Z"
        fill="currentcolor"
      />
    </svg>
  );
};

export const EmployeesIcon = ({ className }) => {
  return (
    <svg
      width="26"
      height="22"
      viewBox="0 0 26 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Group">
        <path
          id="Vector"
          d="M12.9996 9.7543C15.325 9.7543 17.2101 7.86918 17.2101 5.54378C17.2101 3.21837 15.325 1.33325 12.9996 1.33325C10.6742 1.33325 8.78906 3.21837 8.78906 5.54378C8.78906 7.86918 10.6742 9.7543 12.9996 9.7543Z"
          stroke="currentColor"
          strokeWidth="1.2"
        />
        <path
          id="Vector_2"
          d="M19.3168 8.70163C21.061 8.70163 22.4747 7.52268 22.4747 6.07005C22.4747 4.61742 21.061 3.43848 19.3168 3.43848M6.68524 8.70163C4.94103 8.70163 3.52734 7.52268 3.52734 6.07005C3.52734 4.61742 4.94103 3.43848 6.68524 3.43848"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          id="Vector_3"
          d="M12.9994 21.3332C16.4875 21.3332 19.3152 19.448 19.3152 17.1226C19.3152 14.7972 16.4875 12.9121 12.9994 12.9121C9.51127 12.9121 6.68359 14.7972 6.68359 17.1226C6.68359 19.448 9.51127 21.3332 12.9994 21.3332Z"
          stroke="currentColor"
          strokeWidth="1.2"
        />
        <path
          id="Vector_4"
          d="M21.4219 19.228C23.2682 18.8227 24.5798 17.7975 24.5798 16.5964C24.5798 15.3954 23.2682 14.3701 21.4219 13.9648M4.57977 19.228C2.73345 18.8227 1.42188 17.7975 1.42188 16.5964C1.42188 15.3954 2.73345 14.3701 4.57977 13.9648"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export const CustomersIcon = ({ className }) => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Group">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.49232 1.73214C6.81838 1.73214 5.46139 3.08914 5.46139 4.76307C5.46139 6.43701 6.81838 7.794 8.49232 7.794C10.1663 7.794 11.5233 6.43701 11.5233 4.76307C11.5233 3.08914 10.1663 1.73214 8.49232 1.73214ZM4.0625 4.76307C4.0625 2.31655 6.0458 0.333252 8.49232 0.333252C10.9388 0.333252 12.9221 2.31655 12.9221 4.76307C12.9221 7.2096 10.9388 9.19289 8.49232 9.19289C6.0458 9.19289 4.0625 7.2096 4.0625 4.76307Z"
          fill="currentColor"
        />
        <path
          id="Vector (Stroke)_2"
          d="M16.7616 4.7631C16.7616 6.20031 15.5965 7.36541 14.1593 7.36541C13.3037 7.36541 12.5446 6.95253 12.0702 6.31514L11.1758 7.12226C11.8724 8.00205 12.9499 8.56648 14.1593 8.56648C16.2598 8.56648 17.9627 6.86365 17.9627 4.7631C17.9627 2.66255 16.2598 0.959717 14.1593 0.959717C13.0654 0.959717 12.0794 1.42151 11.3855 2.16078L12.2357 3.01044C12.7116 2.48838 13.3972 2.16078 14.1593 2.16078C15.5965 2.16078 16.7616 3.32588 16.7616 4.7631Z"
          fill="currentColor"
        />
        <path
          id="Vector (Stroke)_3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.55982 13.1301C2.31056 13.8329 1.73105 14.6941 1.73105 15.4879C1.73105 16.7074 1.76864 17.394 2.40587 17.913C2.75143 18.1944 3.32909 18.4691 4.31788 18.6692C5.30358 18.8687 6.65121 18.9851 8.49235 18.9851C10.3335 18.9851 11.6811 18.8687 12.6668 18.6692C13.6556 18.4691 14.2333 18.1944 14.5788 17.913C15.2161 17.394 15.2537 16.7074 15.2537 15.4879C15.2537 14.6941 14.6741 13.8329 13.4249 13.1301C12.1976 12.4398 10.4551 11.9907 8.49235 11.9907C6.52965 11.9907 4.78712 12.4398 3.55982 13.1301ZM2.87399 11.9109C4.34701 11.0823 6.33486 10.5918 8.49235 10.5918C10.6498 10.5918 12.6377 11.0823 14.1107 11.9109C15.5618 12.7271 16.6525 13.9642 16.6525 15.4879C16.6525 15.5193 16.6526 15.551 16.6526 15.583C16.6537 16.6664 16.655 18.0263 15.4622 18.9977C14.8752 19.4757 14.0539 19.8157 12.9444 20.0403C11.8317 20.2655 10.3816 20.384 8.49235 20.384C6.60312 20.384 5.15297 20.2655 4.04033 20.0403C2.93079 19.8157 2.10955 19.4757 1.52252 18.9977C0.329719 18.0263 0.331041 16.6664 0.332095 15.583C0.332126 15.551 0.332156 15.5193 0.332156 15.4879C0.332156 13.9642 1.42292 12.7271 2.87399 11.9109Z"
          fill="currentColor"
        />
        <path
          id="Vector (Stroke)_4"
          d="M19.5917 16.5797C19.3343 16.7893 18.948 16.9953 18.3589 17.1694C17.9885 17.2789 17.7418 17.6429 17.8185 18.0215C17.8951 18.4001 18.2654 18.6487 18.6375 18.5448C19.4112 18.3288 20.015 18.039 20.4751 17.6644C21.6678 16.693 21.6665 15.3331 21.6655 14.2497L21.6654 14.1547C21.6654 12.8466 20.8616 11.7498 19.716 10.9492C19.3994 10.7279 18.9701 10.8506 18.7807 11.1873C18.5913 11.5239 18.7152 11.9456 19.0263 12.1746C19.8701 12.7955 20.2665 13.4982 20.2665 14.1547C20.2665 15.3741 20.2289 16.0607 19.5917 16.5797Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const DashboardIcon = ({ className }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Group 2">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.0263 1.02752C1.47083 0.582988 2.07374 0.333252 2.7024 0.333252H7.44314C8.0718 0.333252 8.67472 0.582988 9.11925 1.02752C9.56378 1.47205 9.81351 2.07496 9.81351 2.70362V8.62955C9.81351 9.25821 9.56378 9.86112 9.11925 10.3057C8.67472 10.7502 8.0718 10.9999 7.44314 10.9999H2.7024C2.07374 10.9999 1.47083 10.7502 1.0263 10.3057C0.581767 9.86112 0.332031 9.25821 0.332031 8.62955V2.70362C0.332031 2.07496 0.581767 1.47205 1.0263 1.02752ZM7.44314 2.70362L2.7024 2.70362L2.7024 8.62955H7.44314V2.70362ZM12.8781 1.02752C13.3227 0.582988 13.9256 0.333252 14.5543 0.333252H19.295C19.9237 0.333252 20.5266 0.582987 20.9711 1.02752C21.4156 1.47205 21.6654 2.07496 21.6654 2.70362V5.07399C21.6654 5.70265 21.4156 6.30556 20.9711 6.7501C20.5266 7.19463 19.9237 7.44436 19.295 7.44436H14.5543C13.9256 7.44436 13.3227 7.19463 12.8781 6.7501C12.4336 6.30557 12.1839 5.70265 12.1839 5.07399V2.70362C12.1839 2.07496 12.4336 1.47205 12.8781 1.02752ZM19.295 2.70362H14.5543V5.07399H19.295V2.70362ZM12.8781 10.509C13.3227 10.0645 13.9256 9.81473 14.5543 9.81473H19.295C19.9237 9.81473 20.5266 10.0645 20.9711 10.509C21.4156 10.9535 21.6654 11.5564 21.6654 12.1851V19.2962C21.6654 19.9249 21.4156 20.5278 20.9711 20.9723C20.5266 21.4169 19.9237 21.6666 19.295 21.6666H14.5543C13.9256 21.6666 13.3227 21.4168 12.8781 20.9723C12.4336 20.5278 12.1839 19.9249 12.1839 19.2962V12.1851C12.1839 11.5564 12.4336 10.9535 12.8781 10.509ZM19.295 12.1851H14.5543V19.2962H19.295V12.1851ZM1.0263 14.0646C1.47083 13.62 2.07374 13.3703 2.7024 13.3703H7.44314C8.0718 13.3703 8.67472 13.62 9.11925 14.0646C9.56378 14.5091 9.81351 15.112 9.81351 15.7407V19.2962C9.81351 19.9249 9.56378 20.5278 9.11925 20.9723C8.67471 21.4168 8.0718 21.6666 7.44314 21.6666H2.7024C2.07374 21.6666 1.47083 21.4168 1.0263 20.9723C0.581766 20.5278 0.332031 19.9249 0.332031 19.2962V15.7407C0.332031 15.112 0.581767 14.5091 1.0263 14.0646ZM7.44314 15.7407H2.7024L2.7024 19.2962H7.44314V15.7407Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const SellTradeIcon = ({ className }) => {
  return (
    <svg
      width="17"
      height="22"
      viewBox="0 0 17 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Group">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4.2121C0 3.141 0.868296 2.27271 1.93939 2.27271H14.5455C15.6166 2.27271 16.4848 3.141 16.4848 4.2121V19.7273C16.4848 20.7983 15.6166 21.6666 14.5455 21.6666H1.93939C0.868296 21.6666 0 20.7983 0 19.7273V4.2121ZM14.5455 4.2121H1.93939V19.7273H14.5455V4.2121Z"
          fill="currentColor"
        />
        <path
          id="Vector (Stroke)_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.33393 0.333252C5.86947 0.333252 6.30362 0.7674 6.30362 1.30295V4.21204C6.30362 4.74759 5.86947 5.18174 5.33393 5.18174C4.79838 5.18174 4.36423 4.74759 4.36423 4.21204V1.30295C4.36423 0.7674 4.79838 0.333252 5.33393 0.333252ZM11.1521 0.333252C11.6877 0.333252 12.1218 0.7674 12.1218 1.30295V4.21204C12.1218 4.74759 11.6877 5.18174 11.1521 5.18174C10.6166 5.18174 10.1824 4.74759 10.1824 4.21204V1.30295C10.1824 0.7674 10.6166 0.333252 11.1521 0.333252ZM3.39453 8.57568C3.39453 8.04013 3.82868 7.60598 4.36423 7.60598H12.1218C12.6574 7.60598 13.0915 8.04013 13.0915 8.57568C13.0915 9.11123 12.6574 9.54537 12.1218 9.54537H4.36423C3.82868 9.54537 3.39453 9.11123 3.39453 8.57568ZM3.39453 12.4545C3.39453 11.9189 3.82868 11.4848 4.36423 11.4848H10.1824C10.718 11.4848 11.1521 11.9189 11.1521 12.4545C11.1521 12.99 10.718 13.4242 10.1824 13.4242H4.36423C3.82868 13.4242 3.39453 12.99 3.39453 12.4545ZM3.39453 16.3333C3.39453 15.7977 3.82868 15.3636 4.36423 15.3636H8.24302C8.77856 15.3636 9.21271 15.7977 9.21271 16.3333C9.21271 16.8688 8.77856 17.3029 8.24302 17.3029H4.36423C3.82868 17.3029 3.39453 16.8688 3.39453 16.3333Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const InventoryIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Group 3">
        <path
          id="Vector"
          d="M2.46536 4.59992H4.5987V5.66658C4.5987 6.83992 5.5587 7.79992 6.73203 7.79992H13.132C14.3054 7.79992 15.2654 6.83992 15.2654 5.66658V4.59992H17.3987V9.93325H19.532V4.59992C19.532 3.42658 18.572 2.46659 17.3987 2.46659H12.94C12.492 1.22925 11.3187 0.333252 9.93203 0.333252C8.54537 0.333252 7.37203 1.22925 6.92403 2.46659H2.46536C1.29203 2.46659 0.332031 3.42658 0.332031 4.59992V19.5333C0.332031 20.7066 1.29203 21.6666 2.46536 21.6666H8.86537V19.5333H2.46536V4.59992ZM9.93203 2.46659C10.5187 2.46659 10.9987 2.94659 10.9987 3.53325C10.9987 4.11992 10.5187 4.59992 9.93203 4.59992C9.34536 4.59992 8.86537 4.11992 8.86537 3.53325C8.86537 2.94659 9.34536 2.46659 9.93203 2.46659Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M20.3306 12.3334C19.8933 11.896 19.1679 11.896 18.7306 12.3334L13.6746 17.4L11.2639 15C10.8266 14.5627 10.1119 14.5627 9.66394 15C9.2266 15.4374 9.2266 16.1627 9.66394 16.6L12.9173 19.8427C13.3333 20.2587 14.0053 20.2587 14.4213 19.8427L20.3199 13.9334C20.7679 13.496 20.7679 12.7707 20.3306 12.3334Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const AnalyticsIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4606_11486)">
        <path
          d="M20.125 19.25H4.375C3.67881 19.25 3.01113 18.9734 2.51884 18.4812C2.02656 17.9889 1.75 17.3212 1.75 16.625V0.875C1.75 0.642936 1.65781 0.420376 1.49372 0.256282C1.32962 0.0921872 1.10706 0 0.875 0C0.642936 0 0.420376 0.0921872 0.256282 0.256282C0.0921872 0.420376 0 0.642936 0 0.875L0 16.625C0.00138938 17.7849 0.462772 18.8969 1.28294 19.7171C2.10311 20.5372 3.2151 20.9986 4.375 21H20.125C20.3571 21 20.5796 20.9078 20.7437 20.7437C20.9078 20.5796 21 20.3571 21 20.125C21 19.8929 20.9078 19.6704 20.7437 19.5063C20.5796 19.3422 20.3571 19.25 20.125 19.25Z"
          fill="currentColor"
        />
        <path
          d="M5.25024 17.5C5.48231 17.5 5.70487 17.4078 5.86896 17.2437C6.03305 17.0796 6.12524 16.8571 6.12524 16.625V10.5C6.12524 10.2679 6.03305 10.0454 5.86896 9.88128C5.70487 9.71719 5.48231 9.625 5.25024 9.625C5.01818 9.625 4.79562 9.71719 4.63153 9.88128C4.46743 10.0454 4.37524 10.2679 4.37524 10.5V16.625C4.37524 16.8571 4.46743 17.0796 4.63153 17.2437C4.79562 17.4078 5.01818 17.5 5.25024 17.5Z"
          fill="currentColor"
        />
        <path
          d="M8.74976 8.75V16.625C8.74976 16.8571 8.84194 17.0796 9.00604 17.2437C9.17013 17.4078 9.3927 17.5 9.62476 17.5C9.85683 17.5 10.0794 17.4078 10.2435 17.2437C10.4076 17.0796 10.4998 16.8571 10.4998 16.625V8.75C10.4998 8.51793 10.4076 8.29538 10.2435 8.13128C10.0794 7.96719 9.85683 7.875 9.62476 7.875C9.3927 7.875 9.17013 7.96719 9.00604 8.13128C8.84194 8.29538 8.74976 8.51793 8.74976 8.75Z"
          fill="currentColor"
        />
        <path
          d="M13.125 11.375V16.625C13.125 16.8571 13.2172 17.0796 13.3813 17.2437C13.5454 17.4078 13.7679 17.5 14 17.5C14.2321 17.5 14.4546 17.4078 14.6187 17.2437C14.7828 17.0796 14.875 16.8571 14.875 16.625V11.375C14.875 11.1429 14.7828 10.9204 14.6187 10.7563C14.4546 10.5922 14.2321 10.5 14 10.5C13.7679 10.5 13.5454 10.5922 13.3813 10.7563C13.2172 10.9204 13.125 11.1429 13.125 11.375Z"
          fill="currentColor"
        />
        <path
          d="M17.5002 7.875V16.625C17.5002 16.8571 17.5924 17.0796 17.7565 17.2437C17.9206 17.4078 18.1432 17.5 18.3752 17.5C18.6073 17.5 18.8299 17.4078 18.994 17.2437C19.1581 17.0796 19.2503 16.8571 19.2503 16.625V7.875C19.2503 7.64294 19.1581 7.42038 18.994 7.25628C18.8299 7.09219 18.6073 7 18.3752 7C18.1432 7 17.9206 7.09219 17.7565 7.25628C17.5924 7.42038 17.5002 7.64294 17.5002 7.875Z"
          fill="currentColor"
        />
        <path
          d="M5.24981 7.87401C5.48186 7.87396 5.70438 7.78174 5.86844 7.61764L9.00619 4.47989C9.17296 4.32101 9.39447 4.23239 9.62481 4.23239C9.85515 4.23239 10.0767 4.32101 10.2434 4.47989L12.1439 6.38039C12.6362 6.8725 13.3038 7.14895 13.9998 7.14895C14.6959 7.14895 15.3634 6.8725 15.8557 6.38039L20.7434 1.49264C20.9028 1.32761 20.991 1.10658 20.989 0.877162C20.987 0.64774 20.895 0.428279 20.7328 0.266047C20.5705 0.103815 20.3511 0.0117923 20.1217 0.0097987C19.8922 0.00780509 19.6712 0.0960002 19.5062 0.255388L14.6184 5.14226C14.4544 5.3063 14.2318 5.39845 13.9998 5.39845C13.7678 5.39845 13.5453 5.3063 13.3812 5.14226L11.4807 3.24264C10.9884 2.75053 10.3209 2.47407 9.62481 2.47407C8.92876 2.47407 8.2612 2.75053 7.76894 3.24264L4.63119 6.38039C4.50886 6.50276 4.42555 6.65865 4.3918 6.82836C4.35806 6.99807 4.37538 7.17397 4.4416 7.33384C4.50781 7.4937 4.61993 7.63034 4.76379 7.72649C4.90765 7.82264 5.07678 7.87398 5.24981 7.87401Z"
          fill="currentColor"
        />
      </g>
      {/* <defs>
        <clipPath id="clip0_4606_11486">
          <rect width="21" height="21" fill="white" />
        </clipPath>
      </defs> */}
    </svg>
  );
};

export const SettingsIcon = ({ className }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Group 16">
        <path
          id="Vector"
          d="M19.1183 11.5806V10.4116L20.5853 9.12795C20.8557 8.8896 21.0332 8.56333 21.0863 8.20679C21.1394 7.85026 21.0648 7.48642 20.8756 7.17958L19.0724 4.12331C18.9385 3.89123 18.7458 3.69847 18.5138 3.56436C18.2818 3.43026 18.0186 3.35952 17.7506 3.35924C17.5845 3.35797 17.4194 3.38378 17.2616 3.43565L15.4049 4.06218C15.0844 3.84917 14.75 3.65773 14.404 3.48913L14.0143 1.56368C13.9444 1.21191 13.7531 0.895918 13.4737 0.671023C13.1943 0.446129 12.8448 0.326661 12.4862 0.333533H8.91035C8.55177 0.326661 8.2022 0.446129 7.92282 0.671023C7.64345 0.895918 7.45208 1.21191 7.38221 1.56368L6.99254 3.48913C6.64407 3.65769 6.30714 3.84912 5.98397 4.06218L4.16549 3.40509C4.00602 3.36354 3.84089 3.34806 3.67648 3.35924C3.4085 3.35952 3.14531 3.43026 2.9133 3.56436C2.6813 3.69847 2.48863 3.89123 2.35465 4.12331L0.551446 7.17958C0.373103 7.48596 0.306831 7.84482 0.363981 8.19469C0.421132 8.54456 0.598148 8.86368 0.864714 9.09739L2.3088 10.4192V11.5883L0.864714 12.8719C0.590619 13.1072 0.40876 13.432 0.351412 13.7887C0.294064 14.1454 0.364934 14.5109 0.551446 14.8203L2.35465 17.8765C2.48863 18.1086 2.6813 18.3014 2.9133 18.4355C3.14531 18.5696 3.4085 18.6403 3.67648 18.6406C3.84255 18.6419 4.00772 18.6161 4.16549 18.5642L6.02217 17.9377C6.34273 18.1507 6.67711 18.3421 7.0231 18.5107L7.41277 20.4362C7.48264 20.7879 7.67402 21.1039 7.95339 21.3288C8.23276 21.5537 8.58233 21.6732 8.94091 21.6663H12.5473C12.9059 21.6732 13.2555 21.5537 13.5348 21.3288C13.8142 21.1039 14.0056 20.7879 14.0754 20.4362L14.4651 18.5107C14.8136 18.3421 15.1505 18.1507 15.4737 17.9377L17.3227 18.5642C17.4805 18.6161 17.6457 18.6419 17.8117 18.6406C18.0797 18.6403 18.3429 18.5696 18.5749 18.4355C18.8069 18.3014 18.9996 18.1086 19.1336 17.8765L20.8756 14.8203C21.054 14.5139 21.1203 14.155 21.0631 13.8051C21.006 13.4553 20.8289 13.1362 20.5624 12.9024L19.1183 11.5806ZM17.7506 17.1125L15.1299 16.2261C14.5164 16.7458 13.8152 17.152 13.0592 17.4257L12.5167 20.1687H8.91035L8.36786 17.4563C7.61787 17.1748 6.9205 16.7693 6.30488 16.2567L3.67648 17.1125L1.87328 14.0562L3.95155 12.2224C3.81027 11.4315 3.81027 10.6218 3.95155 9.83089L1.87328 7.94365L3.67648 4.88738L6.29724 5.77369C6.91073 5.25405 7.61189 4.84784 8.36786 4.57411L8.91035 1.83111H12.5167L13.0592 4.54355C13.8092 4.82505 14.5066 5.23055 15.1222 5.74313L17.7506 4.88738L19.5538 7.94365L17.4755 9.77741C17.6168 10.5683 17.6168 11.378 17.4755 12.1689L19.5538 14.0562L17.7506 17.1125Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M10.7133 15.5843C9.8066 15.5843 8.92026 15.3155 8.16635 14.8117C7.41245 14.308 6.82486 13.592 6.47788 12.7543C6.13089 11.9166 6.04011 10.9948 6.217 10.1056C6.39389 9.21627 6.83051 8.39941 7.47165 7.75827C8.11279 7.11713 8.92965 6.68051 9.81894 6.50362C10.7082 6.32673 11.63 6.41751 12.4677 6.7645C13.3054 7.11148 14.0214 7.69907 14.5251 8.45298C15.0288 9.20688 15.2977 10.0932 15.2977 10.9999C15.3038 11.6037 15.1895 12.2026 14.9612 12.7615C14.733 13.3205 14.3956 13.8283 13.9686 14.2553C13.5417 14.6822 13.0339 15.0196 12.4749 15.2479C11.9159 15.4761 11.3171 15.5905 10.7133 15.5843ZM10.7133 7.94366C10.3094 7.93425 9.90775 8.00688 9.53269 8.15714C9.15763 8.3074 8.81695 8.53218 8.53125 8.81787C8.24555 9.10357 8.02078 9.44425 7.87052 9.81931C7.72026 10.1944 7.64763 10.596 7.65704 10.9999C7.64763 11.4039 7.72026 11.8055 7.87052 12.1806C8.02078 12.5556 8.24555 12.8963 8.53125 13.182C8.81695 13.4677 9.15763 13.6925 9.53269 13.8427C9.90775 13.993 10.3094 14.0656 10.7133 14.0562C11.1172 14.0656 11.5189 13.993 11.8939 13.8427C12.269 13.6925 12.6097 13.4677 12.8954 13.182C13.1811 12.8963 13.4058 12.5556 13.5561 12.1806C13.7064 11.8055 13.779 11.4039 13.7696 10.9999C13.779 10.596 13.7064 10.1944 13.5561 9.81931C13.4058 9.44425 13.1811 9.10357 12.8954 8.81787C12.6097 8.53218 12.269 8.3074 11.8939 8.15714C11.5189 8.00688 11.1172 7.93425 10.7133 7.94366Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const AdminIcon = ({ className }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Group 16">
        <path
          id="Vector"
          d="M19.1183 11.5806V10.4116L20.5853 9.12795C20.8557 8.8896 21.0332 8.56333 21.0863 8.20679C21.1394 7.85026 21.0648 7.48642 20.8756 7.17958L19.0724 4.12331C18.9385 3.89123 18.7458 3.69847 18.5138 3.56436C18.2818 3.43026 18.0186 3.35952 17.7506 3.35924C17.5845 3.35797 17.4194 3.38378 17.2616 3.43565L15.4049 4.06218C15.0844 3.84917 14.75 3.65773 14.404 3.48913L14.0143 1.56368C13.9444 1.21191 13.7531 0.895918 13.4737 0.671023C13.1943 0.446129 12.8448 0.326661 12.4862 0.333533H8.91035C8.55177 0.326661 8.2022 0.446129 7.92282 0.671023C7.64345 0.895918 7.45208 1.21191 7.38221 1.56368L6.99254 3.48913C6.64407 3.65769 6.30714 3.84912 5.98397 4.06218L4.16549 3.40509C4.00602 3.36354 3.84089 3.34806 3.67648 3.35924C3.4085 3.35952 3.14531 3.43026 2.9133 3.56436C2.6813 3.69847 2.48863 3.89123 2.35465 4.12331L0.551446 7.17958C0.373103 7.48596 0.306831 7.84482 0.363981 8.19469C0.421132 8.54456 0.598148 8.86368 0.864714 9.09739L2.3088 10.4192V11.5883L0.864714 12.8719C0.590619 13.1072 0.40876 13.432 0.351412 13.7887C0.294064 14.1454 0.364934 14.5109 0.551446 14.8203L2.35465 17.8765C2.48863 18.1086 2.6813 18.3014 2.9133 18.4355C3.14531 18.5696 3.4085 18.6403 3.67648 18.6406C3.84255 18.6419 4.00772 18.6161 4.16549 18.5642L6.02217 17.9377C6.34273 18.1507 6.67711 18.3421 7.0231 18.5107L7.41277 20.4362C7.48264 20.7879 7.67402 21.1039 7.95339 21.3288C8.23276 21.5537 8.58233 21.6732 8.94091 21.6663H12.5473C12.9059 21.6732 13.2555 21.5537 13.5348 21.3288C13.8142 21.1039 14.0056 20.7879 14.0754 20.4362L14.4651 18.5107C14.8136 18.3421 15.1505 18.1507 15.4737 17.9377L17.3227 18.5642C17.4805 18.6161 17.6457 18.6419 17.8117 18.6406C18.0797 18.6403 18.3429 18.5696 18.5749 18.4355C18.8069 18.3014 18.9996 18.1086 19.1336 17.8765L20.8756 14.8203C21.054 14.5139 21.1203 14.155 21.0631 13.8051C21.006 13.4553 20.8289 13.1362 20.5624 12.9024L19.1183 11.5806ZM17.7506 17.1125L15.1299 16.2261C14.5164 16.7458 13.8152 17.152 13.0592 17.4257L12.5167 20.1687H8.91035L8.36786 17.4563C7.61787 17.1748 6.9205 16.7693 6.30488 16.2567L3.67648 17.1125L1.87328 14.0562L3.95155 12.2224C3.81027 11.4315 3.81027 10.6218 3.95155 9.83089L1.87328 7.94365L3.67648 4.88738L6.29724 5.77369C6.91073 5.25405 7.61189 4.84784 8.36786 4.57411L8.91035 1.83111H12.5167L13.0592 4.54355C13.8092 4.82505 14.5066 5.23055 15.1222 5.74313L17.7506 4.88738L19.5538 7.94365L17.4755 9.77741C17.6168 10.5683 17.6168 11.378 17.4755 12.1689L19.5538 14.0562L17.7506 17.1125Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M10.7133 15.5843C9.8066 15.5843 8.92026 15.3155 8.16635 14.8117C7.41245 14.308 6.82486 13.592 6.47788 12.7543C6.13089 11.9166 6.04011 10.9948 6.217 10.1056C6.39389 9.21627 6.83051 8.39941 7.47165 7.75827C8.11279 7.11713 8.92965 6.68051 9.81894 6.50362C10.7082 6.32673 11.63 6.41751 12.4677 6.7645C13.3054 7.11148 14.0214 7.69907 14.5251 8.45298C15.0288 9.20688 15.2977 10.0932 15.2977 10.9999C15.3038 11.6037 15.1895 12.2026 14.9612 12.7615C14.733 13.3205 14.3956 13.8283 13.9686 14.2553C13.5417 14.6822 13.0339 15.0196 12.4749 15.2479C11.9159 15.4761 11.3171 15.5905 10.7133 15.5843ZM10.7133 7.94366C10.3094 7.93425 9.90775 8.00688 9.53269 8.15714C9.15763 8.3074 8.81695 8.53218 8.53125 8.81787C8.24555 9.10357 8.02078 9.44425 7.87052 9.81931C7.72026 10.1944 7.64763 10.596 7.65704 10.9999C7.64763 11.4039 7.72026 11.8055 7.87052 12.1806C8.02078 12.5556 8.24555 12.8963 8.53125 13.182C8.81695 13.4677 9.15763 13.6925 9.53269 13.8427C9.90775 13.993 10.3094 14.0656 10.7133 14.0562C11.1172 14.0656 11.5189 13.993 11.8939 13.8427C12.269 13.6925 12.6097 13.4677 12.8954 13.182C13.1811 12.8963 13.4058 12.5556 13.5561 12.1806C13.7064 11.8055 13.779 11.4039 13.7696 10.9999C13.779 10.596 13.7064 10.1944 13.5561 9.81931C13.4058 9.44425 13.1811 9.10357 12.8954 8.81787C12.6097 8.53218 12.269 8.3074 11.8939 8.15714C11.5189 8.00688 11.1172 7.93425 10.7133 7.94366Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const ResetCartIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.74142 1.69797C7.11184 1.81194 7.31973 2.20463 7.20576 2.57505L6.94928 3.40859C7.21746 3.32528 7.49226 3.25271 7.76551 3.19059C8.60279 3.00026 9.48408 2.89499 10.2192 2.89499C14.4825 2.89499 17.9384 6.35089 17.9384 10.6142C17.9384 14.8775 14.4825 18.3334 10.2192 18.3334C5.9559 18.3334 2.5 14.8775 2.5 10.6142C2.5 10.2266 2.81418 9.91246 3.20175 9.91246C3.58931 9.91246 3.90349 10.2266 3.90349 10.6142C3.90349 14.1024 6.73103 16.9299 10.2192 16.9299C13.7074 16.9299 16.5349 14.1024 16.5349 10.6142C16.5349 7.12602 13.7074 4.29848 10.2192 4.29848C9.60305 4.29848 8.82677 4.38864 8.07662 4.55917C7.85599 4.60933 7.6425 4.66534 7.43979 4.72628L8.09913 5.08592C8.43937 5.2715 8.56475 5.69777 8.37916 6.03801C8.19357 6.37825 7.76731 6.50362 7.42707 6.31804L5.49726 5.26542C5.2044 5.10567 5.06448 4.76183 5.16258 4.44298L5.86433 2.16231C5.97831 1.79188 6.37099 1.58399 6.74142 1.69797Z"
        fill="currentColor"
      />
    </svg>
  );
};

//------- Share Icon
export const ShareIcon = ({ className }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs></defs>
      <title />
      <g data-name="Layer 51" id="Layer_51">
        <path
          fill="currentColor"
          d="M2,29A1.12,1.12,0,0,1,1.69,29,1,1,0,0,1,1,28V27A19,19,0,0,1,17,8.24V4a1,1,0,0,1,1.6-.8l12,9a1,1,0,0,1,0,1.6l-12,9A1,1,0,0,1,17,22V18.25A18.66,18.66,0,0,0,4.93,25.67L2.81,28.59A1,1,0,0,1,2,29ZM19,6V9.12a1,1,0,0,1-.89,1,17,17,0,0,0-15,14.6l.16-.21A20.68,20.68,0,0,1,17.9,16.11a1,1,0,0,1,.77.26,1,1,0,0,1,.33.74V20l9.33-7Z"
        />
      </g>
    </svg>
  );
};

export const PricechartingIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 668 575"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.4742 430.175C34.626 425.976 37.9183 381.448 67.1454 397.183C202.268 469.926 126.913 456.032 252.848 331.053C260.227 323.729 369.129 191.619 389.807 167.036C413.277 177.018 538.282 237.615 540.576 242.117L542.987 242.119C558.25 209.779 617.132 171.473 603.323 150.228C570.551 99.8088 567.203 82.3232 521.241 31.0656C493.698 0.349415 518.072 13.9175 488.325 5.10443C461.913 -2.72032 429.828 -1.47005 403.588 8.31212C391.251 12.9114 359.774 60.6004 305.082 76.5058C246.456 93.5552 197.606 115.623 142.183 98.1379C135.482 96.024 128.862 97.3688 121.691 97.091C117.897 96.944 103.236 78.3573 46.2688 113.827C11.5875 135.422 9.36966 165.122 5.92727 209.319C1.8314 261.91 -3.51626 317.123 3.16632 369.273C3.17426 369.335 10.8002 424.939 12.4742 430.175Z"
        fill="#0076D4"
        className="shadow-md"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M665.808 408.817C665.808 312.58 675.579 308.176 643.89 232.605C639.202 222.769 632.19 211.242 630.485 200.574C606.682 215.02 563.796 301.845 537.599 289.596C350.464 202.099 444.319 184.021 288.908 352.352C269.574 373.292 170.472 507.506 152.663 497.072C121.924 479.061 88.4174 461.411 56.4743 442.99C25.8322 478.993 7.3363 473.851 49.0891 547.349C100.331 637.55 194.198 479.005 222.47 446.043C257.278 405.462 423.549 351.582 485.978 377.177C542.282 400.262 619.472 448.74 665.808 408.817Z"
        fill="#7CA542"
        className="shadow-md"
      />
    </svg>
  );
};

export const DownloadIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4539_924)">
        <path
          d="M9.87823 18.122C10.1568 18.4008 10.4876 18.6219 10.8517 18.7728C11.2158 18.9237 11.6061 19.0014 12.0002 19.0014C12.3944 19.0014 12.7846 18.9237 13.1487 18.7728C13.5128 18.6219 13.8436 18.4008 14.1222 18.122L17.3332 14.911C17.5054 14.7206 17.5977 14.4713 17.5911 14.2147C17.5846 13.958 17.4795 13.7138 17.2978 13.5325C17.1161 13.3512 16.8716 13.2467 16.615 13.2406C16.3584 13.2346 16.1093 13.3274 15.9192 13.5L12.9932 16.427L13.0002 1C13.0002 0.734784 12.8949 0.48043 12.7073 0.292893C12.5198 0.105357 12.2654 0 12.0002 0V0C11.735 0 11.4807 0.105357 11.2931 0.292893C11.1056 0.48043 11.0002 0.734784 11.0002 1L10.9912 16.408L8.08123 13.5C7.89359 13.3125 7.63914 13.2072 7.37387 13.2073C7.1086 13.2074 6.85423 13.3129 6.66673 13.5005C6.47922 13.6881 6.37393 13.9426 6.37402 14.2079C6.37412 14.4731 6.47959 14.7275 6.66723 14.915L9.87823 18.122Z"
          fill="currentColor"
        />
        <path
          d="M23 16C22.7348 16 22.4804 16.1054 22.2929 16.2929C22.1054 16.4804 22 16.7348 22 17V21C22 21.2652 21.8946 21.5196 21.7071 21.7071C21.5196 21.8946 21.2652 22 21 22H3C2.73478 22 2.48043 21.8946 2.29289 21.7071C2.10536 21.5196 2 21.2652 2 21V17C2 16.7348 1.89464 16.4804 1.70711 16.2929C1.51957 16.1054 1.26522 16 1 16C0.734784 16 0.48043 16.1054 0.292893 16.2929C0.105357 16.4804 0 16.7348 0 17L0 21C0 21.7956 0.31607 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V17C24 16.7348 23.8946 16.4804 23.7071 16.2929C23.5196 16.1054 23.2652 16 23 16Z"
          fill="currentColor"
        />
      </g>
      {/* <defs>
        <clipPath id="clip0_4539_924">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs> */}
    </svg>
  );
};

export const PrintSaleSummaryIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4539_931)">
        <path
          d="M19 6V4C19 2.93913 18.5786 1.92172 17.8284 1.17157C17.0783 0.421427 16.0609 0 15 0L9 0C7.93913 0 6.92172 0.421427 6.17157 1.17157C5.42143 1.92172 5 2.93913 5 4V6C3.67441 6.00159 2.40356 6.52888 1.46622 7.46622C0.528882 8.40356 0.00158786 9.67441 0 11L0 16C0.00158786 17.3256 0.528882 18.5964 1.46622 19.5338C2.40356 20.4711 3.67441 20.9984 5 21C5 21.7956 5.31607 22.5587 5.87868 23.1213C6.44129 23.6839 7.20435 24 8 24H16C16.7956 24 17.5587 23.6839 18.1213 23.1213C18.6839 22.5587 19 21.7956 19 21C20.3256 20.9984 21.5964 20.4711 22.5338 19.5338C23.4711 18.5964 23.9984 17.3256 24 16V11C23.9984 9.67441 23.4711 8.40356 22.5338 7.46622C21.5964 6.52888 20.3256 6.00159 19 6ZM7 4C7 3.46957 7.21071 2.96086 7.58579 2.58579C7.96086 2.21071 8.46957 2 9 2H15C15.5304 2 16.0391 2.21071 16.4142 2.58579C16.7893 2.96086 17 3.46957 17 4V6H7V4ZM17 21C17 21.2652 16.8946 21.5196 16.7071 21.7071C16.5196 21.8946 16.2652 22 16 22H8C7.73478 22 7.48043 21.8946 7.29289 21.7071C7.10536 21.5196 7 21.2652 7 21V17C7 16.7348 7.10536 16.4804 7.29289 16.2929C7.48043 16.1054 7.73478 16 8 16H16C16.2652 16 16.5196 16.1054 16.7071 16.2929C16.8946 16.4804 17 16.7348 17 17V21ZM22 16C22 16.7956 21.6839 17.5587 21.1213 18.1213C20.5587 18.6839 19.7956 19 19 19V17C19 16.2044 18.6839 15.4413 18.1213 14.8787C17.5587 14.3161 16.7956 14 16 14H8C7.20435 14 6.44129 14.3161 5.87868 14.8787C5.31607 15.4413 5 16.2044 5 17V19C4.20435 19 3.44129 18.6839 2.87868 18.1213C2.31607 17.5587 2 16.7956 2 16V11C2 10.2044 2.31607 9.44129 2.87868 8.87868C3.44129 8.31607 4.20435 8 5 8H19C19.7956 8 20.5587 8.31607 21.1213 8.87868C21.6839 9.44129 22 10.2044 22 11V16Z"
          fill="currentColor"
        />
        <path
          d="M18 10H16C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11C15 11.2652 15.1054 11.5196 15.2929 11.7071C15.4804 11.8946 15.7348 12 16 12H18C18.2652 12 18.5196 11.8946 18.7071 11.7071C18.8946 11.5196 19 11.2652 19 11C19 10.7348 18.8946 10.4804 18.7071 10.2929C18.5196 10.1054 18.2652 10 18 10Z"
          fill="currentColor"
        />
      </g>
      {/* <defs>
        <clipPath id="clip0_4539_931">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs> */}
    </svg>
  );
};

export const SaleSummaryIcon = ({ className }) => {
  return (
    <svg
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3651 11.1787C11.3651 11.372 11.2882 11.5574 11.1515 11.6942C11.0148 11.8309 10.8294 11.9077 10.6361 11.9077H4.80405C4.61071 11.9077 4.42529 11.8309 4.28857 11.6942C4.15186 11.5574 4.07505 11.372 4.07505 11.1787C4.07505 10.9853 4.15186 10.7999 4.28857 10.6632C4.42529 10.5265 4.61071 10.4497 4.80405 10.4497H10.6361C10.8294 10.4497 11.0148 10.5265 11.1515 10.6632C11.2882 10.7999 11.3651 10.9853 11.3651 11.1787ZM8.44905 13.3657H4.80405C4.61071 13.3657 4.42529 13.4425 4.28857 13.5792C4.15186 13.7159 4.07505 13.9013 4.07505 14.0947C4.07505 14.288 4.15186 14.4734 4.28857 14.6102C4.42529 14.7469 4.61071 14.8237 4.80405 14.8237H8.44905C8.6424 14.8237 8.82782 14.7469 8.96453 14.6102C9.10125 14.4734 9.17805 14.288 9.17805 14.0947C9.17805 13.9013 9.10125 13.7159 8.96453 13.5792C8.82782 13.4425 8.6424 13.3657 8.44905 13.3657ZM15.0101 8.61624V14.8237C15.0089 15.79 14.6245 16.7165 13.9412 17.3998C13.2579 18.0831 12.3314 18.4675 11.3651 18.4687H4.07505C3.10869 18.4675 2.18225 18.0831 1.49893 17.3998C0.815609 16.7165 0.431211 15.79 0.430054 14.8237V4.61767C0.431211 3.65131 0.815609 2.72487 1.49893 2.04155C2.18225 1.35823 3.10869 0.973831 4.07505 0.972673H7.36649C8.03689 0.970948 8.70098 1.10213 9.32037 1.35865C9.93976 1.61516 10.5022 1.99192 10.975 2.46712L13.5149 5.00842C13.9904 5.48098 14.3673 6.0432 14.624 6.6625C14.8806 7.2818 15.0119 7.94586 15.0101 8.61624V8.61624ZM9.94423 3.49793C9.7148 3.2757 9.45721 3.08453 9.17805 2.92931V6.07567C9.17805 6.26901 9.25486 6.45444 9.39157 6.59115C9.52829 6.72787 9.71371 6.80467 9.90705 6.80467H13.0534C12.8981 6.5256 12.7067 6.26823 12.4841 6.03922L9.94423 3.49793ZM13.5521 8.61624C13.5521 8.49595 13.5287 8.38077 13.5178 8.26267H9.90705C9.32702 8.26267 8.77075 8.03226 8.36061 7.62211C7.95047 7.21197 7.72005 6.6557 7.72005 6.07567V2.46494C7.60195 2.454 7.48604 2.43067 7.36649 2.43067H4.07505C3.49502 2.43067 2.93875 2.66109 2.52861 3.07123C2.11847 3.48137 1.88805 4.03764 1.88805 4.61767V14.8237C1.88805 15.4037 2.11847 15.96 2.52861 16.3701C2.93875 16.7803 3.49502 17.0107 4.07505 17.0107H11.3651C11.9451 17.0107 12.5014 16.7803 12.9115 16.3701C13.3216 15.96 13.5521 15.4037 13.5521 14.8237V8.61624Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const NewEditIcon = ({ className }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.55556 0V1.55556H11.3478L3.70222 9.20111L4.79889 10.2978L12.4444 2.65222V5.44444H14V0H8.55556ZM12.4444 12.4444H1.55556V1.55556H7V0H1.55556C0.692222 0 0 0.7 0 1.55556V12.4444C0 12.857 0.163888 13.2527 0.455612 13.5444C0.747335 13.8361 1.143 14 1.55556 14H12.4444C12.857 14 13.2527 13.8361 13.5444 13.5444C13.8361 13.2527 14 12.857 14 12.4444V7H12.4444V12.4444Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TcgplayerIcon = ({ className }) => {
  return (
    <svg
      className={className}
      enable-background="new 0 0 200 200"
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m0 25h200v150h-200z" />
      </clipPath>
      <g clip-path="url(#a)">
        <path
          d="m10.3 43.5c-6.6 1-11.2 7.1-10.2 13.8l14.1 94.9c1 6.6 7.1 11.2 13.8 10.2l18.2-2.7v-121.6z"
          fill="#ffc412"
        />
        <path
          d="m189.7 43.5-35.5-5.3v121.4l17.8 2.7c6.6 1 12.8-3.6 13.8-10.2l14.1-94.9c.9-6.6-3.6-12.7-10.2-13.7z"
          fill="#df2923"
        />
        <path
          d="m142.1 25.9h-83.8c-6.7 0-12.1 5.4-12.1 12.1v124.1c0 6.7 5.4 12.1 12.1 12.1h83.7c6.7 0 12.1-5.4 12.1-12.1v-124.2c.1-6.6-5.3-12-12-12zm-32.1 41.3h26.9c.9 0 1.2 1.1.5 1.6l-20.9 15.1c-.5.3-.5 1-.1 1.4l10.6 10.8c.4.4.3 1-.1 1.4l-23.9 16.6-1.8 1.2.9 4.5 3 14.6c.2.9-1 1.5-1.6.7l-3.1-3.8-1.1-1.3-19.8-24.2c-.4-.5-.2-1.1.3-1.4l11.6-8.1c.6-.3.7-1 .2-1.4l-29.1-26.2c-.6-.6-.2-1.5.6-1.5z"
          fill="#315ff3"
        />
        <path
          d="m136.9 67.2h-73.8c-.8 0-1.2 1-.6 1.5l29.1 26.3c.5.4.3 1.2-.2 1.4l-11.6 8.1c-.5.3-.7.9-.3 1.4l19.8 24.2 1.1 1.3 3.1 3.8c.6.7 1.8.2 1.6-.7l-3-14.6-.9-4.5 1.8-1.2 23.9-16.6c.5-.3.5-1 .1-1.4l-10.6-10.8c-.4-.4-.3-1 .1-1.4l20.8-15.1c.9-.5.5-1.7-.4-1.7z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const MoreInfoIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.59994 10.7333C2.65434 10.7333 0.266602 8.34561 0.266602 5.40001C0.266602 2.45441 2.65434 0.0666809 5.59994 0.0666809C8.54554 0.0666809 10.9333 2.45441 10.9333 5.40001C10.9333 8.34561 8.54554 10.7333 5.59994 10.7333ZM5.59994 9.66668C6.73153 9.66668 7.81677 9.21716 8.61692 8.417C9.41708 7.61685 9.8666 6.5316 9.8666 5.40001C9.8666 4.26842 9.41708 3.18318 8.61692 2.38303C7.81677 1.58287 6.73153 1.13335 5.59994 1.13335C4.46834 1.13335 3.3831 1.58287 2.58295 2.38303C1.78279 3.18318 1.33327 4.26842 1.33327 5.40001C1.33327 6.5316 1.78279 7.61685 2.58295 8.417C3.3831 9.21716 4.46834 9.66668 5.59994 9.66668ZM5.0666 7.00001H6.13327V8.06668H5.0666V7.00001ZM6.13327 6.12268V6.46668H5.0666V5.66668C5.0666 5.52523 5.12279 5.38958 5.22281 5.28956C5.32283 5.18954 5.45849 5.13335 5.59994 5.13335C5.75144 5.13334 5.89983 5.09031 6.02784 5.00926C6.15585 4.92821 6.25821 4.81248 6.32301 4.67553C6.38782 4.53858 6.4124 4.38604 6.3939 4.23566C6.3754 4.08529 6.31458 3.94326 6.21851 3.8261C6.12245 3.70894 5.99509 3.62147 5.85125 3.57386C5.70742 3.52626 5.55302 3.52048 5.40603 3.55719C5.25904 3.5939 5.12549 3.6716 5.02093 3.78125C4.91637 3.8909 4.8451 4.02798 4.8154 4.17655L3.769 3.96695C3.83387 3.64273 3.98367 3.34155 4.20309 3.09419C4.42251 2.84684 4.70368 2.66219 5.01785 2.55912C5.33202 2.45605 5.66793 2.43825 5.99123 2.50754C6.31454 2.57684 6.61364 2.73074 6.85797 2.95352C7.1023 3.1763 7.28309 3.45996 7.38186 3.77551C7.48063 4.09107 7.49384 4.42718 7.42013 4.74951C7.34642 5.07184 7.18844 5.36881 6.96235 5.61008C6.73625 5.85134 6.45014 6.02823 6.13327 6.12268Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ShopifySingleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="24px"
      height="24px"
    >
      <path
        fill="#7cb342"
        d="M37.216,11.78c-0.023-0.211-0.211-0.305-0.351-0.305s-3.21-0.234-3.21-0.234s-2.132-2.132-2.39-2.343	c-0.234-0.234-0.68-0.164-0.867-0.117c-0.023,0-0.469,0.141-1.195,0.375c-0.726-2.086-1.968-3.984-4.194-3.984h-0.211	C24.187,4.375,23.391,4,22.735,4c-5.155,0-7.639,6.444-8.412,9.725c-2.015,0.633-3.445,1.054-3.609,1.125	c-1.125,0.351-1.148,0.375-1.289,1.429c-0.117,0.797-3.046,23.456-3.046,23.456L29.179,44l12.373-2.671	C41.575,41.282,37.24,11.991,37.216,11.78z M27.937,9.483c-0.562,0.164-1.242,0.375-1.921,0.609V9.671	c0-1.265-0.164-2.296-0.469-3.117C26.718,6.695,27.445,7.984,27.937,9.483L27.937,9.483z M24.117,6.812	c0.305,0.797,0.516,1.922,0.516,3.468v0.234c-1.265,0.398-2.601,0.797-3.984,1.242C21.422,8.804,22.899,7.351,24.117,6.812	L24.117,6.812z M22.617,5.359c0.234,0,0.469,0.094,0.656,0.234c-1.664,0.773-3.421,2.718-4.148,6.655	c-1.101,0.351-2.156,0.656-3.163,0.984C16.806,10.233,18.915,5.359,22.617,5.359z"
      />
      <path
        fill="#558b2f"
        d="M36.865,11.428c-0.141,0-3.21-0.234-3.21-0.234s-2.132-2.132-2.39-2.343	C31.17,8.757,31.053,8.71,30.96,8.71L29.249,44l12.373-2.671c0,0-4.335-29.338-4.359-29.549	C37.169,11.569,37.005,11.475,36.865,11.428z"
      />
      <path
        fill="#fff"
        d="M24.792,18.593l-1.475,4.449c0,0-1.337-0.715-2.927-0.715c-2.374,0-2.489,1.498-2.489,1.867	c0,2.028,5.301,2.812,5.301,7.583c0,3.757-2.374,6.177-5.578,6.177c-3.872,0-5.808-2.397-5.808-2.397l1.037-3.411	c0,0,2.028,1.752,3.734,1.752c1.129,0,1.59-0.876,1.59-1.521c0-2.651-4.333-2.766-4.333-7.145c0-3.665,2.628-7.214,7.952-7.214	C23.777,17.994,24.792,18.593,24.792,18.593z"
      />
    </svg>
  );
};
